module.exports = /******/function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/
  var installedModules = {};
  /******/
  /******/ // The require function
  /******/
  function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/if (installedModules[moduleId]) {
      /******/return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/
    var module = installedModules[moduleId] = {
      /******/i: moduleId,
      /******/l: false,
      /******/exports: {}
      /******/
    };
    /******/
    /******/ // Execute the module function
    /******/
    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ // Flag the module as loaded
    /******/
    module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/
    return module.exports;
    /******/
  }
  /******/
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/
  __webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/
  __webpack_require__.c = installedModules;
  /******/
  /******/ // define getter function for harmony exports
  /******/
  __webpack_require__.d = function (exports, name, getter) {
    /******/if (!__webpack_require__.o(exports, name)) {
      /******/Object.defineProperty(exports, name, {
        /******/configurable: false,
        /******/enumerable: true,
        /******/get: getter
        /******/
      });
      /******/
    }
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/
  __webpack_require__.n = function (module) {
    /******/var getter = module && module.__esModule ? /******/function getDefault() {
      return module['default'];
    } : /******/function getModuleExports() {
      return module;
    };
    /******/
    __webpack_require__.d(getter, 'a', getter);
    /******/
    return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/
  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/
  __webpack_require__.p = "/";
  /******/
  /******/ // Load entry module and return exports
  /******/
  return __webpack_require__(__webpack_require__.s = 71);
  /******/
}
/************************************************************************/
/******/([( /* 0 */
/***/function (module, exports) {
  // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
  module.exports = typeof window == 'object' && window && window.Math == Math ? window : typeof self == 'object' && self && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();

  /***/
}), ( /* 1 */
/***/function (module, exports, __webpack_require__) {
  var store = __webpack_require__(20)('wks');
  var uid = __webpack_require__(56);
  var Symbol = __webpack_require__(0).Symbol;
  var NATIVE_SYMBOL = __webpack_require__(113);
  module.exports = function (name) {
    return store[name] || (store[name] = NATIVE_SYMBOL && Symbol[name] || (NATIVE_SYMBOL ? Symbol : uid)('Symbol.' + name));
  };

  /***/
}), ( /* 2 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  Object.defineProperty(__webpack_exports__, "__esModule", {
    value: true
  });
  /* WEBPACK VAR INJECTION */
  (function (process) {
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "version", function () {
      return version;
    });
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "DOM", function () {
      return DOM;
    });
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "Children", function () {
      return Children;
    });
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "render", function () {
      return render$1;
    });
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "createClass", function () {
      return createClass;
    });
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "createPortal", function () {
      return createPortal;
    });
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "createFactory", function () {
      return createFactory;
    });
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "createElement", function () {
      return createElement;
    });
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "cloneElement", function () {
      return cloneElement$1;
    });
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "isValidElement", function () {
      return isValidElement;
    });
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "findDOMNode", function () {
      return findDOMNode;
    });
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "unmountComponentAtNode", function () {
      return unmountComponentAtNode;
    });
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "Component", function () {
      return Component$1;
    });
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "PureComponent", function () {
      return PureComponent;
    });
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "unstable_renderSubtreeIntoContainer", function () {
      return renderSubtreeIntoContainer;
    });
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "unstable_batchedUpdates", function () {
      return unstable_batchedUpdates;
    });
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "__spread", function () {
      return extend;
    });
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(4);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
    /* harmony reexport (default from non-hamory) */
    __webpack_require__.d(__webpack_exports__, "PropTypes", function () {
      return __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a;
    });
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_1_preact__ = __webpack_require__(79);
    var version = '15.1.0'; // trick libraries to think we are react

    var ELEMENTS = 'a abbr address area article aside audio b base bdi bdo big blockquote body br button canvas caption cite code col colgroup data datalist dd del details dfn dialog div dl dt em embed fieldset figcaption figure footer form h1 h2 h3 h4 h5 h6 head header hgroup hr html i iframe img input ins kbd keygen label legend li link main map mark menu menuitem meta meter nav noscript object ol optgroup option output p param picture pre progress q rp rt ruby s samp script section select small source span strong style sub summary sup table tbody td textarea tfoot th thead time title tr track u ul var video wbr circle clipPath defs ellipse g image line linearGradient mask path pattern polygon polyline radialGradient rect stop svg text tspan'.split(' ');
    var REACT_ELEMENT_TYPE = typeof Symbol !== 'undefined' && Symbol.for && Symbol.for('react.element') || 0xeac7;
    var COMPONENT_WRAPPER_KEY = typeof Symbol !== 'undefined' && Symbol.for ? Symbol.for('__preactCompatWrapper') : '__preactCompatWrapper';

    // don't autobind these methods since they already have guaranteed context.
    var AUTOBIND_BLACKLIST = {
      constructor: 1,
      render: 1,
      shouldComponentUpdate: 1,
      componentWillReceiveProps: 1,
      componentWillUpdate: 1,
      componentDidUpdate: 1,
      componentWillMount: 1,
      componentDidMount: 1,
      componentWillUnmount: 1,
      componentDidUnmount: 1
    };
    var CAMEL_PROPS = /^(?:accent|alignment|arabic|baseline|cap|clip|color|fill|flood|font|glyph|horiz|marker|overline|paint|stop|strikethrough|stroke|text|underline|unicode|units|v|vector|vert|word|writing|x)[A-Z]/;
    var BYPASS_HOOK = {};

    /*global process*/
    var DEV = false;
    try {
      DEV = process.env.NODE_ENV !== 'production';
    } catch (e) {}

    // a component that renders nothing. Used to replace components for unmountComponentAtNode.
    function EmptyComponent() {
      return null;
    }

    // make react think we're react.
    var VNode = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["c" /* h */])('a', null).constructor;
    VNode.prototype.$$typeof = REACT_ELEMENT_TYPE;
    VNode.prototype.preactCompatUpgraded = false;
    VNode.prototype.preactCompatNormalized = false;
    Object.defineProperty(VNode.prototype, 'type', {
      get: function () {
        return this.nodeName;
      },
      set: function (v) {
        this.nodeName = v;
      },
      configurable: true
    });
    Object.defineProperty(VNode.prototype, 'props', {
      get: function () {
        return this.attributes;
      },
      set: function (v) {
        this.attributes = v;
      },
      configurable: true
    });
    var oldEventHook = __WEBPACK_IMPORTED_MODULE_1_preact__["d" /* options */].event;
    __WEBPACK_IMPORTED_MODULE_1_preact__["d" /* options */].event = function (e) {
      if (oldEventHook) {
        e = oldEventHook(e);
      }
      e.persist = Object;
      e.nativeEvent = e;
      return e;
    };
    var oldVnodeHook = __WEBPACK_IMPORTED_MODULE_1_preact__["d" /* options */].vnode;
    __WEBPACK_IMPORTED_MODULE_1_preact__["d" /* options */].vnode = function (vnode) {
      if (!vnode.preactCompatUpgraded) {
        vnode.preactCompatUpgraded = true;
        var tag = vnode.nodeName,
          attrs = vnode.attributes = vnode.attributes == null ? {} : extend({}, vnode.attributes);
        if (typeof tag === 'function') {
          if (tag[COMPONENT_WRAPPER_KEY] === true || tag.prototype && 'isReactComponent' in tag.prototype) {
            if (vnode.children && String(vnode.children) === '') {
              vnode.children = undefined;
            }
            if (vnode.children) {
              attrs.children = vnode.children;
            }
            if (!vnode.preactCompatNormalized) {
              normalizeVNode(vnode);
            }
            handleComponentVNode(vnode);
          }
        } else {
          if (vnode.children && String(vnode.children) === '') {
            vnode.children = undefined;
          }
          if (vnode.children) {
            attrs.children = vnode.children;
          }
          if (attrs.defaultValue) {
            if (!attrs.value && attrs.value !== 0) {
              attrs.value = attrs.defaultValue;
            }
            delete attrs.defaultValue;
          }
          handleElementVNode(vnode, attrs);
        }
      }
      if (oldVnodeHook) {
        oldVnodeHook(vnode);
      }
    };
    function handleComponentVNode(vnode) {
      var tag = vnode.nodeName,
        a = vnode.attributes;
      vnode.attributes = {};
      if (tag.defaultProps) {
        extend(vnode.attributes, tag.defaultProps);
      }
      if (a) {
        extend(vnode.attributes, a);
      }
    }
    function handleElementVNode(vnode, a) {
      var shouldSanitize, attrs, i;
      if (a) {
        for (i in a) {
          if (shouldSanitize = CAMEL_PROPS.test(i)) {
            break;
          }
        }
        if (shouldSanitize) {
          attrs = vnode.attributes = {};
          for (i in a) {
            if (a.hasOwnProperty(i)) {
              attrs[CAMEL_PROPS.test(i) ? i.replace(/([A-Z0-9])/, '-$1').toLowerCase() : i] = a[i];
            }
          }
        }
      }
    }

    // proxy render() since React returns a Component reference.
    function render$1(vnode, parent, callback) {
      var prev = parent && parent._preactCompatRendered && parent._preactCompatRendered.base;

      // ignore impossible previous renders
      if (prev && prev.parentNode !== parent) {
        prev = null;
      }

      // default to first Element child
      if (!prev && parent) {
        prev = parent.firstElementChild;
      }

      // remove unaffected siblings
      for (var i = parent.childNodes.length; i--;) {
        if (parent.childNodes[i] !== prev) {
          parent.removeChild(parent.childNodes[i]);
        }
      }
      var out = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["e" /* render */])(vnode, parent, prev);
      if (parent) {
        parent._preactCompatRendered = out && (out._component || {
          base: out
        });
      }
      if (typeof callback === 'function') {
        callback();
      }
      return out && out._component || out;
    }
    var ContextProvider = function () {};
    ContextProvider.prototype.getChildContext = function () {
      return this.props.context;
    };
    ContextProvider.prototype.render = function (props) {
      return props.children[0];
    };
    function renderSubtreeIntoContainer(parentComponent, vnode, container, callback) {
      var wrap = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["c" /* h */])(ContextProvider, {
        context: parentComponent.context
      }, vnode);
      var renderContainer = render$1(wrap, container);
      var component = renderContainer._component || renderContainer.base;
      if (callback) {
        callback.call(component, renderContainer);
      }
      return component;
    }
    function Portal(props) {
      renderSubtreeIntoContainer(this, props.vnode, props.container);
    }
    function createPortal(vnode, container) {
      return Object(__WEBPACK_IMPORTED_MODULE_1_preact__["c" /* h */])(Portal, {
        vnode: vnode,
        container: container
      });
    }
    function unmountComponentAtNode(container) {
      var existing = container._preactCompatRendered && container._preactCompatRendered.base;
      if (existing && existing.parentNode === container) {
        Object(__WEBPACK_IMPORTED_MODULE_1_preact__["e" /* render */])(Object(__WEBPACK_IMPORTED_MODULE_1_preact__["c" /* h */])(EmptyComponent), container, existing);
        return true;
      }
      return false;
    }
    var ARR = [];

    // This API is completely unnecessary for Preact, so it's basically passthrough.
    var Children = {
      map: function (children, fn, ctx) {
        if (children == null) {
          return null;
        }
        children = Children.toArray(children);
        if (ctx && ctx !== children) {
          fn = fn.bind(ctx);
        }
        return children.map(fn);
      },
      forEach: function (children, fn, ctx) {
        if (children == null) {
          return null;
        }
        children = Children.toArray(children);
        if (ctx && ctx !== children) {
          fn = fn.bind(ctx);
        }
        children.forEach(fn);
      },
      count: function (children) {
        return children && children.length || 0;
      },
      only: function (children) {
        children = Children.toArray(children);
        if (children.length !== 1) {
          throw new Error('Children.only() expects only one child.');
        }
        return children[0];
      },
      toArray: function (children) {
        if (children == null) {
          return [];
        }
        return ARR.concat(children);
      }
    };

    /** Track current render() component for ref assignment */
    var currentComponent;
    function createFactory(type) {
      return createElement.bind(null, type);
    }
    var DOM = {};
    for (var i = ELEMENTS.length; i--;) {
      DOM[ELEMENTS[i]] = createFactory(ELEMENTS[i]);
    }
    function upgradeToVNodes(arr, offset) {
      for (var i = offset || 0; i < arr.length; i++) {
        var obj = arr[i];
        if (Array.isArray(obj)) {
          upgradeToVNodes(obj);
        } else if (obj && typeof obj === 'object' && !isValidElement(obj) && (obj.props && obj.type || obj.attributes && obj.nodeName || obj.children)) {
          arr[i] = createElement(obj.type || obj.nodeName, obj.props || obj.attributes, obj.children);
        }
      }
    }
    function isStatelessComponent(c) {
      return typeof c === 'function' && !(c.prototype && c.prototype.render);
    }

    // wraps stateless functional components in a PropTypes validator
    function wrapStatelessComponent(WrappedComponent) {
      return createClass({
        displayName: WrappedComponent.displayName || WrappedComponent.name,
        render: function () {
          return WrappedComponent(this.props, this.context);
        }
      });
    }
    function statelessComponentHook(Ctor) {
      var Wrapped = Ctor[COMPONENT_WRAPPER_KEY];
      if (Wrapped) {
        return Wrapped === true ? Ctor : Wrapped;
      }
      Wrapped = wrapStatelessComponent(Ctor);
      Object.defineProperty(Wrapped, COMPONENT_WRAPPER_KEY, {
        configurable: true,
        value: true
      });
      Wrapped.displayName = Ctor.displayName;
      Wrapped.propTypes = Ctor.propTypes;
      Wrapped.defaultProps = Ctor.defaultProps;
      Object.defineProperty(Ctor, COMPONENT_WRAPPER_KEY, {
        configurable: true,
        value: Wrapped
      });
      return Wrapped;
    }
    function createElement() {
      var args = [],
        len = arguments.length;
      while (len--) args[len] = arguments[len];
      upgradeToVNodes(args, 2);
      return normalizeVNode(__WEBPACK_IMPORTED_MODULE_1_preact__["c" /* h */].apply(void 0, args));
    }
    function normalizeVNode(vnode) {
      vnode.preactCompatNormalized = true;
      applyClassName(vnode);
      if (isStatelessComponent(vnode.nodeName)) {
        vnode.nodeName = statelessComponentHook(vnode.nodeName);
      }
      var ref = vnode.attributes.ref,
        type = ref && typeof ref;
      if (currentComponent && (type === 'string' || type === 'number')) {
        vnode.attributes.ref = createStringRefProxy(ref, currentComponent);
      }
      applyEventNormalization(vnode);
      return vnode;
    }
    function cloneElement$1(element, props) {
      var children = [],
        len = arguments.length - 2;
      while (len-- > 0) children[len] = arguments[len + 2];
      if (!isValidElement(element)) {
        return element;
      }
      var elementProps = element.attributes || element.props;
      var node = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["c" /* h */])(element.nodeName || element.type, extend({}, elementProps), element.children || elementProps && elementProps.children);
      // Only provide the 3rd argument if needed.
      // Arguments 3+ overwrite element.children in preactCloneElement
      var cloneArgs = [node, props];
      if (children && children.length) {
        cloneArgs.push(children);
      } else if (props && props.children) {
        cloneArgs.push(props.children);
      }
      return normalizeVNode(__WEBPACK_IMPORTED_MODULE_1_preact__["b" /* cloneElement */].apply(void 0, cloneArgs));
    }
    function isValidElement(element) {
      return element && (element instanceof VNode || element.$$typeof === REACT_ELEMENT_TYPE);
    }
    function createStringRefProxy(name, component) {
      return component._refProxies[name] || (component._refProxies[name] = function (resolved) {
        if (component && component.refs) {
          component.refs[name] = resolved;
          if (resolved === null) {
            delete component._refProxies[name];
            component = null;
          }
        }
      });
    }
    function applyEventNormalization(ref) {
      var nodeName = ref.nodeName;
      var attributes = ref.attributes;
      if (!attributes || typeof nodeName !== 'string') {
        return;
      }
      var props = {};
      for (var i in attributes) {
        props[i.toLowerCase()] = i;
      }
      if (props.ondoubleclick) {
        attributes.ondblclick = attributes[props.ondoubleclick];
        delete attributes[props.ondoubleclick];
      }
      // for *textual inputs* (incl textarea), normalize `onChange` -> `onInput`:
      if (props.onchange && (nodeName === 'textarea' || nodeName.toLowerCase() === 'input' && !/^fil|che|rad/i.test(attributes.type))) {
        var normalized = props.oninput || 'oninput';
        if (!attributes[normalized]) {
          attributes[normalized] = multihook([attributes[normalized], attributes[props.onchange]]);
          delete attributes[props.onchange];
        }
      }
    }
    function applyClassName(vnode) {
      var a = vnode.attributes || (vnode.attributes = {});
      classNameDescriptor.enumerable = 'className' in a;
      if (a.className) {
        a.class = a.className;
      }
      Object.defineProperty(a, 'className', classNameDescriptor);
    }
    var classNameDescriptor = {
      configurable: true,
      get: function () {
        return this.class;
      },
      set: function (v) {
        this.class = v;
      }
    };
    function extend(base, props) {
      var arguments$1 = arguments;
      for (var i = 1, obj = void 0; i < arguments.length; i++) {
        if (obj = arguments$1[i]) {
          for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
              base[key] = obj[key];
            }
          }
        }
      }
      return base;
    }
    function shallowDiffers(a, b) {
      for (var i in a) {
        if (!(i in b)) {
          return true;
        }
      }
      for (var i$1 in b) {
        if (a[i$1] !== b[i$1]) {
          return true;
        }
      }
      return false;
    }
    function findDOMNode(component) {
      return component && (component.base || component.nodeType === 1 && component) || null;
    }
    function F() {}
    function createClass(obj) {
      function cl(props, context) {
        bindAll(this);
        Component$1.call(this, props, context, BYPASS_HOOK);
        newComponentHook.call(this, props, context);
      }
      obj = extend({
        constructor: cl
      }, obj);

      // We need to apply mixins here so that getDefaultProps is correctly mixed
      if (obj.mixins) {
        applyMixins(obj, collateMixins(obj.mixins));
      }
      if (obj.statics) {
        extend(cl, obj.statics);
      }
      if (obj.propTypes) {
        cl.propTypes = obj.propTypes;
      }
      if (obj.defaultProps) {
        cl.defaultProps = obj.defaultProps;
      }
      if (obj.getDefaultProps) {
        cl.defaultProps = obj.getDefaultProps.call(cl);
      }
      F.prototype = Component$1.prototype;
      cl.prototype = extend(new F(), obj);
      cl.displayName = obj.displayName || 'Component';
      return cl;
    }

    // Flatten an Array of mixins to a map of method name to mixin implementations
    function collateMixins(mixins) {
      var keyed = {};
      for (var i = 0; i < mixins.length; i++) {
        var mixin = mixins[i];
        for (var key in mixin) {
          if (mixin.hasOwnProperty(key) && typeof mixin[key] === 'function') {
            (keyed[key] || (keyed[key] = [])).push(mixin[key]);
          }
        }
      }
      return keyed;
    }

    // apply a mapping of Arrays of mixin methods to a component prototype
    function applyMixins(proto, mixins) {
      for (var key in mixins) {
        if (mixins.hasOwnProperty(key)) {
          proto[key] = multihook(mixins[key].concat(proto[key] || ARR), key === 'getDefaultProps' || key === 'getInitialState' || key === 'getChildContext');
        }
      }
    }
    function bindAll(ctx) {
      for (var i in ctx) {
        var v = ctx[i];
        if (typeof v === 'function' && !v.__bound && !AUTOBIND_BLACKLIST.hasOwnProperty(i)) {
          (ctx[i] = v.bind(ctx)).__bound = true;
        }
      }
    }
    function callMethod(ctx, m, args) {
      if (typeof m === 'string') {
        m = ctx.constructor.prototype[m];
      }
      if (typeof m === 'function') {
        return m.apply(ctx, args);
      }
    }
    function multihook(hooks, skipDuplicates) {
      return function () {
        var arguments$1 = arguments;
        var this$1 = this;
        var ret;
        for (var i = 0; i < hooks.length; i++) {
          var r = callMethod(this$1, hooks[i], arguments$1);
          if (skipDuplicates && r != null) {
            if (!ret) {
              ret = {};
            }
            for (var key in r) {
              if (r.hasOwnProperty(key)) {
                ret[key] = r[key];
              }
            }
          } else if (typeof r !== 'undefined') {
            ret = r;
          }
        }
        return ret;
      };
    }
    function newComponentHook(props, context) {
      propsHook.call(this, props, context);
      this.componentWillReceiveProps = multihook([propsHook, this.componentWillReceiveProps || 'componentWillReceiveProps']);
      this.render = multihook([propsHook, beforeRender, this.render || 'render', afterRender]);
    }
    function propsHook(props, context) {
      if (!props) {
        return;
      }

      // React annoyingly special-cases single children, and some react components are ridiculously strict about this.
      var c = props.children;
      if (c && Array.isArray(c) && c.length === 1 && (typeof c[0] === 'string' || typeof c[0] === 'function' || c[0] instanceof VNode)) {
        props.children = c[0];

        // but its totally still going to be an Array.
        if (props.children && typeof props.children === 'object') {
          props.children.length = 1;
          props.children[0] = props.children;
        }
      }

      // add proptype checking
      if (DEV) {
        var ctor = typeof this === 'function' ? this : this.constructor,
          propTypes = this.propTypes || ctor.propTypes;
        var displayName = this.displayName || ctor.name;
        if (propTypes) {
          __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.checkPropTypes(propTypes, props, 'prop', displayName);
        }
      }
    }
    function beforeRender(props) {
      currentComponent = this;
    }
    function afterRender() {
      if (currentComponent === this) {
        currentComponent = null;
      }
    }
    function Component$1(props, context, opts) {
      __WEBPACK_IMPORTED_MODULE_1_preact__["a" /* Component */].call(this, props, context);
      this.state = this.getInitialState ? this.getInitialState() : {};
      this.refs = {};
      this._refProxies = {};
      if (opts !== BYPASS_HOOK) {
        newComponentHook.call(this, props, context);
      }
    }
    extend(Component$1.prototype = new __WEBPACK_IMPORTED_MODULE_1_preact__["a" /* Component */](), {
      constructor: Component$1,
      isReactComponent: {},
      replaceState: function (state, callback) {
        var this$1 = this;
        this.setState(state, callback);
        for (var i in this$1.state) {
          if (!(i in state)) {
            delete this$1.state[i];
          }
        }
      },
      getDOMNode: function () {
        return this.base;
      },
      isMounted: function () {
        return !!this.base;
      }
    });
    function PureComponent(props, context) {
      Component$1.call(this, props, context);
    }
    F.prototype = Component$1.prototype;
    PureComponent.prototype = new F();
    PureComponent.prototype.isPureReactComponent = true;
    PureComponent.prototype.shouldComponentUpdate = function (props, state) {
      return shallowDiffers(this.props, props) || shallowDiffers(this.state, state);
    };
    function unstable_batchedUpdates(callback) {
      callback();
    }
    var index = {
      version: version,
      DOM: DOM,
      PropTypes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a,
      Children: Children,
      render: render$1,
      createClass: createClass,
      createPortal: createPortal,
      createFactory: createFactory,
      createElement: createElement,
      cloneElement: cloneElement$1,
      isValidElement: isValidElement,
      findDOMNode: findDOMNode,
      unmountComponentAtNode: unmountComponentAtNode,
      Component: Component$1,
      PureComponent: PureComponent,
      unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer,
      unstable_batchedUpdates: unstable_batchedUpdates,
      __spread: extend
    };

    /* harmony default export */
    __webpack_exports__["default"] = index;

    /* WEBPACK VAR INJECTION */
  }).call(__webpack_exports__, __webpack_require__(3));

  /***/
}), ( /* 3 */
/***/function (module, exports) {
  // shim for using process in browser
  var process = module.exports = {};

  // cached from whatever global is present so that test runners that stub it
  // don't break things.  But we need to wrap it in a try catch in case it is
  // wrapped in strict mode code which doesn't define any globals.  It's inside a
  // function because try/catches deoptimize in certain engines.

  var cachedSetTimeout;
  var cachedClearTimeout;
  function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
  }
  function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
  }
  (function () {
    try {
      if (typeof setTimeout === 'function') {
        cachedSetTimeout = setTimeout;
      } else {
        cachedSetTimeout = defaultSetTimout;
      }
    } catch (e) {
      cachedSetTimeout = defaultSetTimout;
    }
    try {
      if (typeof clearTimeout === 'function') {
        cachedClearTimeout = clearTimeout;
      } else {
        cachedClearTimeout = defaultClearTimeout;
      }
    } catch (e) {
      cachedClearTimeout = defaultClearTimeout;
    }
  })();
  function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
      //normal enviroments in sane situations
      return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
      cachedSetTimeout = setTimeout;
      return setTimeout(fun, 0);
    }
    try {
      // when when somebody has screwed with setTimeout but no I.E. maddness
      return cachedSetTimeout(fun, 0);
    } catch (e) {
      try {
        // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
        return cachedSetTimeout.call(null, fun, 0);
      } catch (e) {
        // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
        return cachedSetTimeout.call(this, fun, 0);
      }
    }
  }
  function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
      //normal enviroments in sane situations
      return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
      cachedClearTimeout = clearTimeout;
      return clearTimeout(marker);
    }
    try {
      // when when somebody has screwed with setTimeout but no I.E. maddness
      return cachedClearTimeout(marker);
    } catch (e) {
      try {
        // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
        return cachedClearTimeout.call(null, marker);
      } catch (e) {
        // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
        // Some versions of I.E. have different rules for clearTimeout vs setTimeout
        return cachedClearTimeout.call(this, marker);
      }
    }
  }
  var queue = [];
  var draining = false;
  var currentQueue;
  var queueIndex = -1;
  function cleanUpNextTick() {
    if (!draining || !currentQueue) {
      return;
    }
    draining = false;
    if (currentQueue.length) {
      queue = currentQueue.concat(queue);
    } else {
      queueIndex = -1;
    }
    if (queue.length) {
      drainQueue();
    }
  }
  function drainQueue() {
    if (draining) {
      return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while (len) {
      currentQueue = queue;
      queue = [];
      while (++queueIndex < len) {
        if (currentQueue) {
          currentQueue[queueIndex].run();
        }
      }
      queueIndex = -1;
      len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
  }
  process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
      for (var i = 1; i < arguments.length; i++) {
        args[i - 1] = arguments[i];
      }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
      runTimeout(drainQueue);
    }
  };

  // v8 likes predictible objects
  function Item(fun, array) {
    this.fun = fun;
    this.array = array;
  }
  Item.prototype.run = function () {
    this.fun.apply(null, this.array);
  };
  process.title = 'browser';
  process.browser = true;
  process.env = {};
  process.argv = [];
  process.version = ''; // empty string to avoid regexp issues
  process.versions = {};
  function noop() {}
  process.on = noop;
  process.addListener = noop;
  process.once = noop;
  process.off = noop;
  process.removeListener = noop;
  process.removeAllListeners = noop;
  process.emit = noop;
  process.prependListener = noop;
  process.prependOnceListener = noop;
  process.listeners = function (name) {
    return [];
  };
  process.binding = function (name) {
    throw new Error('process.binding is not supported');
  };
  process.cwd = function () {
    return '/';
  };
  process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
  };
  process.umask = function () {
    return 0;
  };

  /***/
}), ( /* 4 */
/***/function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */(function (process) {
    /**
    * Copyright (c) 2013-present, Facebook, Inc.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    */

    if (process.env.NODE_ENV !== 'production') {
      var ReactIs = __webpack_require__(42);

      // By explicitly using `prop-types` you are opting into new development behavior.
      // http://fb.me/prop-types-in-prod
      var throwOnDirectAccess = true;
      module.exports = __webpack_require__(75)(ReactIs.isElement, throwOnDirectAccess);
    } else {
      // By explicitly using `prop-types` you are opting into new production behavior.
      // http://fb.me/prop-types-in-prod
      module.exports = __webpack_require__(78)();
    }

    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(3));

  /***/
}), ( /* 5 */
/***/function (module, exports) {
  module.exports = function (it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
  };

  /***/
}), ( /* 6 */
/***/function (module, exports, __webpack_require__) {
  var isObject = __webpack_require__(5);
  module.exports = function (it) {
    if (!isObject(it)) {
      throw TypeError(String(it) + ' is not an object');
    }
    return it;
  };

  /***/
}), ( /* 7 */
/***/function (module, exports) {
  var hasOwnProperty = {}.hasOwnProperty;
  module.exports = function (it, key) {
    return hasOwnProperty.call(it, key);
  };

  /***/
}), ( /* 8 */
/***/function (module, exports, __webpack_require__) {
  var definePropertyModule = __webpack_require__(14);
  var createPropertyDescriptor = __webpack_require__(35);
  module.exports = __webpack_require__(13) ? function (object, key, value) {
    return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
  } : function (object, key, value) {
    object[key] = value;
    return object;
  };

  /***/
}), ( /* 9 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  /* WEBPACK VAR INJECTION */
  (function (process) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.redirectAfterSubmit = exports.omit = exports.noop = exports.applyIOSIframeResizeHack = exports.applyIOSFooterHack = exports.debounce = exports.fixSafariScroll = exports.isElementInViewport = exports.onMessage = exports.ensureMetaViewport = exports.replaceExistingKeys = exports.appendParamsToUrl = exports.updateQueryStringParameter = exports.randomString = exports.DOMAIN = undefined;
    var _customEvent = __webpack_require__(80);
    var _customEvent2 = _interopRequireDefault(_customEvent);
    var _isUrl = __webpack_require__(81);
    var _isUrl2 = _interopRequireDefault(_isUrl);
    var _urlParse = __webpack_require__(43);
    var _urlParse2 = _interopRequireDefault(_urlParse);
    var _isobject = __webpack_require__(84);
    var _isobject2 = _interopRequireDefault(_isobject);
    var _mobileDetection = __webpack_require__(16);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function _objectWithoutProperties(obj, keys) {
      var target = {};
      for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
      }
      return target;
    }
    var DOMAIN_REGEXP = /(\.typeform)\.(com|io)$/;
    var DOMAIN = exports.DOMAIN = 'admin.typeform.com';
    var randomString = exports.randomString = function randomString() {
      return Math.random().toString(36).substr(2, 5);
    };
    var updateQueryStringParameter = exports.updateQueryStringParameter = function updateQueryStringParameter(key, value, uri) {
      var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
      var separator = uri.indexOf('?') !== -1 ? '&' : '?';
      if (uri.match(re)) {
        return uri.replace(re, '$1' + key + '=' + value + '$2');
      }
      return uri + separator + key + '=' + value;
    };
    var appendParamsToUrl = exports.appendParamsToUrl = function appendParamsToUrl(url, params) {
      var queryParameters = [];
      var _UrlParse = (0, _urlParse2.default)(url, true),
        query = _UrlParse.query,
        origin = _UrlParse.origin,
        pathname = _UrlParse.pathname;
      var path = pathname.replace(/\/$/, ''); // remove trailing slash
      var parameters = Object.assign({}, query, params);
      Object.keys(parameters).forEach(function (key) {
        queryParameters.push(encodeURIComponent(key) + '=' + encodeURIComponent(parameters[key]));
      });
      return '' + origin + path + '?' + queryParameters.join('&');
    };
    var replaceExistingKeys = exports.replaceExistingKeys = function replaceExistingKeys(obj, replacer) {
      return Object.keys(replacer).reduce(function (acc, oldKey) {
        var newKey = replacer[oldKey];
        if (newKey != null && obj[oldKey] != null && obj[oldKey] !== false) {
          acc[newKey] = obj[oldKey];
        }
        return acc;
      }, {});
    };
    var ensureMetaViewport = exports.ensureMetaViewport = function ensureMetaViewport() {
      if (!document.querySelector) {
        return;
      }
      var viewport = document.querySelector('meta[name=viewport]');
      var viewportContent = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0';
      if (viewport) {
        viewport.setAttribute('content', viewportContent);
      } else {
        var metaTag = document.createElement('meta');
        metaTag.content = viewportContent;
        metaTag.name = 'viewport';
        document.head.appendChild(metaTag);
      }
    };
    var acceptMessageOrigin = function acceptMessageOrigin(e) {
      if (process.env.NODE_ENV === 'development') {
        return true;
      }

      // deal with polymorphistic legacy: some events come from jQuery, other Vanilla JS
      var re = new RegExp('^(?:f|ht)tp(?:s)?://([^/]+)', 'im');
      var matches = e.origin.match(re);
      if (matches && matches.length > 1) {
        var domain = matches[1].toString();

        // to test this in local you will need to whitelist your local domain
        if (!DOMAIN_REGEXP.test(domain)) {
          return false;
        }
      } else {
        return false;
      }
      return true;
    };
    var onMessage = exports.onMessage = function onMessage(e) {
      e = e.originalEvent || e;
      if (!acceptMessageOrigin(e)) {
        return false;
      }
      if ((0, _isUrl2.default)(e.data)) {
        window.location.href = e.data;
        return;
      }
      if ((0, _isobject2.default)(e.data) && e.data.hasOwnProperty('type')) {
        window.dispatchEvent(new _customEvent2.default(e.data.type, {
          detail: e.data
        }));
        return;
      }
      window.dispatchEvent(new _customEvent2.default(e.data));
    };
    var isElementInViewport = exports.isElementInViewport = function isElementInViewport(el) {
      // If it's a nested iframe, don't try to calculate if is insideViewport
      if (window.top !== window) {
        return false;
      }
      var rect = el.getBoundingClientRect();
      var margin = rect.height * 0.2; // 20% of margin
      var docWidth = window.innerWidth || document.documentElement.clientWidth;
      var docHeight = window.innerHeight || document.documentElement.clientHeight;
      return rect.top >= -margin && rect.left >= -margin && rect.bottom <= docHeight + margin && rect.right <= docWidth + margin;
    };

    // RD-712
    var fixSafariScroll = exports.fixSafariScroll = function fixSafariScroll(iframe) {
      if ((0, _mobileDetection.isMobile)(navigator.userAgent) || !(0, _mobileDetection.isSafari)(navigator.userAgent)) {
        return;
      }
      iframe.addEventListener('load', function () {
        return setTimeout(function () {
          var originalHeight = window.getComputedStyle(iframe).height;
          iframe.setAttribute('height', iframe.offsetHeight + 1 + 'px');
          return setTimeout(function () {
            iframe.setAttribute('height', originalHeight);
          }, 1);
        }, 1000);
      });
    };
    var debounce = exports.debounce = function debounce(func, wait, context) {
      var timeout = void 0;
      return function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        var debounced = function debounced() {
          timeout = null;
          func.call.apply(func, [context].concat(args));
        };
        clearTimeout(timeout);
        timeout = setTimeout(debounced, wait);
      };
    };

    // Fix RD-731, footer not fully visible on iOS devices
    var applyIOSFooterHack = exports.applyIOSFooterHack = function applyIOSFooterHack(element) {
      if (!(0, _mobileDetection.isIOSDevice)(navigator.userAgent)) {
        return;
      }
      element.setAttribute('scrolling', 'no');
      element.style.height = '1px';
      element.style.minHeight = '100%';
    };
    var applyIOSIframeResizeHack = exports.applyIOSIframeResizeHack = function applyIOSIframeResizeHack(element) {
      if (!(0, _mobileDetection.isIOSDevice)(navigator.userAgent)) {
        return;
      }
      element.style.maxHeight = '100%';
      element.style.maxWidth = '100%';
      element.style.minHeight = '100%';
      element.style.minWidth = '100%';
      element.style.width = 0;
    };
    var noop = exports.noop = function noop() {
      return null;
    };
    var omit = function omit(key, object) {
      var deletedKey = object[key],
        otherKeys = _objectWithoutProperties(object, [key]);
      return otherKeys;
    };
    exports.omit = omit;
    var redirectAfterSubmit = exports.redirectAfterSubmit = function redirectAfterSubmit(event) {
      var url = event.detail.url;
      try {
        var anchor = document.createElement('a');
        anchor.href = url;
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
      } catch (e) {}
    };
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(3));

  /***/
}), ( /* 10 */
/***/function (module, exports) {
  module.exports = function (exec) {
    try {
      return !!exec();
    } catch (error) {
      return true;
    }
  };

  /***/
}), ( /* 11 */
/***/function (module, exports) {
  var toString = {}.toString;
  module.exports = function (it) {
    return toString.call(it).slice(8, -1);
  };

  /***/
}), ( /* 12 */
/***/function (module, exports, __webpack_require__) {
  var global = __webpack_require__(0);
  var getOwnPropertyDescriptor = __webpack_require__(34).f;
  var hide = __webpack_require__(8);
  var redefine = __webpack_require__(19);
  var setGlobal = __webpack_require__(37);
  var copyConstructorProperties = __webpack_require__(106);
  var isForced = __webpack_require__(57);

  /*
    options.target      - name of the target object
    options.global      - target is the global object
    options.stat        - export as static methods of target
    options.proto       - export as prototype methods of target
    options.real        - real prototype method for the `pure` version
    options.forced      - export even if the native feature is available
    options.bind        - bind methods to the target, required for the `pure` version
    options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
    options.unsafe      - use the simple assignment of property instead of delete + defineProperty
    options.sham        - add a flag to not completely full polyfills
    options.enumerable  - export as enumerable property
    options.noTargetGet - prevent calling a getter on target
  */
  module.exports = function (options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) {
      target = global;
    } else if (STATIC) {
      target = global[TARGET] || setGlobal(TARGET, {});
    } else {
      target = (global[TARGET] || {}).prototype;
    }
    if (target) for (key in source) {
      sourceProperty = source[key];
      if (options.noTargetGet) {
        descriptor = getOwnPropertyDescriptor(target, key);
        targetProperty = descriptor && descriptor.value;
      } else targetProperty = target[key];
      FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
      // contained in target
      if (!FORCED && targetProperty !== undefined) {
        if (typeof sourceProperty === typeof targetProperty) continue;
        copyConstructorProperties(sourceProperty, targetProperty);
      }
      // add a flag to not completely full polyfills
      if (options.sham || targetProperty && targetProperty.sham) {
        hide(sourceProperty, 'sham', true);
      }
      // extend global
      redefine(target, key, sourceProperty, options);
    }
  };

  /***/
}), ( /* 13 */
/***/function (module, exports, __webpack_require__) {
  // Thank's IE8 for his funny defineProperty
  module.exports = !__webpack_require__(10)(function () {
    return Object.defineProperty({}, 'a', {
      get: function () {
        return 7;
      }
    }).a != 7;
  });

  /***/
}), ( /* 14 */
/***/function (module, exports, __webpack_require__) {
  var DESCRIPTORS = __webpack_require__(13);
  var IE8_DOM_DEFINE = __webpack_require__(54);
  var anObject = __webpack_require__(6);
  var toPrimitive = __webpack_require__(53);
  var nativeDefineProperty = Object.defineProperty;
  exports.f = DESCRIPTORS ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
    anObject(O);
    P = toPrimitive(P, true);
    anObject(Attributes);
    if (IE8_DOM_DEFINE) try {
      return nativeDefineProperty(O, P, Attributes);
    } catch (error) {/* empty */}
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
  };

  /***/
}), ( /* 15 */
/***/function (module, exports) {
  module.exports = {};

  /***/
}), ( /* 16 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var isScreenBig = exports.isScreenBig = function isScreenBig() {
    return window.screen.width >= 1024 && window.screen.height >= 768;
  };
  var isMobile = exports.isMobile = function isMobile(ua) {
    return /mobile|tablet|android/i.test(ua.toLowerCase());
  };
  var isSafari = exports.isSafari = function isSafari(ua) {
    return /^((?!chrome|android).)*safari/i.test(ua.toLowerCase());
  };
  var isIOSDevice = exports.isIOSDevice = function isIOSDevice(ua) {
    return /ip(hone|od|ad)/i.test(ua.toLowerCase());
  };

  /***/
}), ( /* 17 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  /* WEBPACK VAR INJECTION */
  (function (global) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.keyframes = exports.injectGlobal = exports.css = undefined;
    var _react = __webpack_require__(2);
    var _react2 = _interopRequireDefault(_react);
    var _createEmotion = __webpack_require__(86);
    var _createEmotion2 = _interopRequireDefault(_createEmotion);
    var _createEmotionStyled = __webpack_require__(91);
    var _createEmotionStyled2 = _interopRequireDefault(_createEmotionStyled);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    var context = typeof global !== 'undefined' ? global : {};
    var emotion = (0, _createEmotion2.default)(context);
    var css = exports.css = emotion.css;
    var injectGlobal = exports.injectGlobal = emotion.injectGlobal;
    var keyframes = exports.keyframes = emotion.keyframes;
    exports.default = (0, _createEmotionStyled2.default)(emotion, _react2.default);
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(25));

  /***/
}), ( /* 18 */
/***/function (module, exports, __webpack_require__) {
  // toObject with fallback for non-array-like ES3 strings
  var IndexedObject = __webpack_require__(27);
  var requireObjectCoercible = __webpack_require__(28);
  module.exports = function (it) {
    return IndexedObject(requireObjectCoercible(it));
  };

  /***/
}), ( /* 19 */
/***/function (module, exports, __webpack_require__) {
  var global = __webpack_require__(0);
  var hide = __webpack_require__(8);
  var has = __webpack_require__(7);
  var setGlobal = __webpack_require__(37);
  var nativeFunctionToString = __webpack_require__(55);
  var InternalStateModule = __webpack_require__(22);
  var getInternalState = InternalStateModule.get;
  var enforceInternalState = InternalStateModule.enforce;
  var TEMPLATE = String(nativeFunctionToString).split('toString');
  __webpack_require__(20)('inspectSource', function (it) {
    return nativeFunctionToString.call(it);
  });
  (module.exports = function (O, key, value, options) {
    var unsafe = options ? !!options.unsafe : false;
    var simple = options ? !!options.enumerable : false;
    var noTargetGet = options ? !!options.noTargetGet : false;
    if (typeof value == 'function') {
      if (typeof key == 'string' && !has(value, 'name')) hide(value, 'name', key);
      enforceInternalState(value).source = TEMPLATE.join(typeof key == 'string' ? key : '');
    }
    if (O === global) {
      if (simple) O[key] = value;else setGlobal(key, value);
      return;
    } else if (!unsafe) {
      delete O[key];
    } else if (!noTargetGet && O[key]) {
      simple = true;
    }
    if (simple) O[key] = value;else hide(O, key, value);
    // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
  })(Function.prototype, 'toString', function toString() {
    return typeof this == 'function' && getInternalState(this).source || nativeFunctionToString.call(this);
  });

  /***/
}), ( /* 20 */
/***/function (module, exports, __webpack_require__) {
  var global = __webpack_require__(0);
  var setGlobal = __webpack_require__(37);
  var SHARED = '__core-js_shared__';
  var store = global[SHARED] || setGlobal(SHARED, {});
  (module.exports = function (key, value) {
    return store[key] || (store[key] = value !== undefined ? value : {});
  })('versions', []).push({
    version: '3.0.1',
    mode: __webpack_require__(21) ? 'pure' : 'global',
    copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
  });

  /***/
}), ( /* 21 */
/***/function (module, exports) {
  module.exports = false;

  /***/
}), ( /* 22 */
/***/function (module, exports, __webpack_require__) {
  var NATIVE_WEAK_MAP = __webpack_require__(105);
  var isObject = __webpack_require__(5);
  var hide = __webpack_require__(8);
  var objectHas = __webpack_require__(7);
  var sharedKey = __webpack_require__(38);
  var hiddenKeys = __webpack_require__(31);
  var WeakMap = __webpack_require__(0).WeakMap;
  var set, get, has;
  var enforce = function (it) {
    return has(it) ? get(it) : set(it, {});
  };
  var getterFor = function (TYPE) {
    return function (it) {
      var state;
      if (!isObject(it) || (state = get(it)).type !== TYPE) {
        throw TypeError('Incompatible receiver, ' + TYPE + ' required');
      }
      return state;
    };
  };
  if (NATIVE_WEAK_MAP) {
    var store = new WeakMap();
    var wmget = store.get;
    var wmhas = store.has;
    var wmset = store.set;
    set = function (it, metadata) {
      wmset.call(store, it, metadata);
      return metadata;
    };
    get = function (it) {
      return wmget.call(store, it) || {};
    };
    has = function (it) {
      return wmhas.call(store, it);
    };
  } else {
    var STATE = sharedKey('state');
    hiddenKeys[STATE] = true;
    set = function (it, metadata) {
      hide(it, STATE, metadata);
      return metadata;
    };
    get = function (it) {
      return objectHas(it, STATE) ? it[STATE] : {};
    };
    has = function (it) {
      return objectHas(it, STATE);
    };
  }
  module.exports = {
    set: set,
    get: get,
    has: has,
    enforce: enforce,
    getterFor: getterFor
  };

  /***/
}), ( /* 23 */
/***/function (module, exports) {
  module.exports = function (it) {
    if (typeof it != 'function') {
      throw TypeError(String(it) + ' is not a function');
    }
    return it;
  };

  /***/
}), ( /* 24 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
  module.exports = ReactPropTypesSecret;

  /***/
}), ( /* 25 */
/***/function (module, exports) {
  var g;

  // This works in non-strict mode
  g = function () {
    return this;
  }();
  try {
    // This works if eval is allowed (see CSP)
    g = g || Function("return this")() || (1, eval)("this");
  } catch (e) {
    // This works if the window reference is available
    if (typeof window === "object") g = window;
  }

  // g can still be undefined, but nothing to do about it...
  // We return undefined, instead of nothing here, so it's
  // easier to handle this case. if(!global) { ...}

  module.exports = g;

  /***/
}), ( /* 26 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _react = __webpack_require__(2);
  var _react2 = _interopRequireDefault(_react);
  var _propTypes = __webpack_require__(4);
  var _propTypes2 = _interopRequireDefault(_propTypes);
  var _utils = __webpack_require__(9);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function _objectWithoutProperties(obj, keys) {
    var target = {};
    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }
    return target;
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var Iframe = function (_Component) {
    _inherits(Iframe, _Component);
    function Iframe(props) {
      _classCallCheck(this, Iframe);
      var _this = _possibleConstructorReturn(this, (Iframe.__proto__ || Object.getPrototypeOf(Iframe)).call(this, props));
      _this.iframeRef = null;
      _this.loadHandler = _this.loadHandler.bind(_this);
      return _this;
    }

    // Fixes scroll not responding in renderer v1

    _createClass(Iframe, [{
      key: 'loadHandler',
      value: function loadHandler() {
        var _this2 = this;
        this.iframeRef.style.height = this.iframeRef.offsetHeight + 1 + 'px';
        setTimeout(function () {
          _this2.iframeRef.style.height = '';
          (0, _utils.applyIOSFooterHack)(_this2.iframeRef);
          (0, _utils.applyIOSIframeResizeHack)(_this2.iframeRef);
          _this2.props.onLoad && _this2.props.onLoad(_this2.iframeRef);
        }, 1);
      }
    }, {
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        return nextProps.src !== this.props.src;
      }
    }, {
      key: 'render',
      value: function render() {
        var _this3 = this;
        var _props = this.props,
          style = _props.style,
          rest = _objectWithoutProperties(_props, ['style']);
        return _react2.default.createElement('iframe', _extends({}, rest, {
          'data-qa': 'iframe',
          frameBorder: '0',
          height: '100%',
          onLoad: this.loadHandler,
          ref: function ref(node) {
            _this3.iframeRef = node;
          },
          src: this.props.src,
          style: _extends({
            border: 0
          }, style),
          width: '100%'
        }));
      }
    }]);
    return Iframe;
  }(_react.Component);
  Iframe.propTypes = {
    src: _propTypes2.default.string.isRequired,
    onLoad: _propTypes2.default.func,
    style: _propTypes2.default.object
  };
  exports.default = Iframe;

  /***/
}), ( /* 27 */
/***/function (module, exports, __webpack_require__) {
  // fallback for non-array-like ES3 and non-enumerable old V8 strings
  var fails = __webpack_require__(10);
  var classof = __webpack_require__(11);
  var split = ''.split;
  module.exports = fails(function () {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins
    return !Object('z').propertyIsEnumerable(0);
  }) ? function (it) {
    return classof(it) == 'String' ? split.call(it, '') : Object(it);
  } : Object;

  /***/
}), ( /* 28 */
/***/function (module, exports) {
  // `RequireObjectCoercible` abstract operation
  // https://tc39.github.io/ecma262/#sec-requireobjectcoercible
  module.exports = function (it) {
    if (it == undefined) throw TypeError("Can't call method on " + it);
    return it;
  };

  /***/
}), ( /* 29 */
/***/function (module, exports, __webpack_require__) {
  var toInteger = __webpack_require__(30);
  var min = Math.min;

  // `ToLength` abstract operation
  // https://tc39.github.io/ecma262/#sec-tolength
  module.exports = function (argument) {
    return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
  };

  /***/
}), ( /* 30 */
/***/function (module, exports) {
  var ceil = Math.ceil;
  var floor = Math.floor;

  // `ToInteger` abstract operation
  // https://tc39.github.io/ecma262/#sec-tointeger
  module.exports = function (argument) {
    return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
  };

  /***/
}), ( /* 31 */
/***/function (module, exports) {
  module.exports = {};

  /***/
}), ( /* 32 */
/***/function (module, exports) {
  // IE8- don't enum bug keys
  module.exports = ['constructor', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'toLocaleString', 'toString', 'valueOf'];

  /***/
}), ( /* 33 */
/***/function (module, exports, __webpack_require__) {
  var requireObjectCoercible = __webpack_require__(28);

  // `ToObject` abstract operation
  // https://tc39.github.io/ecma262/#sec-toobject
  module.exports = function (argument) {
    return Object(requireObjectCoercible(argument));
  };

  /***/
}), ( /* 34 */
/***/function (module, exports, __webpack_require__) {
  var DESCRIPTORS = __webpack_require__(13);
  var propertyIsEnumerableModule = __webpack_require__(52);
  var createPropertyDescriptor = __webpack_require__(35);
  var toIndexedObject = __webpack_require__(18);
  var toPrimitive = __webpack_require__(53);
  var has = __webpack_require__(7);
  var IE8_DOM_DEFINE = __webpack_require__(54);
  var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  exports.f = DESCRIPTORS ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = toIndexedObject(O);
    P = toPrimitive(P, true);
    if (IE8_DOM_DEFINE) try {
      return nativeGetOwnPropertyDescriptor(O, P);
    } catch (error) {/* empty */}
    if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
  };

  /***/
}), ( /* 35 */
/***/function (module, exports) {
  module.exports = function (bitmap, value) {
    return {
      enumerable: !(bitmap & 1),
      configurable: !(bitmap & 2),
      writable: !(bitmap & 4),
      value: value
    };
  };

  /***/
}), ( /* 36 */
/***/function (module, exports, __webpack_require__) {
  var isObject = __webpack_require__(5);
  var document = __webpack_require__(0).document;
  // typeof document.createElement is 'object' in old IE
  var exist = isObject(document) && isObject(document.createElement);
  module.exports = function (it) {
    return exist ? document.createElement(it) : {};
  };

  /***/
}), ( /* 37 */
/***/function (module, exports, __webpack_require__) {
  var global = __webpack_require__(0);
  var hide = __webpack_require__(8);
  module.exports = function (key, value) {
    try {
      hide(global, key, value);
    } catch (error) {
      global[key] = value;
    }
    return value;
  };

  /***/
}), ( /* 38 */
/***/function (module, exports, __webpack_require__) {
  var shared = __webpack_require__(20)('keys');
  var uid = __webpack_require__(56);
  module.exports = function (key) {
    return shared[key] || (shared[key] = uid(key));
  };

  /***/
}), ( /* 39 */
/***/function (module, exports, __webpack_require__) {
  var aFunction = __webpack_require__(23);

  // optional / simple context binding
  module.exports = function (fn, that, length) {
    aFunction(fn);
    if (that === undefined) return fn;
    switch (length) {
      case 0:
        return function () {
          return fn.call(that);
        };
      case 1:
        return function (a) {
          return fn.call(that, a);
        };
      case 2:
        return function (a, b) {
          return fn.call(that, a, b);
        };
      case 3:
        return function (a, b, c) {
          return fn.call(that, a, b, c);
        };
    }
    return function /* ...args */
    () {
      return fn.apply(that, arguments);
    };
  };

  /***/
}), ( /* 40 */
/***/function (module, exports, __webpack_require__) {
  var defineProperty = __webpack_require__(14).f;
  var has = __webpack_require__(7);
  var TO_STRING_TAG = __webpack_require__(1)('toStringTag');
  module.exports = function (it, TAG, STATIC) {
    if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
      defineProperty(it, TO_STRING_TAG, {
        configurable: true,
        value: TAG
      });
    }
  };

  /***/
}), ( /* 41 */
/***/function (module, exports, __webpack_require__) {
  module.exports = __webpack_require__(0);

  /***/
}), ( /* 42 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  /* WEBPACK VAR INJECTION */
  (function (process) {
    if (process.env.NODE_ENV === 'production') {
      module.exports = __webpack_require__(73);
    } else {
      module.exports = __webpack_require__(74);
    }

    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(3));

  /***/
}), ( /* 43 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  /* WEBPACK VAR INJECTION */
  (function (global) {
    var required = __webpack_require__(82),
      qs = __webpack_require__(83),
      protocolre = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\S\s]*)/i,
      slashes = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//;

    /**
     * These are the parse rules for the URL parser, it informs the parser
     * about:
     *
     * 0. The char it Needs to parse, if it's a string it should be done using
     *    indexOf, RegExp using exec and NaN means set as current value.
     * 1. The property we should set when parsing this value.
     * 2. Indication if it's backwards or forward parsing, when set as number it's
     *    the value of extra chars that should be split off.
     * 3. Inherit from location if non existing in the parser.
     * 4. `toLowerCase` the resulting value.
     */
    var rules = [['#', 'hash'],
    // Extract from the back.
    ['?', 'query'],
    // Extract from the back.
    function sanitize(address) {
      // Sanitize what is left of the address
      return address.replace('\\', '/');
    }, ['/', 'pathname'],
    // Extract from the back.
    ['@', 'auth', 1],
    // Extract from the front.
    [NaN, 'host', undefined, 1, 1],
    // Set left over value.
    [/:(\d+)$/, 'port', undefined, 1],
    // RegExp the back.
    [NaN, 'hostname', undefined, 1, 1] // Set left over.
    ];

    /**
     * These properties should not be copied or inherited from. This is only needed
     * for all non blob URL's as a blob URL does not include a hash, only the
     * origin.
     *
     * @type {Object}
     * @private
     */
    var ignore = {
      hash: 1,
      query: 1
    };

    /**
     * The location object differs when your code is loaded through a normal page,
     * Worker or through a worker using a blob. And with the blobble begins the
     * trouble as the location object will contain the URL of the blob, not the
     * location of the page where our code is loaded in. The actual origin is
     * encoded in the `pathname` so we can thankfully generate a good "default"
     * location from it so we can generate proper relative URL's again.
     *
     * @param {Object|String} loc Optional default location object.
     * @returns {Object} lolcation object.
     * @public
     */
    function lolcation(loc) {
      var globalVar;
      if (typeof window !== 'undefined') globalVar = window;else if (typeof global !== 'undefined') globalVar = global;else if (typeof self !== 'undefined') globalVar = self;else globalVar = {};
      var location = globalVar.location || {};
      loc = loc || location;
      var finaldestination = {},
        type = typeof loc,
        key;
      if ('blob:' === loc.protocol) {
        finaldestination = new Url(unescape(loc.pathname), {});
      } else if ('string' === type) {
        finaldestination = new Url(loc, {});
        for (key in ignore) delete finaldestination[key];
      } else if ('object' === type) {
        for (key in loc) {
          if (key in ignore) continue;
          finaldestination[key] = loc[key];
        }
        if (finaldestination.slashes === undefined) {
          finaldestination.slashes = slashes.test(loc.href);
        }
      }
      return finaldestination;
    }

    /**
     * @typedef ProtocolExtract
     * @type Object
     * @property {String} protocol Protocol matched in the URL, in lowercase.
     * @property {Boolean} slashes `true` if protocol is followed by "//", else `false`.
     * @property {String} rest Rest of the URL that is not part of the protocol.
     */

    /**
     * Extract protocol information from a URL with/without double slash ("//").
     *
     * @param {String} address URL we want to extract from.
     * @return {ProtocolExtract} Extracted information.
     * @private
     */
    function extractProtocol(address) {
      var match = protocolre.exec(address);
      return {
        protocol: match[1] ? match[1].toLowerCase() : '',
        slashes: !!match[2],
        rest: match[3]
      };
    }

    /**
     * Resolve a relative URL pathname against a base URL pathname.
     *
     * @param {String} relative Pathname of the relative URL.
     * @param {String} base Pathname of the base URL.
     * @return {String} Resolved pathname.
     * @private
     */
    function resolve(relative, base) {
      var path = (base || '/').split('/').slice(0, -1).concat(relative.split('/')),
        i = path.length,
        last = path[i - 1],
        unshift = false,
        up = 0;
      while (i--) {
        if (path[i] === '.') {
          path.splice(i, 1);
        } else if (path[i] === '..') {
          path.splice(i, 1);
          up++;
        } else if (up) {
          if (i === 0) unshift = true;
          path.splice(i, 1);
          up--;
        }
      }
      if (unshift) path.unshift('');
      if (last === '.' || last === '..') path.push('');
      return path.join('/');
    }

    /**
     * The actual URL instance. Instead of returning an object we've opted-in to
     * create an actual constructor as it's much more memory efficient and
     * faster and it pleases my OCD.
     *
     * It is worth noting that we should not use `URL` as class name to prevent
     * clashes with the global URL instance that got introduced in browsers.
     *
     * @constructor
     * @param {String} address URL we want to parse.
     * @param {Object|String} [location] Location defaults for relative paths.
     * @param {Boolean|Function} [parser] Parser for the query string.
     * @private
     */
    function Url(address, location, parser) {
      if (!(this instanceof Url)) {
        return new Url(address, location, parser);
      }
      var relative,
        extracted,
        parse,
        instruction,
        index,
        key,
        instructions = rules.slice(),
        type = typeof location,
        url = this,
        i = 0;

      //
      // The following if statements allows this module two have compatibility with
      // 2 different API:
      //
      // 1. Node.js's `url.parse` api which accepts a URL, boolean as arguments
      //    where the boolean indicates that the query string should also be parsed.
      //
      // 2. The `URL` interface of the browser which accepts a URL, object as
      //    arguments. The supplied object will be used as default values / fall-back
      //    for relative paths.
      //
      if ('object' !== type && 'string' !== type) {
        parser = location;
        location = null;
      }
      if (parser && 'function' !== typeof parser) parser = qs.parse;
      location = lolcation(location);

      //
      // Extract protocol information before running the instructions.
      //
      extracted = extractProtocol(address || '');
      relative = !extracted.protocol && !extracted.slashes;
      url.slashes = extracted.slashes || relative && location.slashes;
      url.protocol = extracted.protocol || location.protocol || '';
      address = extracted.rest;

      //
      // When the authority component is absent the URL starts with a path
      // component.
      //
      if (!extracted.slashes) instructions[3] = [/(.*)/, 'pathname'];
      for (; i < instructions.length; i++) {
        instruction = instructions[i];
        if (typeof instruction === 'function') {
          address = instruction(address);
          continue;
        }
        parse = instruction[0];
        key = instruction[1];
        if (parse !== parse) {
          url[key] = address;
        } else if ('string' === typeof parse) {
          if (~(index = address.indexOf(parse))) {
            if ('number' === typeof instruction[2]) {
              url[key] = address.slice(0, index);
              address = address.slice(index + instruction[2]);
            } else {
              url[key] = address.slice(index);
              address = address.slice(0, index);
            }
          }
        } else if (index = parse.exec(address)) {
          url[key] = index[1];
          address = address.slice(0, index.index);
        }
        url[key] = url[key] || (relative && instruction[3] ? location[key] || '' : '');

        //
        // Hostname, host and protocol should be lowercased so they can be used to
        // create a proper `origin`.
        //
        if (instruction[4]) url[key] = url[key].toLowerCase();
      }

      //
      // Also parse the supplied query string in to an object. If we're supplied
      // with a custom parser as function use that instead of the default build-in
      // parser.
      //
      if (parser) url.query = parser(url.query);

      //
      // If the URL is relative, resolve the pathname against the base URL.
      //
      if (relative && location.slashes && url.pathname.charAt(0) !== '/' && (url.pathname !== '' || location.pathname !== '')) {
        url.pathname = resolve(url.pathname, location.pathname);
      }

      //
      // We should not add port numbers if they are already the default port number
      // for a given protocol. As the host also contains the port number we're going
      // override it with the hostname which contains no port number.
      //
      if (!required(url.port, url.protocol)) {
        url.host = url.hostname;
        url.port = '';
      }

      //
      // Parse down the `auth` for the username and password.
      //
      url.username = url.password = '';
      if (url.auth) {
        instruction = url.auth.split(':');
        url.username = instruction[0] || '';
        url.password = instruction[1] || '';
      }
      url.origin = url.protocol && url.host && url.protocol !== 'file:' ? url.protocol + '//' + url.host : 'null';

      //
      // The href is just the compiled result.
      //
      url.href = url.toString();
    }

    /**
     * This is convenience method for changing properties in the URL instance to
     * insure that they all propagate correctly.
     *
     * @param {String} part          Property we need to adjust.
     * @param {Mixed} value          The newly assigned value.
     * @param {Boolean|Function} fn  When setting the query, it will be the function
     *                               used to parse the query.
     *                               When setting the protocol, double slash will be
     *                               removed from the final url if it is true.
     * @returns {URL} URL instance for chaining.
     * @public
     */
    function set(part, value, fn) {
      var url = this;
      switch (part) {
        case 'query':
          if ('string' === typeof value && value.length) {
            value = (fn || qs.parse)(value);
          }
          url[part] = value;
          break;
        case 'port':
          url[part] = value;
          if (!required(value, url.protocol)) {
            url.host = url.hostname;
            url[part] = '';
          } else if (value) {
            url.host = url.hostname + ':' + value;
          }
          break;
        case 'hostname':
          url[part] = value;
          if (url.port) value += ':' + url.port;
          url.host = value;
          break;
        case 'host':
          url[part] = value;
          if (/:\d+$/.test(value)) {
            value = value.split(':');
            url.port = value.pop();
            url.hostname = value.join(':');
          } else {
            url.hostname = value;
            url.port = '';
          }
          break;
        case 'protocol':
          url.protocol = value.toLowerCase();
          url.slashes = !fn;
          break;
        case 'pathname':
        case 'hash':
          if (value) {
            var char = part === 'pathname' ? '/' : '#';
            url[part] = value.charAt(0) !== char ? char + value : value;
          } else {
            url[part] = value;
          }
          break;
        default:
          url[part] = value;
      }
      for (var i = 0; i < rules.length; i++) {
        var ins = rules[i];
        if (ins[4]) url[ins[1]] = url[ins[1]].toLowerCase();
      }
      url.origin = url.protocol && url.host && url.protocol !== 'file:' ? url.protocol + '//' + url.host : 'null';
      url.href = url.toString();
      return url;
    }

    /**
     * Transform the properties back in to a valid and full URL string.
     *
     * @param {Function} stringify Optional query stringify function.
     * @returns {String} Compiled version of the URL.
     * @public
     */
    function toString(stringify) {
      if (!stringify || 'function' !== typeof stringify) stringify = qs.stringify;
      var query,
        url = this,
        protocol = url.protocol;
      if (protocol && protocol.charAt(protocol.length - 1) !== ':') protocol += ':';
      var result = protocol + (url.slashes ? '//' : '');
      if (url.username) {
        result += url.username;
        if (url.password) result += ':' + url.password;
        result += '@';
      }
      result += url.host + url.pathname;
      query = 'object' === typeof url.query ? stringify(url.query) : url.query;
      if (query) result += '?' !== query.charAt(0) ? '?' + query : query;
      if (url.hash) result += url.hash;
      return result;
    }
    Url.prototype = {
      set: set,
      toString: toString
    };

    //
    // Expose the URL parser and some additional properties that might be useful for
    // others or testing.
    //
    Url.extractProtocol = extractProtocol;
    Url.location = lolcation;
    Url.qs = qs;
    module.exports = Url;

    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(25));

  /***/
}), ( /* 44 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.POPUP_MODES = exports.DRAWER_RIGHT = exports.DRAWER = exports.POPUP = exports.DEFAULT_AUTOCLOSE_TIMEOUT = undefined;
  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _POPUP_MODES;
  var _react = __webpack_require__(2);
  var _react2 = _interopRequireDefault(_react);
  var _propTypes = __webpack_require__(4);
  var _propTypes2 = _interopRequireDefault(_propTypes);
  var _scrollbarWidth = __webpack_require__(85);
  var _scrollbarWidth2 = _interopRequireDefault(_scrollbarWidth);
  var _styles = __webpack_require__(17);
  var _styles2 = _interopRequireDefault(_styles);
  var _iframe = __webpack_require__(26);
  var _iframe2 = _interopRequireDefault(_iframe);
  var _spinner = __webpack_require__(93);
  var _spinner2 = _interopRequireDefault(_spinner);
  var _utils = __webpack_require__(9);
  var _close = __webpack_require__(95);
  var _close2 = _interopRequireDefault(_close);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  var ESC_KEY_CODE = 27;
  var CLOSE_BUTTON_WIDTH = 30;
  var DEFAULT_AUTOCLOSE_TIMEOUT = exports.DEFAULT_AUTOCLOSE_TIMEOUT = 5;
  var POPUP = exports.POPUP = 'popup';
  var DRAWER = exports.DRAWER = 'drawer_left';
  var DRAWER_RIGHT = exports.DRAWER_RIGHT = 'drawer_right';
  var POPUP_MODES = exports.POPUP_MODES = (_POPUP_MODES = {}, _defineProperty(_POPUP_MODES, POPUP, 'popup-blank'), _defineProperty(_POPUP_MODES, DRAWER, 'popup-classic'), _defineProperty(_POPUP_MODES, DRAWER_RIGHT, 'popup-drawer'), _POPUP_MODES);
  var BaseWrapper = /*#__PURE__*/(0, _styles2.default)('div', {
    target: 'e1o3ysfi0'
  })('visibility:', function (p) {
    return p.open ? 'visible' : 'hidden';
  }, ';opacity:', function (p) {
    return p.open ? 1 : 0;
  }, ';position:', function (p) {
    return p.isContained ? 'absolute' : 'fixed';
  }, ';max-width:100%;z-index:10001;');
  var Overlay = /*#__PURE__*/(0, _styles2.default)('div', {
    target: 'e1o3ysfi1'
  })('visibility:', function (p) {
    return p.appearing ? 'hidden' : 'visible';
  }, ';opacity:', function (p) {
    return p.appearing ? 0 : 1;
  }, ';transition:opacity 200ms ease,visibility 0s linear ', function (p) {
    return p.appearing ? '200ms' : '0s';
  }, ';background:rgba(0,0,0,0.85);position:', function (p) {
    return p.isContained ? 'absolute' : 'fixed';
  }, ';overflow:', function (p) {
    return p.isContained ? 'hidden' : 'auto';
  }, ';left:0;top:0;right:0;bottom:0;z-index:10000;min-height:100%;');
  var popupWrapper = /*#__PURE__*/(0, _styles2.default)(BaseWrapper, {
    target: 'e1o3ysfi2'
  })('width:', function (p) {
    return p.isContained ? 'calc(100% - 80px)' : 'calc(100vw - 80px)';
  }, ';height:', function (p) {
    return p.isContained ? 'calc(100% - 80px)' : 'calc(100vh - 80px)';
  }, ';top:40px;left:40px;transition:all 300ms ease-out;');
  var drawerWrapper = /*#__PURE__*/(0, _styles2.default)(BaseWrapper, {
    target: 'e1o3ysfi3'
  })('transition:all 400ms ease-out;width:', function (p) {
    return p.width;
  }, 'px;height:100%;top:0;');
  var drawerLeftWrapper = /*#__PURE__*/(0, _styles2.default)(drawerWrapper, {
    target: 'e1o3ysfi4'
  })('left:', function (p) {
    return !p.open ? -(p.width - CLOSE_BUTTON_WIDTH) : 0;
  }, 'px;');
  var drawerRightWrapper = /*#__PURE__*/(0, _styles2.default)(drawerWrapper, {
    target: 'e1o3ysfi5'
  })('right:', function (p) {
    return !p.open ? -(p.width - CLOSE_BUTTON_WIDTH) : 0;
  }, 'px;');
  var BaseCloseImage = /*#__PURE__*/(0, _styles2.default)('img', {
    target: 'e1o3ysfi6'
  })('position:absolute;padding:8px;cursor:pointer;width:initial;max-width:initial;');
  var closeImagePopup = /*#__PURE__*/(0, _styles2.default)(BaseCloseImage, {
    target: 'e1o3ysfi7'
  })('top:-34px;right:-34px;');
  var closeImageLeft = /*#__PURE__*/(0, _styles2.default)(BaseCloseImage, {
    target: 'e1o3ysfi8'
  })('top:12px;right:-38px;');
  var closeImageRight = /*#__PURE__*/(0, _styles2.default)(BaseCloseImage, {
    target: 'e1o3ysfi9'
  })('top:12px;left:-38px;right:auto;');
  var Popup = function (_Component) {
    _inherits(Popup, _Component);
    function Popup(props) {
      _classCallCheck(this, Popup);
      var _this = _possibleConstructorReturn(this, (Popup.__proto__ || Object.getPrototypeOf(Popup)).call(this, props));
      _this.state = {
        frameAnimate: false,
        iframeLoaded: false,
        popupAnimate: true,
        transitionEnded: false
      };
      _this.handleIframeLoad = _this.handleIframeLoad.bind(_this);
      _this.onKeyDown = _this.onKeyDown.bind(_this);
      _this.onAutoClose = _this.onAutoClose.bind(_this);
      _this.animateBeforeClose = _this.animateBeforeClose.bind(_this);
      _this.handleTransitionEnd = _this.handleTransitionEnd.bind(_this);
      _this.onFormSubmit = _this.onFormSubmit.bind(_this);
      _this.getWrapperRef = _this.getWrapperRef.bind(_this);
      return _this;
    }
    _createClass(Popup, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;
        window.addEventListener('message', _utils.onMessage);
        window.addEventListener('keydown', this.onKeyDown);
        window.addEventListener('form-close', this.animateBeforeClose);
        window.addEventListener('ESC', this.animateBeforeClose);
        window.addEventListener('embed-auto-close-popup', this.onAutoClose);
        window.addEventListener('form-submit', this.onFormSubmit);
        window.addEventListener('redirect-after-submit', _utils.redirectAfterSubmit);
        setTimeout(function () {
          _this2.setState({
            popupAnimate: false
          });
        }, 100);
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        window.removeEventListener('message', _utils.onMessage);
        window.removeEventListener('keydown', this.onKeyDown);
        window.removeEventListener('form-close', this.animateBeforeClose);
        window.removeEventListener('ESC', this.animateBeforeClose);
        window.removeEventListener('embed-auto-close-popup', this.onAutoClose);
        window.removeEventListener('form-submit', this.onFormSubmit);
        window.removeEventListener('redirect-after-submit', _utils.redirectAfterSubmit);
      }
    }, {
      key: 'getWrapperComponent',
      value: function getWrapperComponent(mode) {
        if (mode === DRAWER_RIGHT) return drawerRightWrapper;
        if (mode === DRAWER) return drawerLeftWrapper;
        return popupWrapper;
      }
    }, {
      key: 'getCloseImage',
      value: function getCloseImage(mode) {
        if (mode === DRAWER_RIGHT) return closeImageRight;
        if (mode === DRAWER) return closeImageLeft;
        return closeImagePopup;
      }
    }, {
      key: 'getWrapperRef',
      value: function getWrapperRef(node) {
        this.wrapper = node;
      }
    }, {
      key: 'handleIframeLoad',
      value: function handleIframeLoad(iframeRef) {
        var _this3 = this;
        this.setState({
          iframeLoaded: true
        }, function () {
          setTimeout(function () {
            _this3.setState({
              frameAnimate: true
            });
            if (iframeRef && iframeRef.contentWindow) {
              iframeRef.contentWindow.focus();
            }
          }, 500);
        });
      }
    }, {
      key: 'animateBeforeClose',
      value: function animateBeforeClose() {
        var _this4 = this;
        this.setState({
          frameAnimate: false,
          popupAnimate: false
        }, function () {
          setTimeout(function () {
            _this4.setState({
              popupAnimate: true
            }, function () {
              setTimeout(_this4.props.onClose, 400);
            });
          }, 400);
        });
      }
    }, {
      key: 'onKeyDown',
      value: function onKeyDown(e) {
        var key = document.all ? e.keyCode : e.which;
        if (key === ESC_KEY_CODE) {
          this.animateBeforeClose();
        }
      }
    }, {
      key: 'onAutoClose',
      value: function onAutoClose(e) {
        var _this5 = this;
        var _e$detail$canSetAutoc = e.detail.canSetAutocloseDelay,
          canSetAutocloseDelay = _e$detail$canSetAutoc === undefined ? true : _e$detail$canSetAutoc;
        var _props$options = this.props.options,
          isAutoCloseEnabled = _props$options.isAutoCloseEnabled,
          _props$options$autoCl = _props$options.autoClose,
          autoClose = _props$options$autoCl === undefined ? DEFAULT_AUTOCLOSE_TIMEOUT : _props$options$autoCl;
        var timeout = (canSetAutocloseDelay ? autoClose : DEFAULT_AUTOCLOSE_TIMEOUT) * 1000;
        if (isAutoCloseEnabled) {
          setTimeout(function () {
            _this5.animateBeforeClose();
          }, timeout);
        }
      }
    }, {
      key: 'handleTransitionEnd',
      value: function handleTransitionEnd(event) {
        if (event.target === this.wrapper) {
          this.setState({
            transitionEnded: this.state.frameAnimate
          });
        }
      }
    }, {
      key: 'onFormSubmit',
      value: function onFormSubmit() {
        var onSubmit = this.props.options.onSubmit;
        onSubmit();
      }
    }, {
      key: 'render',
      value: function render() {
        var iframeStyles = null;
        var options = this.props.options;
        var drawerWidth = options.drawerWidth,
          hideScrollbars = options.hideScrollbars,
          isContained = options.isContained,
          mode = options.mode;
        if (hideScrollbars) {
          iframeStyles = {
            width: 'calc(100% + ' + (0, _scrollbarWidth2.default)() + 'px)'
          };
        }
        if (mode === POPUP) {
          iframeStyles = _extends({}, iframeStyles, {
            WebkitMaskImage: '-webkit-radial-gradient(circle, white, black)',
            WebkitTransform: 'translateZ(0)'
          });
        }
        var Wrapper = this.getWrapperComponent(mode);
        var CloseImage = this.getCloseImage(mode);
        return _react2.default.createElement(Overlay, {
          appearing: this.state.popupAnimate,
          isContained: isContained
        }, _react2.default.createElement(_spinner2.default, {
          stopped: this.state.iframeLoaded
        }), _react2.default.createElement(Wrapper, {
          'data-qa': 'popup-mode-' + mode,
          innerRef: this.getWrapperRef,
          isContained: isContained,
          mode: mode,
          onTransitionEnd: this.handleTransitionEnd,
          open: this.state.frameAnimate,
          width: drawerWidth
        }, this.state.iframeLoaded && _react2.default.createElement(CloseImage, {
          alt: 'close-typeform',
          'data-qa': 'popup-close-button',
          mode: mode,
          onClick: this.animateBeforeClose,
          src: _close2.default
        }), _react2.default.createElement(_iframe2.default, {
          onLoad: this.handleIframeLoad,
          src: this.props.url,
          style: iframeStyles
        })));
      }
    }]);
    return Popup;
  }(_react.Component);
  Popup.propTypes = {
    url: _propTypes2.default.string.isRequired,
    options: _propTypes2.default.object.isRequired,
    onClose: _propTypes2.default.func,
    width: _propTypes2.default.number,
    height: _propTypes2.default.number
  };
  exports.default = Popup;

  /***/
}), ( /* 45 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  function memoize(fn) {
    var cache = {};
    return function (arg) {
      if (cache[arg] === undefined) cache[arg] = fn(arg);
      return cache[arg];
    };
  }

  /* harmony default export */
  __webpack_exports__["a"] = memoize;

  /***/
}), ( /* 46 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _react = __webpack_require__(2);
  var _react2 = _interopRequireDefault(_react);
  var _propTypes = __webpack_require__(4);
  var _propTypes2 = _interopRequireDefault(_propTypes);
  var _styles = __webpack_require__(17);
  var _styles2 = _interopRequireDefault(_styles);
  var _closeIcon = __webpack_require__(96);
  var _closeIcon2 = _interopRequireDefault(_closeIcon);
  var _iframe = __webpack_require__(26);
  var _iframe2 = _interopRequireDefault(_iframe);
  var _dataService = __webpack_require__(47);
  var _dataService2 = _interopRequireDefault(_dataService);
  var _store = __webpack_require__(48);
  var _store2 = _interopRequireDefault(_store);
  var _utils = __webpack_require__(9);
  var _popup = __webpack_require__(44);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var DOMAIN = 'admin.typeform.com';
  var TYPE = 'popup';
  var Wrapper = /*#__PURE__*/(0, _styles2.default)('div', {
    target: 'e4550h40'
  })('visibility:', function (p) {
    return p.open ? 'visible' : 'hidden';
  }, ';opacity:', function (p) {
    return p.open ? 1 : 0;
  }, ';background-color:', function (p) {
    return p.backgroundColor;
  }, ';position:fixed !important;z-index:1000;left:0 !important;right:0 !important;top:0 !important;bottom:0 !important;overflow:hidden !important;height:100%;transition:all 400ms ease ', function (props) {
    return props.openDelay;
  }, 's;');
  (0, _styles.injectGlobal)('.__typeform-embed-mobile-modal-open{overflow:hidden !important;position:fixed !important;top:0 !important;left:0 !important;right:0 !important;bottom:0 !important;}');
  var MobileModal = function (_Component) {
    _inherits(MobileModal, _Component);
    function MobileModal(props) {
      _classCallCheck(this, MobileModal);
      var _this = _possibleConstructorReturn(this, (MobileModal.__proto__ || Object.getPrototypeOf(MobileModal)).call(this, props));
      _this.state = {
        backgroundColor: 'transparent',
        buttonColor: '#FFF'
      };
      _this.onAutoClose = _this.onAutoClose.bind(_this);
      _this.onFormSubmit = _this.onFormSubmit.bind(_this);
      _this.close = _this.close.bind(_this);
      return _this;
    }
    _createClass(MobileModal, [{
      key: 'onAutoClose',
      value: function onAutoClose(e) {
        var _this2 = this;
        var _e$detail$canSetAutoc = e.detail.canSetAutocloseDelay,
          canSetAutocloseDelay = _e$detail$canSetAutoc === undefined ? true : _e$detail$canSetAutoc;
        var _props = this.props,
          isAutoCloseEnabled = _props.isAutoCloseEnabled,
          autoClose = _props.autoClose;
        var timeout = (canSetAutocloseDelay ? autoClose : _popup.DEFAULT_AUTOCLOSE_TIMEOUT) * 1000;
        if (isAutoCloseEnabled) {
          setTimeout(function () {
            _this2.close();
          }, timeout);
        }
      }
    }, {
      key: 'onFormSubmit',
      value: function onFormSubmit() {
        var onSubmit = this.props.onSubmit;
        onSubmit && onSubmit();
      }
    }, {
      key: 'componentWillMount',
      value: function componentWillMount() {
        var _this3 = this;
        var uid = _dataService2.default.getUidFromURL(this.props.url);
        _dataService2.default.getFormData(uid, DOMAIN).then(function (data) {
          return (0, _store2.default)(uid, TYPE, _this3.props.url, _this3.props.buttonText, data);
        }).then(function (_ref) {
          var form = _ref.form;
          _this3.setState({
            backgroundColor: '#' + form['background-color'],
            buttonColor: '#' + form['button-color']
          });
        });
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        window.addEventListener('message', _utils.onMessage);
        window.addEventListener('embed-auto-close-popup', this.onAutoClose);
        window.addEventListener('form-submit', this.onFormSubmit);
        if (this.props.open) {
          this.open();
        }
      }
    }, {
      key: 'open',
      value: function open() {
        var _this4 = this;
        setTimeout(function () {
          _this4.originalBodyScrollTop = window.document.body.scrollTop;
          document.body.classList.add('__typeform-embed-mobile-modal-open');
        }, this.props.openDelay * 1000 + 500);
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (!prevProps.open && this.props.open) {
          this.open();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        window.removeEventListener('message', _utils.onMessage);
        window.removeEventListener('embed-auto-close-popup', this.onAutoClose);
        window.removeEventListener('form-submit', this.onFormSubmit);
        document.body.classList.remove('__typeform-embed-mobile-modal-open');
      }
    }, {
      key: 'close',
      value: function close() {
        var _this5 = this;
        document.body.classList.remove('__typeform-embed-mobile-modal-open');
        setTimeout(function () {
          window.document.body.scrollTop = _this5.originalBodyScrollTop;
        }, 40);
        if (this.props.onClose) {
          this.props.onClose();
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _props2 = this.props,
          url = _props2.url,
          open = _props2.open;
        var _state = this.state,
          backgroundColor = _state.backgroundColor,
          buttonColor = _state.buttonColor;
        return _react2.default.createElement(Wrapper, {
          backgroundColor: backgroundColor,
          'data-qa': 'mobile-modal',
          open: open,
          openDelay: this.props.openDelay
        }, open && _react2.default.createElement(_iframe2.default, {
          src: url
        }), _react2.default.createElement(_closeIcon2.default, {
          color: buttonColor,
          dataQa: 'close-button-mobile',
          onClick: this.close
        }));
      }
    }]);
    return MobileModal;
  }(_react.Component);
  MobileModal.propTypes = {
    url: _propTypes2.default.string,
    open: _propTypes2.default.bool,
    isAutoCloseEnabled: _propTypes2.default.bool,
    buttonText: _propTypes2.default.string,
    onClose: _propTypes2.default.func,
    onSubmit: _propTypes2.default.func,
    autoClose: _propTypes2.default.number,
    openDelay: _propTypes2.default.number
  };
  MobileModal.defaultProps = {
    open: false,
    openDelay: 0,
    autoClose: null
  };
  exports.default = MobileModal;

  /***/
}), ( /* 47 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _fetchJsonp = __webpack_require__(97);
  var _fetchJsonp2 = _interopRequireDefault(_fetchJsonp);
  var _urlParse = __webpack_require__(43);
  var _urlParse2 = _interopRequireDefault(_urlParse);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  var DataService = {
    generateURL: function generateURL(uid, domain) {
      return 'https://' + domain + '/app/embed/' + uid + '?jsoncallback=?';
    },
    getFormData: function getFormData(uid, domain) {
      var url = this.generateURL(uid, domain);
      return (0, _fetchJsonp2.default)(url, {
        jsonpCallback: 'jsoncallback'
      }).then(function (res) {
        return res.json();
      });
    },
    getAccountFromURL: function getAccountFromURL(url) {
      return url.split('/')[2].split('.')[0];
    },
    getUidFromURL: function getUidFromURL(url) {
      var _UrlParse = (0, _urlParse2.default)(url, true),
        pathname = _UrlParse.pathname,
        query = _UrlParse.query;
      var path = pathname.replace(/\/$/, ''); // remove trailing slash
      var uid = path.replace(/\/to\/(.+)$/, '$1');
      if (uid === '/renderer') {
        return query.uid;
      }
      return uid;
    },
    getDomainFromUrl: function getDomainFromUrl(url) {
      return url.split('/')[2];
    },
    getDOMElementData: function getDOMElementData($element) {
      return {
        url: $element.data('url'),
        text: $element.data('text')
      };
    }
  };
  exports.default = DataService;

  /***/
}), ( /* 48 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _mobileDetection = __webpack_require__(16);
  var defaultData = {
    'account-name': 'admin',
    name: 'Typeform',
    'welcome-image': '',
    'font-google': '',
    'primary-color': '#222',
    'background-image': '',
    'background-color': '#DDD',
    'background-repeat': '',
    'background-brightness': '',
    'button-color': '#AAA'
  };
  var store = function store(uid, type, url, buttonText) {
    var data = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : defaultData;
    return {
      isMobile: (0, _mobileDetection.isMobile)(navigator.userAgent),
      'account-name': data['account-name'] || 'admin',
      type: type,
      form: {
        uid: uid,
        url: url,
        ready: false,
        // not implemented
        buttonText: buttonText,
        name: data['name'] || '',
        'welcome-image': data['welcome-image'],
        'font-google': data['font-google'],
        'primary-color': data['primary-color'],
        'background-image': data['background-image'],
        'background-color': data['background-color'],
        'background-repeat': data['background-repeat'],
        'background-brightness': data['background-brightness'],
        'button-color': data['button-color']
      }
    };
  };
  exports.default = store;

  /***/
}), ( /* 49 */
/***/function (module, exports, __webpack_require__) {
  // 19.1.2.14 / 15.2.3.14 Object.keys(O)
  var internalObjectKeys = __webpack_require__(50);
  var enumBugKeys = __webpack_require__(32);
  module.exports = Object.keys || function keys(O) {
    return internalObjectKeys(O, enumBugKeys);
  };

  /***/
}), ( /* 50 */
/***/function (module, exports, __webpack_require__) {
  var has = __webpack_require__(7);
  var toIndexedObject = __webpack_require__(18);
  var arrayIndexOf = __webpack_require__(103)(false);
  var hiddenKeys = __webpack_require__(31);
  module.exports = function (object, names) {
    var O = toIndexedObject(object);
    var i = 0;
    var result = [];
    var key;
    for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while (names.length > i) if (has(O, key = names[i++])) {
      ~arrayIndexOf(result, key) || result.push(key);
    }
    return result;
  };

  /***/
}), ( /* 51 */
/***/function (module, exports) {
  exports.f = Object.getOwnPropertySymbols;

  /***/
}), ( /* 52 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
  var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

  // Nashorn ~ JDK8 bug
  var NASHORN_BUG = nativeGetOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({
    1: 2
  }, 1);
  exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = nativeGetOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
  } : nativePropertyIsEnumerable;

  /***/
}), ( /* 53 */
/***/function (module, exports, __webpack_require__) {
  // 7.1.1 ToPrimitive(input [, PreferredType])
  var isObject = __webpack_require__(5);
  // instead of the ES6 spec version, we didn't implement @@toPrimitive case
  // and the second argument - flag - preferred type is a string
  module.exports = function (it, S) {
    if (!isObject(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
  };

  /***/
}), ( /* 54 */
/***/function (module, exports, __webpack_require__) {
  // Thank's IE8 for his funny defineProperty
  module.exports = !__webpack_require__(13) && !__webpack_require__(10)(function () {
    return Object.defineProperty(__webpack_require__(36)('div'), 'a', {
      get: function () {
        return 7;
      }
    }).a != 7;
  });

  /***/
}), ( /* 55 */
/***/function (module, exports, __webpack_require__) {
  module.exports = __webpack_require__(20)('native-function-to-string', Function.toString);

  /***/
}), ( /* 56 */
/***/function (module, exports) {
  var id = 0;
  var postfix = Math.random();
  module.exports = function (key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + postfix).toString(36));
  };

  /***/
}), ( /* 57 */
/***/function (module, exports, __webpack_require__) {
  var fails = __webpack_require__(10);
  var replacement = /#|\.prototype\./;
  var isForced = function (feature, detection) {
    var value = data[normalize(feature)];
    return value == POLYFILL ? true : value == NATIVE ? false : typeof detection == 'function' ? fails(detection) : !!detection;
  };
  var normalize = isForced.normalize = function (string) {
    return String(string).replace(replacement, '.').toLowerCase();
  };
  var data = isForced.data = {};
  var NATIVE = isForced.NATIVE = 'N';
  var POLYFILL = isForced.POLYFILL = 'P';
  module.exports = isForced;

  /***/
}), ( /* 58 */
/***/function (module, exports, __webpack_require__) {
  var UNSCOPABLES = __webpack_require__(1)('unscopables');
  var create = __webpack_require__(59);
  var hide = __webpack_require__(8);
  var ArrayPrototype = Array.prototype;

  // Array.prototype[@@unscopables]
  // https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
  if (ArrayPrototype[UNSCOPABLES] == undefined) {
    hide(ArrayPrototype, UNSCOPABLES, create(null));
  }

  // add a key to Array.prototype[@@unscopables]
  module.exports = function (key) {
    ArrayPrototype[UNSCOPABLES][key] = true;
  };

  /***/
}), ( /* 59 */
/***/function (module, exports, __webpack_require__) {
  // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
  var anObject = __webpack_require__(6);
  var defineProperties = __webpack_require__(114);
  var enumBugKeys = __webpack_require__(32);
  var html = __webpack_require__(60);
  var documentCreateElement = __webpack_require__(36);
  var IE_PROTO = __webpack_require__(38)('IE_PROTO');
  var PROTOTYPE = 'prototype';
  var Empty = function () {/* empty */};

  // Create object with fake `null` prototype: use iframe Object with cleared prototype
  var createDict = function () {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = documentCreateElement('iframe');
    var length = enumBugKeys.length;
    var lt = '<';
    var script = 'script';
    var gt = '>';
    var js = 'java' + script + ':';
    var iframeDocument;
    iframe.style.display = 'none';
    html.appendChild(iframe);
    iframe.src = String(js);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + script + gt + 'document.F=Object' + lt + '/' + script + gt);
    iframeDocument.close();
    createDict = iframeDocument.F;
    while (length--) delete createDict[PROTOTYPE][enumBugKeys[length]];
    return createDict();
  };
  module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
      Empty[PROTOTYPE] = anObject(O);
      result = new Empty();
      Empty[PROTOTYPE] = null;
      // add "__proto__" for Object.getPrototypeOf polyfill
      result[IE_PROTO] = O;
    } else result = createDict();
    return Properties === undefined ? result : defineProperties(result, Properties);
  };
  __webpack_require__(31)[IE_PROTO] = true;

  /***/
}), ( /* 60 */
/***/function (module, exports, __webpack_require__) {
  var document = __webpack_require__(0).document;
  module.exports = document && document.documentElement;

  /***/
}), ( /* 61 */
/***/function (module, exports, __webpack_require__) {
  var classofRaw = __webpack_require__(11);
  var TO_STRING_TAG = __webpack_require__(1)('toStringTag');
  // ES3 wrong here
  var CORRECT_ARGUMENTS = classofRaw(function () {
    return arguments;
  }()) == 'Arguments';

  // fallback for IE11 Script Access Denied error
  var tryGet = function (it, key) {
    try {
      return it[key];
    } catch (error) {/* empty */}
  };

  // getting tag from ES6+ `Object.prototype.toString`
  module.exports = function (it) {
    var O, tag, result;
    return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
  };

  /***/
}), ( /* 62 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var $export = __webpack_require__(12);
  var createIteratorConstructor = __webpack_require__(122);
  var getPrototypeOf = __webpack_require__(64);
  var setPrototypeOf = __webpack_require__(124);
  var setToStringTag = __webpack_require__(40);
  var hide = __webpack_require__(8);
  var redefine = __webpack_require__(19);
  var IS_PURE = __webpack_require__(21);
  var ITERATOR = __webpack_require__(1)('iterator');
  var Iterators = __webpack_require__(15);
  var IteratorsCore = __webpack_require__(63);
  var IteratorPrototype = IteratorsCore.IteratorPrototype;
  var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
  var KEYS = 'keys';
  var VALUES = 'values';
  var ENTRIES = 'entries';
  var returnThis = function () {
    return this;
  };
  module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    createIteratorConstructor(IteratorConstructor, NAME, next);
    var getIterationMethod = function (KIND) {
      if (KIND === DEFAULT && defaultIterator) return defaultIterator;
      if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
      switch (KIND) {
        case KEYS:
          return function keys() {
            return new IteratorConstructor(this, KIND);
          };
        case VALUES:
          return function values() {
            return new IteratorConstructor(this, KIND);
          };
        case ENTRIES:
          return function entries() {
            return new IteratorConstructor(this, KIND);
          };
      }
      return function () {
        return new IteratorConstructor(this);
      };
    };
    var TO_STRING_TAG = NAME + ' Iterator';
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[ITERATOR] || IterablePrototype['@@iterator'] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;

    // fix native
    if (anyNativeIterator) {
      CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
      if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
        if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
          if (setPrototypeOf) {
            setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
          } else if (typeof CurrentIteratorPrototype[ITERATOR] != 'function') {
            hide(CurrentIteratorPrototype, ITERATOR, returnThis);
          }
        }
        // Set @@toStringTag to native iterators
        setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
        if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
      }
    }

    // fix Array#{values, @@iterator}.name in V8 / FF
    if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() {
        return nativeIterator.call(this);
      };
    }

    // define iterator
    if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
      hide(IterablePrototype, ITERATOR, defaultIterator);
    }
    Iterators[NAME] = defaultIterator;

    // export additional methods
    if (DEFAULT) {
      methods = {
        values: getIterationMethod(VALUES),
        keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
        entries: getIterationMethod(ENTRIES)
      };
      if (FORCED) for (KEY in methods) {
        if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
          redefine(IterablePrototype, KEY, methods[KEY]);
        }
      } else $export({
        target: NAME,
        proto: true,
        forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
      }, methods);
    }
    return methods;
  };

  /***/
}), ( /* 63 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var getPrototypeOf = __webpack_require__(64);
  var hide = __webpack_require__(8);
  var has = __webpack_require__(7);
  var IS_PURE = __webpack_require__(21);
  var ITERATOR = __webpack_require__(1)('iterator');
  var BUGGY_SAFARI_ITERATORS = false;
  var returnThis = function () {
    return this;
  };

  // `%IteratorPrototype%` object
  // https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
  var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;
  if ([].keys) {
    arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;else {
      PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
      if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
    }
  }
  if (IteratorPrototype == undefined) IteratorPrototype = {};

  // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
  if (!IS_PURE && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
  module.exports = {
    IteratorPrototype: IteratorPrototype,
    BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
  };

  /***/
}), ( /* 64 */
/***/function (module, exports, __webpack_require__) {
  // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
  var has = __webpack_require__(7);
  var toObject = __webpack_require__(33);
  var IE_PROTO = __webpack_require__(38)('IE_PROTO');
  var CORRECT_PROTOTYPE_GETTER = __webpack_require__(123);
  var ObjectPrototype = Object.prototype;
  module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
    O = toObject(O);
    if (has(O, IE_PROTO)) return O[IE_PROTO];
    if (typeof O.constructor == 'function' && O instanceof O.constructor) {
      return O.constructor.prototype;
    }
    return O instanceof Object ? ObjectPrototype : null;
  };

  /***/
}), ( /* 65 */
/***/function (module, exports, __webpack_require__) {
  var anObject = __webpack_require__(6);
  var aFunction = __webpack_require__(23);
  var SPECIES = __webpack_require__(1)('species');

  // `SpeciesConstructor` abstract operation
  // https://tc39.github.io/ecma262/#sec-speciesconstructor
  module.exports = function (O, defaultConstructor) {
    var C = anObject(O).constructor;
    var S;
    return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aFunction(S);
  };

  /***/
}), ( /* 66 */
/***/function (module, exports, __webpack_require__) {
  var global = __webpack_require__(0);
  var classof = __webpack_require__(11);
  var bind = __webpack_require__(39);
  var html = __webpack_require__(60);
  var createElement = __webpack_require__(36);
  var set = global.setImmediate;
  var clear = global.clearImmediate;
  var process = global.process;
  var MessageChannel = global.MessageChannel;
  var Dispatch = global.Dispatch;
  var counter = 0;
  var queue = {};
  var ONREADYSTATECHANGE = 'onreadystatechange';
  var defer, channel, port;
  var run = function () {
    var id = +this;
    // eslint-disable-next-line no-prototype-builtins
    if (queue.hasOwnProperty(id)) {
      var fn = queue[id];
      delete queue[id];
      fn();
    }
  };
  var listener = function (event) {
    run.call(event.data);
  };

  // Node.js 0.9+ & IE10+ has setImmediate, otherwise:
  if (!set || !clear) {
    set = function setImmediate(fn) {
      var args = [];
      var i = 1;
      while (arguments.length > i) args.push(arguments[i++]);
      queue[++counter] = function () {
        // eslint-disable-next-line no-new-func
        (typeof fn == 'function' ? fn : Function(fn)).apply(undefined, args);
      };
      defer(counter);
      return counter;
    };
    clear = function clearImmediate(id) {
      delete queue[id];
    };
    // Node.js 0.8-
    if (classof(process) == 'process') {
      defer = function (id) {
        process.nextTick(bind(run, id, 1));
      };
      // Sphere (JS game engine) Dispatch API
    } else if (Dispatch && Dispatch.now) {
      defer = function (id) {
        Dispatch.now(bind(run, id, 1));
      };
      // Browsers with MessageChannel, includes WebWorkers
    } else if (MessageChannel) {
      channel = new MessageChannel();
      port = channel.port2;
      channel.port1.onmessage = listener;
      defer = bind(port.postMessage, port, 1);
      // Browsers with postMessage, skip WebWorkers
      // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
      defer = function (id) {
        global.postMessage(id + '', '*');
      };
      global.addEventListener('message', listener, false);
      // IE8-
    } else if (ONREADYSTATECHANGE in createElement('script')) {
      defer = function (id) {
        html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
          html.removeChild(this);
          run.call(id);
        };
      };
      // Rest old browsers
    } else {
      defer = function (id) {
        setTimeout(bind(run, id, 1), 0);
      };
    }
  }
  module.exports = {
    set: set,
    clear: clear
  };

  /***/
}), ( /* 67 */
/***/function (module, exports, __webpack_require__) {
  var global = __webpack_require__(0);
  var navigator = global.navigator;
  module.exports = navigator && navigator.userAgent || '';

  /***/
}), ( /* 68 */
/***/function (module, exports, __webpack_require__) {
  var anObject = __webpack_require__(6);
  var isObject = __webpack_require__(5);
  var newPromiseCapability = __webpack_require__(69);
  module.exports = function (C, x) {
    anObject(C);
    if (isObject(x) && x.constructor === C) return x;
    var promiseCapability = newPromiseCapability.f(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
  };

  /***/
}), ( /* 69 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  // 25.4.1.5 NewPromiseCapability(C)
  var aFunction = __webpack_require__(23);
  var PromiseCapability = function (C) {
    var resolve, reject;
    this.promise = new C(function ($$resolve, $$reject) {
      if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
      resolve = $$resolve;
      reject = $$reject;
    });
    this.resolve = aFunction(resolve);
    this.reject = aFunction(reject);
  };
  module.exports.f = function (C) {
    return new PromiseCapability(C);
  };

  /***/
}), ( /* 70 */
/***/function (module, exports, __webpack_require__) {
  var path = __webpack_require__(41);
  var global = __webpack_require__(0);
  var aFunction = function (variable) {
    return typeof variable == 'function' ? variable : undefined;
  };
  module.exports = function (namespace, method) {
    return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace]) : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
  };

  /***/
}), ( /* 71 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.makeFullScreen = exports.makeWidget = exports.makePopup = undefined;
  var _makePopup = __webpack_require__(72);
  var _makePopup2 = _interopRequireDefault(_makePopup);
  var _makeWidget = __webpack_require__(98);
  var _makeWidget2 = _interopRequireDefault(_makeWidget);
  var _makeFullScreen = __webpack_require__(100);
  var _makeFullScreen2 = _interopRequireDefault(_makeFullScreen);
  __webpack_require__(101);
  __webpack_require__(109);
  __webpack_require__(115);
  __webpack_require__(117);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  exports.makePopup = _makePopup2.default;
  exports.makeWidget = _makeWidget2.default;
  exports.makeFullScreen = _makeFullScreen2.default;

  /***/
}), ( /* 72 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  exports.default = makePopup;
  var _react = __webpack_require__(2);
  var _react2 = _interopRequireDefault(_react);
  var _reactDom = __webpack_require__(2);
  var _utils = __webpack_require__(9);
  var _mobileDetection = __webpack_require__(16);
  var _popup = __webpack_require__(44);
  var _popup2 = _interopRequireDefault(_popup);
  var _mobileModal = __webpack_require__(46);
  var _mobileModal2 = _interopRequireDefault(_mobileModal);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  var DEFAULT_DRAWER_WIDTH = 800;
  var defaultOptions = {
    mode: _popup.POPUP,
    autoOpen: false,
    isModalOpen: false,
    autoClose: _popup.DEFAULT_AUTOCLOSE_TIMEOUT,
    hideFooter: false,
    hideHeaders: false,
    hideScrollbars: false,
    disableTracking: false,
    drawerWidth: DEFAULT_DRAWER_WIDTH,
    onSubmit: _utils.noop
  };
  var queryStringKeys = {
    embedType: 'typeform-embed',
    hideFooter: 'embed-hide-footer',
    hideHeaders: 'embed-hide-headers',
    disableTracking: 'disable-tracking'
  };
  var renderComponent = function renderComponent(url, domNode, options, onClose) {
    var urlWithQueryString = (0, _utils.appendParamsToUrl)(url, (0, _utils.replaceExistingKeys)(options, queryStringKeys));
    if (!(0, _mobileDetection.isMobile)(navigator.userAgent) && (0, _mobileDetection.isScreenBig)()) {
      (0, _reactDom.render)(_react2.default.createElement(_popup2.default, {
        onClose: onClose,
        options: options,
        url: urlWithQueryString
      }), domNode);
    } else {
      (0, _utils.ensureMetaViewport)();
      (0, _reactDom.render)(_react2.default.createElement(_mobileModal2.default, {
        autoClose: options.autoClose,
        buttonText: options.buttonText,
        isAutoCloseEnabled: options.isAutoCloseEnabled,
        onClose: onClose,
        onSubmit: options.onSubmit,
        open: true,
        url: urlWithQueryString
      }), domNode);
    }
  };
  function makePopup(url, options) {
    options = _extends({}, defaultOptions, options, {
      isAutoCloseEnabled: options.autoClose !== undefined,
      embedType: _popup.POPUP_MODES[options.mode]
    });
    if (!Number.isSafeInteger(options.drawerWidth)) {
      throw new Error('Whoops! You provided an invalid \'drawerWidth\' option: "' + options.drawerWidth + '". It must be a number.');
    }
    var domNode = document.createElement('div');
    options.isContained = options.container !== undefined;
    options.container = options.container || document.body;
    options.container.appendChild(domNode);
    var popup = {
      open: function open() {
        renderComponent(url, domNode, options, this.close);
      },
      close: function close() {
        window.postMessage('form-close', '*');
        (0, _reactDom.unmountComponentAtNode)(domNode);
      }
    };
    if (options.autoOpen) {
      popup.open();
    }
    return popup;
  }

  /***/
}), ( /* 73 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  /** @license React v16.8.1
   * react-is.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  Object.defineProperty(exports, "__esModule", {
    value: !0
  });
  var b = "function" === typeof Symbol && Symbol.for,
    c = b ? Symbol.for("react.element") : 60103,
    d = b ? Symbol.for("react.portal") : 60106,
    e = b ? Symbol.for("react.fragment") : 60107,
    f = b ? Symbol.for("react.strict_mode") : 60108,
    g = b ? Symbol.for("react.profiler") : 60114,
    h = b ? Symbol.for("react.provider") : 60109,
    k = b ? Symbol.for("react.context") : 60110,
    l = b ? Symbol.for("react.async_mode") : 60111,
    m = b ? Symbol.for("react.concurrent_mode") : 60111,
    n = b ? Symbol.for("react.forward_ref") : 60112,
    p = b ? Symbol.for("react.suspense") : 60113,
    q = b ? Symbol.for("react.memo") : 60115,
    r = b ? Symbol.for("react.lazy") : 60116;
  function t(a) {
    if ("object" === typeof a && null !== a) {
      var u = a.$$typeof;
      switch (u) {
        case c:
          switch (a = a.type, a) {
            case l:
            case m:
            case e:
            case g:
            case f:
            case p:
              return a;
            default:
              switch (a = a && a.$$typeof, a) {
                case k:
                case n:
                case h:
                  return a;
                default:
                  return u;
              }
          }
        case r:
        case q:
        case d:
          return u;
      }
    }
  }
  function v(a) {
    return t(a) === m;
  }
  exports.typeOf = t;
  exports.AsyncMode = l;
  exports.ConcurrentMode = m;
  exports.ContextConsumer = k;
  exports.ContextProvider = h;
  exports.Element = c;
  exports.ForwardRef = n;
  exports.Fragment = e;
  exports.Lazy = r;
  exports.Memo = q;
  exports.Portal = d;
  exports.Profiler = g;
  exports.StrictMode = f;
  exports.Suspense = p;
  exports.isValidElementType = function (a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || "object" === typeof a && null !== a && (a.$$typeof === r || a.$$typeof === q || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n);
  };
  exports.isAsyncMode = function (a) {
    return v(a) || t(a) === l;
  };
  exports.isConcurrentMode = v;
  exports.isContextConsumer = function (a) {
    return t(a) === k;
  };
  exports.isContextProvider = function (a) {
    return t(a) === h;
  };
  exports.isElement = function (a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
  };
  exports.isForwardRef = function (a) {
    return t(a) === n;
  };
  exports.isFragment = function (a) {
    return t(a) === e;
  };
  exports.isLazy = function (a) {
    return t(a) === r;
  };
  exports.isMemo = function (a) {
    return t(a) === q;
  };
  exports.isPortal = function (a) {
    return t(a) === d;
  };
  exports.isProfiler = function (a) {
    return t(a) === g;
  };
  exports.isStrictMode = function (a) {
    return t(a) === f;
  };
  exports.isSuspense = function (a) {
    return t(a) === p;
  };

  /***/
}), ( /* 74 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  /* WEBPACK VAR INJECTION */
  (function (process) {
    /** @license React v16.8.1
    * react-is.development.js
    *
    * Copyright (c) Facebook, Inc. and its affiliates.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    */

    if (process.env.NODE_ENV !== "production") {
      (function () {
        'use strict';

        Object.defineProperty(exports, '__esModule', {
          value: true
        });

        // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
        // nor polyfill, then a plain number is used for performance.
        var hasSymbol = typeof Symbol === 'function' && Symbol.for;
        var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
        var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
        var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
        var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
        var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
        var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
        var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace;
        var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
        var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
        var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
        var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
        var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
        var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
        function isValidElementType(type) {
          return typeof type === 'string' || typeof type === 'function' ||
          // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
          type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE);
        }

        /**
         * Forked from fbjs/warning:
         * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
         *
         * Only change is we use console.warn instead of console.error,
         * and do nothing when 'console' is not supported.
         * This really simplifies the code.
         * ---
         * Similar to invariant but only logs a warning if the condition is not met.
         * This can be used to log issues in development environments in critical
         * paths. Removing the logging code for production environments will keep the
         * same logic and follow the same code paths.
         */

        var lowPriorityWarning = function () {};
        {
          var printWarning = function (format) {
            for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              args[_key - 1] = arguments[_key];
            }
            var argIndex = 0;
            var message = 'Warning: ' + format.replace(/%s/g, function () {
              return args[argIndex++];
            });
            if (typeof console !== 'undefined') {
              console.warn(message);
            }
            try {
              // --- Welcome to debugging React ---
              // This error was thrown as a convenience so that you can use this stack
              // to find the callsite that caused this warning to fire.
              throw new Error(message);
            } catch (x) {}
          };
          lowPriorityWarning = function (condition, format) {
            if (format === undefined) {
              throw new Error('`lowPriorityWarning(condition, format, ...args)` requires a warning ' + 'message argument');
            }
            if (!condition) {
              for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
                args[_key2 - 2] = arguments[_key2];
              }
              printWarning.apply(undefined, [format].concat(args));
            }
          };
        }
        var lowPriorityWarning$1 = lowPriorityWarning;
        function typeOf(object) {
          if (typeof object === 'object' && object !== null) {
            var $$typeof = object.$$typeof;
            switch ($$typeof) {
              case REACT_ELEMENT_TYPE:
                var type = object.type;
                switch (type) {
                  case REACT_ASYNC_MODE_TYPE:
                  case REACT_CONCURRENT_MODE_TYPE:
                  case REACT_FRAGMENT_TYPE:
                  case REACT_PROFILER_TYPE:
                  case REACT_STRICT_MODE_TYPE:
                  case REACT_SUSPENSE_TYPE:
                    return type;
                  default:
                    var $$typeofType = type && type.$$typeof;
                    switch ($$typeofType) {
                      case REACT_CONTEXT_TYPE:
                      case REACT_FORWARD_REF_TYPE:
                      case REACT_PROVIDER_TYPE:
                        return $$typeofType;
                      default:
                        return $$typeof;
                    }
                }
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PORTAL_TYPE:
                return $$typeof;
            }
          }
          return undefined;
        }

        // AsyncMode is deprecated along with isAsyncMode
        var AsyncMode = REACT_ASYNC_MODE_TYPE;
        var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
        var ContextConsumer = REACT_CONTEXT_TYPE;
        var ContextProvider = REACT_PROVIDER_TYPE;
        var Element = REACT_ELEMENT_TYPE;
        var ForwardRef = REACT_FORWARD_REF_TYPE;
        var Fragment = REACT_FRAGMENT_TYPE;
        var Lazy = REACT_LAZY_TYPE;
        var Memo = REACT_MEMO_TYPE;
        var Portal = REACT_PORTAL_TYPE;
        var Profiler = REACT_PROFILER_TYPE;
        var StrictMode = REACT_STRICT_MODE_TYPE;
        var Suspense = REACT_SUSPENSE_TYPE;
        var hasWarnedAboutDeprecatedIsAsyncMode = false;

        // AsyncMode should be deprecated
        function isAsyncMode(object) {
          {
            if (!hasWarnedAboutDeprecatedIsAsyncMode) {
              hasWarnedAboutDeprecatedIsAsyncMode = true;
              lowPriorityWarning$1(false, 'The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
            }
          }
          return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
        }
        function isConcurrentMode(object) {
          return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
        }
        function isContextConsumer(object) {
          return typeOf(object) === REACT_CONTEXT_TYPE;
        }
        function isContextProvider(object) {
          return typeOf(object) === REACT_PROVIDER_TYPE;
        }
        function isElement(object) {
          return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }
        function isForwardRef(object) {
          return typeOf(object) === REACT_FORWARD_REF_TYPE;
        }
        function isFragment(object) {
          return typeOf(object) === REACT_FRAGMENT_TYPE;
        }
        function isLazy(object) {
          return typeOf(object) === REACT_LAZY_TYPE;
        }
        function isMemo(object) {
          return typeOf(object) === REACT_MEMO_TYPE;
        }
        function isPortal(object) {
          return typeOf(object) === REACT_PORTAL_TYPE;
        }
        function isProfiler(object) {
          return typeOf(object) === REACT_PROFILER_TYPE;
        }
        function isStrictMode(object) {
          return typeOf(object) === REACT_STRICT_MODE_TYPE;
        }
        function isSuspense(object) {
          return typeOf(object) === REACT_SUSPENSE_TYPE;
        }
        exports.typeOf = typeOf;
        exports.AsyncMode = AsyncMode;
        exports.ConcurrentMode = ConcurrentMode;
        exports.ContextConsumer = ContextConsumer;
        exports.ContextProvider = ContextProvider;
        exports.Element = Element;
        exports.ForwardRef = ForwardRef;
        exports.Fragment = Fragment;
        exports.Lazy = Lazy;
        exports.Memo = Memo;
        exports.Portal = Portal;
        exports.Profiler = Profiler;
        exports.StrictMode = StrictMode;
        exports.Suspense = Suspense;
        exports.isValidElementType = isValidElementType;
        exports.isAsyncMode = isAsyncMode;
        exports.isConcurrentMode = isConcurrentMode;
        exports.isContextConsumer = isContextConsumer;
        exports.isContextProvider = isContextProvider;
        exports.isElement = isElement;
        exports.isForwardRef = isForwardRef;
        exports.isFragment = isFragment;
        exports.isLazy = isLazy;
        exports.isMemo = isMemo;
        exports.isPortal = isPortal;
        exports.isProfiler = isProfiler;
        exports.isStrictMode = isStrictMode;
        exports.isSuspense = isSuspense;
      })();
    }

    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(3));

  /***/
}), ( /* 75 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  /* WEBPACK VAR INJECTION */
  (function (process) {
    /**
    * Copyright (c) 2013-present, Facebook, Inc.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    */

    var ReactIs = __webpack_require__(42);
    var assign = __webpack_require__(76);
    var ReactPropTypesSecret = __webpack_require__(24);
    var checkPropTypes = __webpack_require__(77);
    var has = Function.call.bind(Object.prototype.hasOwnProperty);
    var printWarning = function () {};
    if (process.env.NODE_ENV !== 'production') {
      printWarning = function (text) {
        var message = 'Warning: ' + text;
        if (typeof console !== 'undefined') {
          console.error(message);
        }
        try {
          // --- Welcome to debugging React ---
          // This error was thrown as a convenience so that you can use this stack
          // to find the callsite that caused this warning to fire.
          throw new Error(message);
        } catch (x) {}
      };
    }
    function emptyFunctionThatReturnsNull() {
      return null;
    }
    module.exports = function (isValidElement, throwOnDirectAccess) {
      /* global Symbol */
      var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

      /**
       * Returns the iterator method function contained on the iterable object.
       *
       * Be sure to invoke the function with the iterable as context:
       *
       *     var iteratorFn = getIteratorFn(myIterable);
       *     if (iteratorFn) {
       *       var iterator = iteratorFn.call(myIterable);
       *       ...
       *     }
       *
       * @param {?object} maybeIterable
       * @return {?function}
       */
      function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === 'function') {
          return iteratorFn;
        }
      }

      /**
       * Collection of methods that allow declaration and validation of props that are
       * supplied to React components. Example usage:
       *
       *   var Props = require('ReactPropTypes');
       *   var MyArticle = React.createClass({
       *     propTypes: {
       *       // An optional string prop named "description".
       *       description: Props.string,
       *
       *       // A required enum prop named "category".
       *       category: Props.oneOf(['News','Photos']).isRequired,
       *
       *       // A prop named "dialog" that requires an instance of Dialog.
       *       dialog: Props.instanceOf(Dialog).isRequired
       *     },
       *     render: function() { ... }
       *   });
       *
       * A more formal specification of how these methods are used:
       *
       *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
       *   decl := ReactPropTypes.{type}(.isRequired)?
       *
       * Each and every declaration produces a function with the same signature. This
       * allows the creation of custom validation functions. For example:
       *
       *  var MyLink = React.createClass({
       *    propTypes: {
       *      // An optional string or URI prop named "href".
       *      href: function(props, propName, componentName) {
       *        var propValue = props[propName];
       *        if (propValue != null && typeof propValue !== 'string' &&
       *            !(propValue instanceof URI)) {
       *          return new Error(
       *            'Expected a string or an URI for ' + propName + ' in ' +
       *            componentName
       *          );
       *        }
       *      }
       *    },
       *    render: function() {...}
       *  });
       *
       * @internal
       */

      var ANONYMOUS = '<<anonymous>>';

      // Important!
      // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
      var ReactPropTypes = {
        array: createPrimitiveTypeChecker('array'),
        bool: createPrimitiveTypeChecker('boolean'),
        func: createPrimitiveTypeChecker('function'),
        number: createPrimitiveTypeChecker('number'),
        object: createPrimitiveTypeChecker('object'),
        string: createPrimitiveTypeChecker('string'),
        symbol: createPrimitiveTypeChecker('symbol'),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
      };

      /**
       * inlined Object.is polyfill to avoid requiring consumers ship their own
       * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
       */
      /*eslint-disable no-self-compare*/
      function is(x, y) {
        // SameValue algorithm
        if (x === y) {
          // Steps 1-5, 7-10
          // Steps 6.b-6.e: +0 != -0
          return x !== 0 || 1 / x === 1 / y;
        } else {
          // Step 6.a: NaN == NaN
          return x !== x && y !== y;
        }
      }
      /*eslint-enable no-self-compare*/

      /**
       * We use an Error-like object for backward compatibility as people may call
       * PropTypes directly and inspect their output. However, we don't use real
       * Errors anymore. We don't inspect their stack anyway, and creating them
       * is prohibitively expensive if they are created too often, such as what
       * happens in oneOfType() for any type before the one that matched.
       */
      function PropTypeError(message) {
        this.message = message;
        this.stack = '';
      }
      // Make `instanceof Error` still work for returned errors.
      PropTypeError.prototype = Error.prototype;
      function createChainableTypeChecker(validate) {
        if (process.env.NODE_ENV !== 'production') {
          var manualPropTypeCallCache = {};
          var manualPropTypeWarningCount = 0;
        }
        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
          componentName = componentName || ANONYMOUS;
          propFullName = propFullName || propName;
          if (secret !== ReactPropTypesSecret) {
            if (throwOnDirectAccess) {
              // New behavior only for users of `prop-types` package
              var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
              err.name = 'Invariant Violation';
              throw err;
            } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
              // Old behavior for people using React.PropTypes
              var cacheKey = componentName + ':' + propName;
              if (!manualPropTypeCallCache[cacheKey] &&
              // Avoid spamming the console because they are often not actionable except for lib authors
              manualPropTypeWarningCount < 3) {
                printWarning('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
                manualPropTypeCallCache[cacheKey] = true;
                manualPropTypeWarningCount++;
              }
            }
          }
          if (props[propName] == null) {
            if (isRequired) {
              if (props[propName] === null) {
                return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
              }
              return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
            }
            return null;
          } else {
            return validate(props, propName, componentName, location, propFullName);
          }
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
      }
      function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location, propFullName, secret) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== expectedType) {
            // `propValue` being instance of, say, date/regexp, pass the 'object'
            // check, but we can offer a more precise error message here rather than
            // 'of type `object`'.
            var preciseType = getPreciseType(propValue);
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createAnyTypeChecker() {
        return createChainableTypeChecker(emptyFunctionThatReturnsNull);
      }
      function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
          if (typeof typeChecker !== 'function') {
            return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
          }
          var propValue = props[propName];
          if (!Array.isArray(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
          }
          for (var i = 0; i < propValue.length; i++) {
            var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
            if (error instanceof Error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createElementTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          if (!isValidElement(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createElementTypeTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          if (!ReactIs.isValidElementType(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location, propFullName) {
          if (!(props[propName] instanceof expectedClass)) {
            var expectedClassName = expectedClass.name || ANONYMOUS;
            var actualClassName = getClassName(props[propName]);
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) {
          if (process.env.NODE_ENV !== 'production') {
            if (arguments.length > 1) {
              printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
            } else {
              printWarning('Invalid argument supplied to oneOf, expected an array.');
            }
          }
          return emptyFunctionThatReturnsNull;
        }
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          for (var i = 0; i < expectedValues.length; i++) {
            if (is(propValue, expectedValues[i])) {
              return null;
            }
          }
          var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
            if (getPropType(value) === 'symbol') {
              return String(value);
            }
            return value;
          });
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
        }
        return createChainableTypeChecker(validate);
      }
      function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
          if (typeof typeChecker !== 'function') {
            return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
          }
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== 'object') {
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
          }
          for (var key in propValue) {
            if (has(propValue, key)) {
              var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
              if (error instanceof Error) {
                return error;
              }
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) {
          process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
          return emptyFunctionThatReturnsNull;
        }
        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
          var checker = arrayOfTypeCheckers[i];
          if (typeof checker !== 'function') {
            printWarning('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
            return emptyFunctionThatReturnsNull;
          }
        }
        function validate(props, propName, componentName, location, propFullName) {
          for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
            var checker = arrayOfTypeCheckers[i];
            if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
              return null;
            }
          }
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
        }
        return createChainableTypeChecker(validate);
      }
      function createNodeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          if (!isNode(props[propName])) {
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== 'object') {
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
          }
          for (var key in shapeTypes) {
            var checker = shapeTypes[key];
            if (!checker) {
              continue;
            }
            var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
            if (error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== 'object') {
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
          }
          // We need to check all keys in case some are required but missing from
          // props.
          var allKeys = assign({}, props[propName], shapeTypes);
          for (var key in allKeys) {
            var checker = shapeTypes[key];
            if (!checker) {
              return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
            }
            var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
            if (error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function isNode(propValue) {
        switch (typeof propValue) {
          case 'number':
          case 'string':
          case 'undefined':
            return true;
          case 'boolean':
            return !propValue;
          case 'object':
            if (Array.isArray(propValue)) {
              return propValue.every(isNode);
            }
            if (propValue === null || isValidElement(propValue)) {
              return true;
            }
            var iteratorFn = getIteratorFn(propValue);
            if (iteratorFn) {
              var iterator = iteratorFn.call(propValue);
              var step;
              if (iteratorFn !== propValue.entries) {
                while (!(step = iterator.next()).done) {
                  if (!isNode(step.value)) {
                    return false;
                  }
                }
              } else {
                // Iterator will provide entry [k,v] tuples rather than values.
                while (!(step = iterator.next()).done) {
                  var entry = step.value;
                  if (entry) {
                    if (!isNode(entry[1])) {
                      return false;
                    }
                  }
                }
              }
            } else {
              return false;
            }
            return true;
          default:
            return false;
        }
      }
      function isSymbol(propType, propValue) {
        // Native Symbol.
        if (propType === 'symbol') {
          return true;
        }

        // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
        if (propValue['@@toStringTag'] === 'Symbol') {
          return true;
        }

        // Fallback for non-spec compliant Symbols which are polyfilled.
        if (typeof Symbol === 'function' && propValue instanceof Symbol) {
          return true;
        }
        return false;
      }

      // Equivalent of `typeof` but with special handling for array and regexp.
      function getPropType(propValue) {
        var propType = typeof propValue;
        if (Array.isArray(propValue)) {
          return 'array';
        }
        if (propValue instanceof RegExp) {
          // Old webkits (at least until Android 4.0) return 'function' rather than
          // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
          // passes PropTypes.object.
          return 'object';
        }
        if (isSymbol(propType, propValue)) {
          return 'symbol';
        }
        return propType;
      }

      // This handles more types than `getPropType`. Only used for error messages.
      // See `createPrimitiveTypeChecker`.
      function getPreciseType(propValue) {
        if (typeof propValue === 'undefined' || propValue === null) {
          return '' + propValue;
        }
        var propType = getPropType(propValue);
        if (propType === 'object') {
          if (propValue instanceof Date) {
            return 'date';
          } else if (propValue instanceof RegExp) {
            return 'regexp';
          }
        }
        return propType;
      }

      // Returns a string that is postfixed to a warning about an invalid type.
      // For example, "undefined" or "of type array"
      function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);
        switch (type) {
          case 'array':
          case 'object':
            return 'an ' + type;
          case 'boolean':
          case 'date':
          case 'regexp':
            return 'a ' + type;
          default:
            return type;
        }
      }

      // Returns class name of the object, if any.
      function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) {
          return ANONYMOUS;
        }
        return propValue.constructor.name;
      }
      ReactPropTypes.checkPropTypes = checkPropTypes;
      ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
      ReactPropTypes.PropTypes = ReactPropTypes;
      return ReactPropTypes;
    };

    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(3));

  /***/
}), ( /* 76 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  /*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */

  /* eslint-disable no-unused-vars */
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;
  function toObject(val) {
    if (val === null || val === undefined) {
      throw new TypeError('Object.assign cannot be called with null or undefined');
    }
    return Object(val);
  }
  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      }

      // Detect buggy property enumeration order in older V8 versions.

      // https://bugs.chromium.org/p/v8/issues/detail?id=4118
      var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
      test1[5] = 'de';
      if (Object.getOwnPropertyNames(test1)[0] === '5') {
        return false;
      }

      // https://bugs.chromium.org/p/v8/issues/detail?id=3056
      var test2 = {};
      for (var i = 0; i < 10; i++) {
        test2['_' + String.fromCharCode(i)] = i;
      }
      var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
        return test2[n];
      });
      if (order2.join('') !== '0123456789') {
        return false;
      }

      // https://bugs.chromium.org/p/v8/issues/detail?id=3056
      var test3 = {};
      'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
        test3[letter] = letter;
      });
      if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
        return false;
      }
      return true;
    } catch (err) {
      // We don't expect any of the above to throw, but better to be safe.
      return false;
    }
  }
  module.exports = shouldUseNative() ? Object.assign : function (target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for (var s = 1; s < arguments.length; s++) {
      from = Object(arguments[s]);
      for (var key in from) {
        if (hasOwnProperty.call(from, key)) {
          to[key] = from[key];
        }
      }
      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from);
        for (var i = 0; i < symbols.length; i++) {
          if (propIsEnumerable.call(from, symbols[i])) {
            to[symbols[i]] = from[symbols[i]];
          }
        }
      }
    }
    return to;
  };

  /***/
}), ( /* 77 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  /* WEBPACK VAR INJECTION */
  (function (process) {
    /**
    * Copyright (c) 2013-present, Facebook, Inc.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    */

    var printWarning = function () {};
    if (process.env.NODE_ENV !== 'production') {
      var ReactPropTypesSecret = __webpack_require__(24);
      var loggedTypeFailures = {};
      var has = Function.call.bind(Object.prototype.hasOwnProperty);
      printWarning = function (text) {
        var message = 'Warning: ' + text;
        if (typeof console !== 'undefined') {
          console.error(message);
        }
        try {
          // --- Welcome to debugging React ---
          // This error was thrown as a convenience so that you can use this stack
          // to find the callsite that caused this warning to fire.
          throw new Error(message);
        } catch (x) {}
      };
    }

    /**
     * Assert that the values match with the type specs.
     * Error messages are memorized and will only be shown once.
     *
     * @param {object} typeSpecs Map of name to a ReactPropType
     * @param {object} values Runtime values that need to be type-checked
     * @param {string} location e.g. "prop", "context", "child context"
     * @param {string} componentName Name of the component for error messages.
     * @param {?Function} getStack Returns the component stack.
     * @private
     */
    function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
      if (process.env.NODE_ENV !== 'production') {
        for (var typeSpecName in typeSpecs) {
          if (has(typeSpecs, typeSpecName)) {
            var error;
            // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
              // This is intentionally an invariant that gets caught. It's the same
              // behavior as without this statement except with a better message.
              if (typeof typeSpecs[typeSpecName] !== 'function') {
                var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.');
                err.name = 'Invariant Violation';
                throw err;
              }
              error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
            } catch (ex) {
              error = ex;
            }
            if (error && !(error instanceof Error)) {
              printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
            }
            if (error instanceof Error && !(error.message in loggedTypeFailures)) {
              // Only monitor this failure once because there tends to be a lot of the
              // same error.
              loggedTypeFailures[error.message] = true;
              var stack = getStack ? getStack() : '';
              printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
            }
          }
        }
      }
    }

    /**
     * Resets warning cache when testing.
     *
     * @private
     */
    checkPropTypes.resetWarningCache = function () {
      if (process.env.NODE_ENV !== 'production') {
        loggedTypeFailures = {};
      }
    };
    module.exports = checkPropTypes;

    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(3));

  /***/
}), ( /* 78 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var ReactPropTypesSecret = __webpack_require__(24);
  function emptyFunction() {}
  function emptyFunctionWithReset() {}
  emptyFunctionWithReset.resetWarningCache = emptyFunction;
  module.exports = function () {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        // It is still safe when called from React.
        return;
      }
      var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
      err.name = 'Invariant Violation';
      throw err;
    }
    ;
    shim.isRequired = shim;
    function getShim() {
      return shim;
    }
    ;
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
      array: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };

  /***/
}), ( /* 79 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "c", function () {
    return h;
  });
  /* unused harmony export createElement */
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "b", function () {
    return cloneElement;
  });
  /* unused harmony export createRef */
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "a", function () {
    return Component;
  });
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "e", function () {
    return render;
  });
  /* unused harmony export rerender */
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "d", function () {
    return options;
  });
  var VNode = function VNode() {};
  var options = {};
  var stack = [];
  var EMPTY_CHILDREN = [];
  function h(nodeName, attributes) {
    var children = EMPTY_CHILDREN,
      lastSimple,
      child,
      simple,
      i;
    for (i = arguments.length; i-- > 2;) {
      stack.push(arguments[i]);
    }
    if (attributes && attributes.children != null) {
      if (!stack.length) stack.push(attributes.children);
      delete attributes.children;
    }
    while (stack.length) {
      if ((child = stack.pop()) && child.pop !== undefined) {
        for (i = child.length; i--;) {
          stack.push(child[i]);
        }
      } else {
        if (typeof child === 'boolean') child = null;
        if (simple = typeof nodeName !== 'function') {
          if (child == null) child = '';else if (typeof child === 'number') child = String(child);else if (typeof child !== 'string') simple = false;
        }
        if (simple && lastSimple) {
          children[children.length - 1] += child;
        } else if (children === EMPTY_CHILDREN) {
          children = [child];
        } else {
          children.push(child);
        }
        lastSimple = simple;
      }
    }
    var p = new VNode();
    p.nodeName = nodeName;
    p.children = children;
    p.attributes = attributes == null ? undefined : attributes;
    p.key = attributes == null ? undefined : attributes.key;
    if (options.vnode !== undefined) options.vnode(p);
    return p;
  }
  function extend(obj, props) {
    for (var i in props) {
      obj[i] = props[i];
    }
    return obj;
  }
  function applyRef(ref, value) {
    if (ref != null) {
      if (typeof ref == 'function') ref(value);else ref.current = value;
    }
  }
  var defer = typeof Promise == 'function' ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout;
  function cloneElement(vnode, props) {
    return h(vnode.nodeName, extend(extend({}, vnode.attributes), props), arguments.length > 2 ? [].slice.call(arguments, 2) : vnode.children);
  }
  var IS_NON_DIMENSIONAL = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i;
  var items = [];
  function enqueueRender(component) {
    if (!component._dirty && (component._dirty = true) && items.push(component) == 1) {
      (options.debounceRendering || defer)(rerender);
    }
  }
  function rerender() {
    var p;
    while (p = items.pop()) {
      if (p._dirty) renderComponent(p);
    }
  }
  function isSameNodeType(node, vnode, hydrating) {
    if (typeof vnode === 'string' || typeof vnode === 'number') {
      return node.splitText !== undefined;
    }
    if (typeof vnode.nodeName === 'string') {
      return !node._componentConstructor && isNamedNode(node, vnode.nodeName);
    }
    return hydrating || node._componentConstructor === vnode.nodeName;
  }
  function isNamedNode(node, nodeName) {
    return node.normalizedNodeName === nodeName || node.nodeName.toLowerCase() === nodeName.toLowerCase();
  }
  function getNodeProps(vnode) {
    var props = extend({}, vnode.attributes);
    props.children = vnode.children;
    var defaultProps = vnode.nodeName.defaultProps;
    if (defaultProps !== undefined) {
      for (var i in defaultProps) {
        if (props[i] === undefined) {
          props[i] = defaultProps[i];
        }
      }
    }
    return props;
  }
  function createNode(nodeName, isSvg) {
    var node = isSvg ? document.createElementNS('http://www.w3.org/2000/svg', nodeName) : document.createElement(nodeName);
    node.normalizedNodeName = nodeName;
    return node;
  }
  function removeNode(node) {
    var parentNode = node.parentNode;
    if (parentNode) parentNode.removeChild(node);
  }
  function setAccessor(node, name, old, value, isSvg) {
    if (name === 'className') name = 'class';
    if (name === 'key') {} else if (name === 'ref') {
      applyRef(old, null);
      applyRef(value, node);
    } else if (name === 'class' && !isSvg) {
      node.className = value || '';
    } else if (name === 'style') {
      if (!value || typeof value === 'string' || typeof old === 'string') {
        node.style.cssText = value || '';
      }
      if (value && typeof value === 'object') {
        if (typeof old !== 'string') {
          for (var i in old) {
            if (!(i in value)) node.style[i] = '';
          }
        }
        for (var i in value) {
          node.style[i] = typeof value[i] === 'number' && IS_NON_DIMENSIONAL.test(i) === false ? value[i] + 'px' : value[i];
        }
      }
    } else if (name === 'dangerouslySetInnerHTML') {
      if (value) node.innerHTML = value.__html || '';
    } else if (name[0] == 'o' && name[1] == 'n') {
      var useCapture = name !== (name = name.replace(/Capture$/, ''));
      name = name.toLowerCase().substring(2);
      if (value) {
        if (!old) node.addEventListener(name, eventProxy, useCapture);
      } else {
        node.removeEventListener(name, eventProxy, useCapture);
      }
      (node._listeners || (node._listeners = {}))[name] = value;
    } else if (name !== 'list' && name !== 'type' && !isSvg && name in node) {
      try {
        node[name] = value == null ? '' : value;
      } catch (e) {}
      if ((value == null || value === false) && name != 'spellcheck') node.removeAttribute(name);
    } else {
      var ns = isSvg && name !== (name = name.replace(/^xlink:?/, ''));
      if (value == null || value === false) {
        if (ns) node.removeAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase());else node.removeAttribute(name);
      } else if (typeof value !== 'function') {
        if (ns) node.setAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase(), value);else node.setAttribute(name, value);
      }
    }
  }
  function eventProxy(e) {
    return this._listeners[e.type](options.event && options.event(e) || e);
  }
  var mounts = [];
  var diffLevel = 0;
  var isSvgMode = false;
  var hydrating = false;
  function flushMounts() {
    var c;
    while (c = mounts.shift()) {
      if (options.afterMount) options.afterMount(c);
      if (c.componentDidMount) c.componentDidMount();
    }
  }
  function diff(dom, vnode, context, mountAll, parent, componentRoot) {
    if (!diffLevel++) {
      isSvgMode = parent != null && parent.ownerSVGElement !== undefined;
      hydrating = dom != null && !('__preactattr_' in dom);
    }
    var ret = idiff(dom, vnode, context, mountAll, componentRoot);
    if (parent && ret.parentNode !== parent) parent.appendChild(ret);
    if (! --diffLevel) {
      hydrating = false;
      if (!componentRoot) flushMounts();
    }
    return ret;
  }
  function idiff(dom, vnode, context, mountAll, componentRoot) {
    var out = dom,
      prevSvgMode = isSvgMode;
    if (vnode == null || typeof vnode === 'boolean') vnode = '';
    if (typeof vnode === 'string' || typeof vnode === 'number') {
      if (dom && dom.splitText !== undefined && dom.parentNode && (!dom._component || componentRoot)) {
        if (dom.nodeValue != vnode) {
          dom.nodeValue = vnode;
        }
      } else {
        out = document.createTextNode(vnode);
        if (dom) {
          if (dom.parentNode) dom.parentNode.replaceChild(out, dom);
          recollectNodeTree(dom, true);
        }
      }
      out['__preactattr_'] = true;
      return out;
    }
    var vnodeName = vnode.nodeName;
    if (typeof vnodeName === 'function') {
      return buildComponentFromVNode(dom, vnode, context, mountAll);
    }
    isSvgMode = vnodeName === 'svg' ? true : vnodeName === 'foreignObject' ? false : isSvgMode;
    vnodeName = String(vnodeName);
    if (!dom || !isNamedNode(dom, vnodeName)) {
      out = createNode(vnodeName, isSvgMode);
      if (dom) {
        while (dom.firstChild) {
          out.appendChild(dom.firstChild);
        }
        if (dom.parentNode) dom.parentNode.replaceChild(out, dom);
        recollectNodeTree(dom, true);
      }
    }
    var fc = out.firstChild,
      props = out['__preactattr_'],
      vchildren = vnode.children;
    if (props == null) {
      props = out['__preactattr_'] = {};
      for (var a = out.attributes, i = a.length; i--;) {
        props[a[i].name] = a[i].value;
      }
    }
    if (!hydrating && vchildren && vchildren.length === 1 && typeof vchildren[0] === 'string' && fc != null && fc.splitText !== undefined && fc.nextSibling == null) {
      if (fc.nodeValue != vchildren[0]) {
        fc.nodeValue = vchildren[0];
      }
    } else if (vchildren && vchildren.length || fc != null) {
      innerDiffNode(out, vchildren, context, mountAll, hydrating || props.dangerouslySetInnerHTML != null);
    }
    diffAttributes(out, vnode.attributes, props);
    isSvgMode = prevSvgMode;
    return out;
  }
  function innerDiffNode(dom, vchildren, context, mountAll, isHydrating) {
    var originalChildren = dom.childNodes,
      children = [],
      keyed = {},
      keyedLen = 0,
      min = 0,
      len = originalChildren.length,
      childrenLen = 0,
      vlen = vchildren ? vchildren.length : 0,
      j,
      c,
      f,
      vchild,
      child;
    if (len !== 0) {
      for (var i = 0; i < len; i++) {
        var _child = originalChildren[i],
          props = _child['__preactattr_'],
          key = vlen && props ? _child._component ? _child._component.__key : props.key : null;
        if (key != null) {
          keyedLen++;
          keyed[key] = _child;
        } else if (props || (_child.splitText !== undefined ? isHydrating ? _child.nodeValue.trim() : true : isHydrating)) {
          children[childrenLen++] = _child;
        }
      }
    }
    if (vlen !== 0) {
      for (var i = 0; i < vlen; i++) {
        vchild = vchildren[i];
        child = null;
        var key = vchild.key;
        if (key != null) {
          if (keyedLen && keyed[key] !== undefined) {
            child = keyed[key];
            keyed[key] = undefined;
            keyedLen--;
          }
        } else if (min < childrenLen) {
          for (j = min; j < childrenLen; j++) {
            if (children[j] !== undefined && isSameNodeType(c = children[j], vchild, isHydrating)) {
              child = c;
              children[j] = undefined;
              if (j === childrenLen - 1) childrenLen--;
              if (j === min) min++;
              break;
            }
          }
        }
        child = idiff(child, vchild, context, mountAll);
        f = originalChildren[i];
        if (child && child !== dom && child !== f) {
          if (f == null) {
            dom.appendChild(child);
          } else if (child === f.nextSibling) {
            removeNode(f);
          } else {
            dom.insertBefore(child, f);
          }
        }
      }
    }
    if (keyedLen) {
      for (var i in keyed) {
        if (keyed[i] !== undefined) recollectNodeTree(keyed[i], false);
      }
    }
    while (min <= childrenLen) {
      if ((child = children[childrenLen--]) !== undefined) recollectNodeTree(child, false);
    }
  }
  function recollectNodeTree(node, unmountOnly) {
    var component = node._component;
    if (component) {
      unmountComponent(component);
    } else {
      if (node['__preactattr_'] != null) applyRef(node['__preactattr_'].ref, null);
      if (unmountOnly === false || node['__preactattr_'] == null) {
        removeNode(node);
      }
      removeChildren(node);
    }
  }
  function removeChildren(node) {
    node = node.lastChild;
    while (node) {
      var next = node.previousSibling;
      recollectNodeTree(node, true);
      node = next;
    }
  }
  function diffAttributes(dom, attrs, old) {
    var name;
    for (name in old) {
      if (!(attrs && attrs[name] != null) && old[name] != null) {
        setAccessor(dom, name, old[name], old[name] = undefined, isSvgMode);
      }
    }
    for (name in attrs) {
      if (name !== 'children' && name !== 'innerHTML' && (!(name in old) || attrs[name] !== (name === 'value' || name === 'checked' ? dom[name] : old[name]))) {
        setAccessor(dom, name, old[name], old[name] = attrs[name], isSvgMode);
      }
    }
  }
  var recyclerComponents = [];
  function createComponent(Ctor, props, context) {
    var inst,
      i = recyclerComponents.length;
    if (Ctor.prototype && Ctor.prototype.render) {
      inst = new Ctor(props, context);
      Component.call(inst, props, context);
    } else {
      inst = new Component(props, context);
      inst.constructor = Ctor;
      inst.render = doRender;
    }
    while (i--) {
      if (recyclerComponents[i].constructor === Ctor) {
        inst.nextBase = recyclerComponents[i].nextBase;
        recyclerComponents.splice(i, 1);
        return inst;
      }
    }
    return inst;
  }
  function doRender(props, state, context) {
    return this.constructor(props, context);
  }
  function setComponentProps(component, props, renderMode, context, mountAll) {
    if (component._disable) return;
    component._disable = true;
    component.__ref = props.ref;
    component.__key = props.key;
    delete props.ref;
    delete props.key;
    if (typeof component.constructor.getDerivedStateFromProps === 'undefined') {
      if (!component.base || mountAll) {
        if (component.componentWillMount) component.componentWillMount();
      } else if (component.componentWillReceiveProps) {
        component.componentWillReceiveProps(props, context);
      }
    }
    if (context && context !== component.context) {
      if (!component.prevContext) component.prevContext = component.context;
      component.context = context;
    }
    if (!component.prevProps) component.prevProps = component.props;
    component.props = props;
    component._disable = false;
    if (renderMode !== 0) {
      if (renderMode === 1 || options.syncComponentUpdates !== false || !component.base) {
        renderComponent(component, 1, mountAll);
      } else {
        enqueueRender(component);
      }
    }
    applyRef(component.__ref, component);
  }
  function renderComponent(component, renderMode, mountAll, isChild) {
    if (component._disable) return;
    var props = component.props,
      state = component.state,
      context = component.context,
      previousProps = component.prevProps || props,
      previousState = component.prevState || state,
      previousContext = component.prevContext || context,
      isUpdate = component.base,
      nextBase = component.nextBase,
      initialBase = isUpdate || nextBase,
      initialChildComponent = component._component,
      skip = false,
      snapshot = previousContext,
      rendered,
      inst,
      cbase;
    if (component.constructor.getDerivedStateFromProps) {
      state = extend(extend({}, state), component.constructor.getDerivedStateFromProps(props, state));
      component.state = state;
    }
    if (isUpdate) {
      component.props = previousProps;
      component.state = previousState;
      component.context = previousContext;
      if (renderMode !== 2 && component.shouldComponentUpdate && component.shouldComponentUpdate(props, state, context) === false) {
        skip = true;
      } else if (component.componentWillUpdate) {
        component.componentWillUpdate(props, state, context);
      }
      component.props = props;
      component.state = state;
      component.context = context;
    }
    component.prevProps = component.prevState = component.prevContext = component.nextBase = null;
    component._dirty = false;
    if (!skip) {
      rendered = component.render(props, state, context);
      if (component.getChildContext) {
        context = extend(extend({}, context), component.getChildContext());
      }
      if (isUpdate && component.getSnapshotBeforeUpdate) {
        snapshot = component.getSnapshotBeforeUpdate(previousProps, previousState);
      }
      var childComponent = rendered && rendered.nodeName,
        toUnmount,
        base;
      if (typeof childComponent === 'function') {
        var childProps = getNodeProps(rendered);
        inst = initialChildComponent;
        if (inst && inst.constructor === childComponent && childProps.key == inst.__key) {
          setComponentProps(inst, childProps, 1, context, false);
        } else {
          toUnmount = inst;
          component._component = inst = createComponent(childComponent, childProps, context);
          inst.nextBase = inst.nextBase || nextBase;
          inst._parentComponent = component;
          setComponentProps(inst, childProps, 0, context, false);
          renderComponent(inst, 1, mountAll, true);
        }
        base = inst.base;
      } else {
        cbase = initialBase;
        toUnmount = initialChildComponent;
        if (toUnmount) {
          cbase = component._component = null;
        }
        if (initialBase || renderMode === 1) {
          if (cbase) cbase._component = null;
          base = diff(cbase, rendered, context, mountAll || !isUpdate, initialBase && initialBase.parentNode, true);
        }
      }
      if (initialBase && base !== initialBase && inst !== initialChildComponent) {
        var baseParent = initialBase.parentNode;
        if (baseParent && base !== baseParent) {
          baseParent.replaceChild(base, initialBase);
          if (!toUnmount) {
            initialBase._component = null;
            recollectNodeTree(initialBase, false);
          }
        }
      }
      if (toUnmount) {
        unmountComponent(toUnmount);
      }
      component.base = base;
      if (base && !isChild) {
        var componentRef = component,
          t = component;
        while (t = t._parentComponent) {
          (componentRef = t).base = base;
        }
        base._component = componentRef;
        base._componentConstructor = componentRef.constructor;
      }
    }
    if (!isUpdate || mountAll) {
      mounts.push(component);
    } else if (!skip) {
      if (component.componentDidUpdate) {
        component.componentDidUpdate(previousProps, previousState, snapshot);
      }
      if (options.afterUpdate) options.afterUpdate(component);
    }
    while (component._renderCallbacks.length) {
      component._renderCallbacks.pop().call(component);
    }
    if (!diffLevel && !isChild) flushMounts();
  }
  function buildComponentFromVNode(dom, vnode, context, mountAll) {
    var c = dom && dom._component,
      originalComponent = c,
      oldDom = dom,
      isDirectOwner = c && dom._componentConstructor === vnode.nodeName,
      isOwner = isDirectOwner,
      props = getNodeProps(vnode);
    while (c && !isOwner && (c = c._parentComponent)) {
      isOwner = c.constructor === vnode.nodeName;
    }
    if (c && isOwner && (!mountAll || c._component)) {
      setComponentProps(c, props, 3, context, mountAll);
      dom = c.base;
    } else {
      if (originalComponent && !isDirectOwner) {
        unmountComponent(originalComponent);
        dom = oldDom = null;
      }
      c = createComponent(vnode.nodeName, props, context);
      if (dom && !c.nextBase) {
        c.nextBase = dom;
        oldDom = null;
      }
      setComponentProps(c, props, 1, context, mountAll);
      dom = c.base;
      if (oldDom && dom !== oldDom) {
        oldDom._component = null;
        recollectNodeTree(oldDom, false);
      }
    }
    return dom;
  }
  function unmountComponent(component) {
    if (options.beforeUnmount) options.beforeUnmount(component);
    var base = component.base;
    component._disable = true;
    if (component.componentWillUnmount) component.componentWillUnmount();
    component.base = null;
    var inner = component._component;
    if (inner) {
      unmountComponent(inner);
    } else if (base) {
      if (base['__preactattr_'] != null) applyRef(base['__preactattr_'].ref, null);
      component.nextBase = base;
      removeNode(base);
      recyclerComponents.push(component);
      removeChildren(base);
    }
    applyRef(component.__ref, null);
  }
  function Component(props, context) {
    this._dirty = true;
    this.context = context;
    this.props = props;
    this.state = this.state || {};
    this._renderCallbacks = [];
  }
  extend(Component.prototype, {
    setState: function setState(state, callback) {
      if (!this.prevState) this.prevState = this.state;
      this.state = extend(extend({}, this.state), typeof state === 'function' ? state(this.state, this.props) : state);
      if (callback) this._renderCallbacks.push(callback);
      enqueueRender(this);
    },
    forceUpdate: function forceUpdate(callback) {
      if (callback) this._renderCallbacks.push(callback);
      renderComponent(this, 2);
    },
    render: function render() {}
  });
  function render(vnode, parent, merge) {
    return diff(merge, vnode, {}, false, parent, false);
  }
  function createRef() {
    return {};
  }
  var preact = {
    h: h,
    createElement: h,
    cloneElement: cloneElement,
    createRef: createRef,
    Component: Component,
    render: render,
    rerender: rerender,
    options: options
  };

  /* unused harmony default export */
  var _unused_webpack_default_export = preact;

  /***/
}), ( /* 80 */
/***/function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */(function (global) {
    var NativeCustomEvent = global.CustomEvent;
    function useNative() {
      try {
        var p = new NativeCustomEvent('cat', {
          detail: {
            foo: 'bar'
          }
        });
        return 'cat' === p.type && 'bar' === p.detail.foo;
      } catch (e) {}
      return false;
    }

    /**
     * Cross-browser `CustomEvent` constructor.
     *
     * https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent.CustomEvent
     *
     * @public
     */

    module.exports = useNative() ? NativeCustomEvent :
    // IE >= 9
    'undefined' !== typeof document && 'function' === typeof document.createEvent ? function CustomEvent(type, params) {
      var e = document.createEvent('CustomEvent');
      if (params) {
        e.initCustomEvent(type, params.bubbles, params.cancelable, params.detail);
      } else {
        e.initCustomEvent(type, false, false, void 0);
      }
      return e;
    } :
    // IE <= 8
    function CustomEvent(type, params) {
      var e = document.createEventObject();
      e.type = type;
      if (params) {
        e.bubbles = Boolean(params.bubbles);
        e.cancelable = Boolean(params.cancelable);
        e.detail = params.detail;
      } else {
        e.bubbles = false;
        e.cancelable = false;
        e.detail = void 0;
      }
      return e;
    };

    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(25));

  /***/
}), ( /* 81 */
/***/function (module, exports) {
  /**
   * Expose `isUrl`.
   */

  module.exports = isUrl;

  /**
   * RegExps.
   * A URL must match #1 and then at least one of #2/#3.
   * Use two levels of REs to avoid REDOS.
   */

  var protocolAndDomainRE = /^(?:\w+:)?\/\/(\S+)$/;
  var localhostDomainRE = /^localhost[\:?\d]*(?:[^\:?\d]\S*)?$/;
  var nonLocalhostDomainRE = /^[^\s\.]+\.\S{2,}$/;

  /**
   * Loosely validate a URL `string`.
   *
   * @param {String} string
   * @return {Boolean}
   */

  function isUrl(string) {
    if (typeof string !== 'string') {
      return false;
    }
    var match = string.match(protocolAndDomainRE);
    if (!match) {
      return false;
    }
    var everythingAfterProtocol = match[1];
    if (!everythingAfterProtocol) {
      return false;
    }
    if (localhostDomainRE.test(everythingAfterProtocol) || nonLocalhostDomainRE.test(everythingAfterProtocol)) {
      return true;
    }
    return false;
  }

  /***/
}), ( /* 82 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  /**
   * Check if we're required to add a port number.
   *
   * @see https://url.spec.whatwg.org/#default-port
   * @param {Number|String} port Port number we need to check
   * @param {String} protocol Protocol we need to check against.
   * @returns {Boolean} Is it a default port for the given protocol
   * @api private
   */
  module.exports = function required(port, protocol) {
    protocol = protocol.split(':')[0];
    port = +port;
    if (!port) return false;
    switch (protocol) {
      case 'http':
      case 'ws':
        return port !== 80;
      case 'https':
      case 'wss':
        return port !== 443;
      case 'ftp':
        return port !== 21;
      case 'gopher':
        return port !== 70;
      case 'file':
        return false;
    }
    return port !== 0;
  };

  /***/
}), ( /* 83 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var has = Object.prototype.hasOwnProperty,
    undef;

  /**
   * Decode a URI encoded string.
   *
   * @param {String} input The URI encoded string.
   * @returns {String} The decoded string.
   * @api private
   */
  function decode(input) {
    return decodeURIComponent(input.replace(/\+/g, ' '));
  }

  /**
   * Simple query string parser.
   *
   * @param {String} query The query string that needs to be parsed.
   * @returns {Object}
   * @api public
   */
  function querystring(query) {
    var parser = /([^=?&]+)=?([^&]*)/g,
      result = {},
      part;
    while (part = parser.exec(query)) {
      var key = decode(part[1]),
        value = decode(part[2]);

      //
      // Prevent overriding of existing properties. This ensures that build-in
      // methods like `toString` or __proto__ are not overriden by malicious
      // querystrings.
      //
      if (key in result) continue;
      result[key] = value;
    }
    return result;
  }

  /**
   * Transform a query string to an object.
   *
   * @param {Object} obj Object that should be transformed.
   * @param {String} prefix Optional prefix.
   * @returns {String}
   * @api public
   */
  function querystringify(obj, prefix) {
    prefix = prefix || '';
    var pairs = [],
      value,
      key;

    //
    // Optionally prefix with a '?' if needed
    //
    if ('string' !== typeof prefix) prefix = '?';
    for (key in obj) {
      if (has.call(obj, key)) {
        value = obj[key];

        //
        // Edge cases where we actually want to encode the value to an empty
        // string instead of the stringified value.
        //
        if (!value && (value === null || value === undef || isNaN(value))) {
          value = '';
        }
        pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
      }
    }
    return pairs.length ? prefix + pairs.join('&') : '';
  }

  //
  // Expose the module.
  //
  exports.stringify = querystringify;
  exports.parse = querystring;

  /***/
}), ( /* 84 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  /*!
   * isobject <https://github.com/jonschlinkert/isobject>
   *
   * Copyright (c) 2014-2017, Jon Schlinkert.
   * Released under the MIT License.
   */
  module.exports = function isObject(val) {
    return val != null && typeof val === 'object' && Array.isArray(val) === false;
  };

  /***/
}), ( /* 85 */
/***/function (module, exports, __webpack_require__) {
  var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; // Generated by CoffeeScript 1.9.1
  (function () {
    'use strict';

    var getScrollbarWidth, scrollbarWidth;
    scrollbarWidth = null;
    getScrollbarWidth = function (recalculate) {
      var div1, div2;
      if (recalculate == null) {
        recalculate = false;
      }
      if (scrollbarWidth != null && !recalculate) {
        return scrollbarWidth;
      }
      if (document.readyState === 'loading') {
        return null;
      }
      div1 = document.createElement('div');
      div2 = document.createElement('div');
      div1.style.width = div2.style.width = div1.style.height = div2.style.height = '100px';
      div1.style.overflow = 'scroll';
      div2.style.overflow = 'hidden';
      document.body.appendChild(div1);
      document.body.appendChild(div2);
      scrollbarWidth = Math.abs(div1.scrollHeight - div2.scrollHeight);
      document.body.removeChild(div1);
      document.body.removeChild(div2);
      return scrollbarWidth;
    };
    if (true) {
      !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
        return getScrollbarWidth;
      }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== 'undefined') {
      module.exports = getScrollbarWidth;
    } else {
      this.getScrollbarWidth = getScrollbarWidth;
    }
  }).call(this);

  /***/
}), ( /* 86 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  Object.defineProperty(__webpack_exports__, "__esModule", {
    value: true
  });
  /* WEBPACK VAR INJECTION */
  (function (process) {
    /* harmony import */var __WEBPACK_IMPORTED_MODULE_0__emotion_memoize__ = __webpack_require__(45);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_1__emotion_unitless__ = __webpack_require__(87);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_2__emotion_hash__ = __webpack_require__(88);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_3__emotion_stylis__ = __webpack_require__(89);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet__ = __webpack_require__(90);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet__);
    var hyphenateRegex = /[A-Z]|^ms/g;
    var processStyleName = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_memoize__["a" /* default */])(function (styleName) {
      return styleName.replace(hyphenateRegex, '-$&').toLowerCase();
    });
    var processStyleValue = function processStyleValue(key, value) {
      if (value == null || typeof value === 'boolean') {
        return '';
      }
      if (__WEBPACK_IMPORTED_MODULE_1__emotion_unitless__["a" /* default */][key] !== 1 && key.charCodeAt(1) !== 45 &&
      // custom properties
      !isNaN(value) && value !== 0) {
        return value + 'px';
      }
      return value;
    };
    if (process.env.NODE_ENV !== 'production') {
      var contentValuePattern = /(attr|calc|counters?|url)\(/;
      var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
      var oldProcessStyleValue = processStyleValue;
      processStyleValue = function processStyleValue(key, value) {
        if (key === 'content') {
          if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
            console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
          }
        }
        return oldProcessStyleValue(key, value);
      };
    }
    var classnames = function classnames(args) {
      var len = args.length;
      var i = 0;
      var cls = '';
      for (; i < len; i++) {
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch (typeof arg) {
          case 'boolean':
            break;
          case 'function':
            if (process.env.NODE_ENV !== 'production') {
              console.error('Passing functions to cx is deprecated and will be removed in the next major version of Emotion.\n' + 'Please call the function before passing it to cx.');
            }
            toAdd = classnames([arg()]);
            break;
          case 'object':
            {
              if (Array.isArray(arg)) {
                toAdd = classnames(arg);
              } else {
                toAdd = '';
                for (var k in arg) {
                  if (arg[k] && k) {
                    toAdd && (toAdd += ' ');
                    toAdd += k;
                  }
                }
              }
              break;
            }
          default:
            {
              toAdd = arg;
            }
        }
        if (toAdd) {
          cls && (cls += ' ');
          cls += toAdd;
        }
      }
      return cls;
    };
    var isBrowser = typeof document !== 'undefined';

    /*
    
    high performance StyleSheet for css-in-js systems
    
    - uses multiple style tags behind the scenes for millions of rules
    - uses `insertRule` for appending in production for *much* faster performance
    - 'polyfills' on server side
    
    // usage
    
    import StyleSheet from 'glamor/lib/sheet'
    let styleSheet = new StyleSheet()
    
    styleSheet.inject()
    - 'injects' the stylesheet into the page (or into memory if on server)
    
    styleSheet.insert('#box { border: 1px solid red; }')
    - appends a css rule into the stylesheet
    
    styleSheet.flush()
    - empties the stylesheet of all its contents
    
    */
    // $FlowFixMe
    function sheetForTag(tag) {
      if (tag.sheet) {
        // $FlowFixMe
        return tag.sheet;
      } // this weirdness brought to you by firefox

      for (var i = 0; i < document.styleSheets.length; i++) {
        if (document.styleSheets[i].ownerNode === tag) {
          // $FlowFixMe
          return document.styleSheets[i];
        }
      }
    }
    function makeStyleTag(opts) {
      var tag = document.createElement('style');
      tag.setAttribute('data-emotion', opts.key || '');
      if (opts.nonce !== undefined) {
        tag.setAttribute('nonce', opts.nonce);
      }
      tag.appendChild(document.createTextNode('')) // $FlowFixMe
      ;
      (opts.container !== undefined ? opts.container : document.head).appendChild(tag);
      return tag;
    }
    var StyleSheet = /*#__PURE__*/
    function () {
      function StyleSheet(options) {
        this.isSpeedy = process.env.NODE_ENV === 'production'; // the big drawback here is that the css won't be editable in devtools

        this.tags = [];
        this.ctr = 0;
        this.opts = options;
      }
      var _proto = StyleSheet.prototype;
      _proto.inject = function inject() {
        if (this.injected) {
          throw new Error('already injected!');
        }
        this.tags[0] = makeStyleTag(this.opts);
        this.injected = true;
      };
      _proto.speedy = function speedy(bool) {
        if (this.ctr !== 0) {
          // cannot change speedy mode after inserting any rule to sheet. Either call speedy(${bool}) earlier in your app, or call flush() before speedy(${bool})
          throw new Error("cannot change speedy now");
        }
        this.isSpeedy = !!bool;
      };
      _proto.insert = function insert(rule, sourceMap) {
        // this is the ultrafast version, works across browsers
        if (this.isSpeedy) {
          var tag = this.tags[this.tags.length - 1];
          var sheet = sheetForTag(tag);
          try {
            sheet.insertRule(rule, sheet.cssRules.length);
          } catch (e) {
            if (process.env.NODE_ENV !== 'production') {
              console.warn('illegal rule', rule); // eslint-disable-line no-console
            }
          }
        } else {
          var _tag = makeStyleTag(this.opts);
          this.tags.push(_tag);
          _tag.appendChild(document.createTextNode(rule + (sourceMap || '')));
        }
        this.ctr++;
        if (this.ctr % 65000 === 0) {
          this.tags.push(makeStyleTag(this.opts));
        }
      };
      _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function (tag) {
          return tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0; // todo - look for remnants in document.styleSheets

        this.injected = false;
      };
      return StyleSheet;
    }();
    function createEmotion(context, options) {
      if (context.__SECRET_EMOTION__ !== undefined) {
        return context.__SECRET_EMOTION__;
      }
      if (options === undefined) options = {};
      var key = options.key || 'css';
      if (process.env.NODE_ENV !== 'production') {
        if (/[^a-z-]/.test(key)) {
          throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
        }
      }
      var current;
      function insertRule(rule) {
        current += rule;
        if (isBrowser) {
          sheet.insert(rule, currentSourceMap);
        }
      }
      var insertionPlugin = __WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet___default()(insertRule);
      var stylisOptions;
      if (options.prefix !== undefined) {
        stylisOptions = {
          prefix: options.prefix
        };
      }
      var caches = {
        registered: {},
        inserted: {},
        nonce: options.nonce,
        key: key
      };
      var sheet = new StyleSheet(options);
      if (isBrowser) {
        // 🚀
        sheet.inject();
      }
      var stylis = new __WEBPACK_IMPORTED_MODULE_3__emotion_stylis__["a" /* default */](stylisOptions);
      stylis.use(options.stylisPlugins)(insertionPlugin);
      var currentSourceMap = '';
      function handleInterpolation(interpolation, couldBeSelectorInterpolation) {
        if (interpolation == null) {
          return '';
        }
        switch (typeof interpolation) {
          case 'boolean':
            return '';
          case 'function':
            if (interpolation.__emotion_styles !== undefined) {
              var selector = interpolation.toString();
              if (selector === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
                throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
              }
              return selector;
            }
            if (this === undefined && process.env.NODE_ENV !== 'production') {
              console.error('Interpolating functions in css calls is deprecated and will be removed in the next major version of Emotion.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
            }
            return handleInterpolation.call(this, this === undefined ? interpolation() :
            // $FlowFixMe
            interpolation(this.mergedProps, this.context), couldBeSelectorInterpolation);
          case 'object':
            return createStringFromObject.call(this, interpolation);
          default:
            var cached = caches.registered[interpolation];
            return couldBeSelectorInterpolation === false && cached !== undefined ? cached : interpolation;
        }
      }
      var objectToStringCache = new WeakMap();
      function createStringFromObject(obj) {
        if (objectToStringCache.has(obj)) {
          // $FlowFixMe
          return objectToStringCache.get(obj);
        }
        var string = '';
        if (Array.isArray(obj)) {
          obj.forEach(function (interpolation) {
            string += handleInterpolation.call(this, interpolation, false);
          }, this);
        } else {
          Object.keys(obj).forEach(function (key) {
            if (typeof obj[key] !== 'object') {
              if (caches.registered[obj[key]] !== undefined) {
                string += key + "{" + caches.registered[obj[key]] + "}";
              } else {
                string += processStyleName(key) + ":" + processStyleValue(key, obj[key]) + ";";
              }
            } else {
              if (key === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
                throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
              }
              if (Array.isArray(obj[key]) && typeof obj[key][0] === 'string' && caches.registered[obj[key][0]] === undefined) {
                obj[key].forEach(function (value) {
                  string += processStyleName(key) + ":" + processStyleValue(key, value) + ";";
                });
              } else {
                string += key + "{" + handleInterpolation.call(this, obj[key], false) + "}";
              }
            }
          }, this);
        }
        objectToStringCache.set(obj, string);
        return string;
      }
      var name;
      var stylesWithLabel;
      var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
      var createClassName = function createClassName(styles, identifierName) {
        return Object(__WEBPACK_IMPORTED_MODULE_2__emotion_hash__["a" /* default */])(styles + identifierName) + identifierName;
      };
      if (process.env.NODE_ENV !== 'production') {
        var oldCreateClassName = createClassName;
        var sourceMappingUrlPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;
        createClassName = function createClassName(styles, identifierName) {
          return oldCreateClassName(styles.replace(sourceMappingUrlPattern, function (sourceMap) {
            currentSourceMap = sourceMap;
            return '';
          }), identifierName);
        };
      }
      var createStyles = function createStyles(strings) {
        var stringMode = true;
        var styles = '';
        var identifierName = '';
        if (strings == null || strings.raw === undefined) {
          stringMode = false;
          styles += handleInterpolation.call(this, strings, false);
        } else {
          styles += strings[0];
        }
        for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          interpolations[_key - 1] = arguments[_key];
        }
        interpolations.forEach(function (interpolation, i) {
          styles += handleInterpolation.call(this, interpolation, styles.charCodeAt(styles.length - 1) === 46 // .
          );
          if (stringMode === true && strings[i + 1] !== undefined) {
            styles += strings[i + 1];
          }
        }, this);
        stylesWithLabel = styles;
        styles = styles.replace(labelPattern, function (match, p1) {
          identifierName += "-" + p1;
          return '';
        });
        name = createClassName(styles, identifierName);
        return styles;
      };
      if (process.env.NODE_ENV !== 'production') {
        var oldStylis = stylis;
        stylis = function stylis(selector, styles) {
          oldStylis(selector, styles);
          currentSourceMap = '';
        };
      }
      function insert(scope, styles) {
        if (caches.inserted[name] === undefined) {
          current = '';
          stylis(scope, styles);
          caches.inserted[name] = current;
        }
      }
      var css = function css() {
        var styles = createStyles.apply(this, arguments);
        var selector = key + "-" + name;
        if (caches.registered[selector] === undefined) {
          caches.registered[selector] = stylesWithLabel;
        }
        insert("." + selector, styles);
        return selector;
      };
      var keyframes = function keyframes() {
        var styles = createStyles.apply(this, arguments);
        var animation = "animation-" + name;
        insert('', "@keyframes " + animation + "{" + styles + "}");
        return animation;
      };
      var injectGlobal = function injectGlobal() {
        var styles = createStyles.apply(this, arguments);
        insert('', styles);
      };
      function getRegisteredStyles(registeredStyles, classNames) {
        var rawClassName = '';
        classNames.split(' ').forEach(function (className) {
          if (caches.registered[className] !== undefined) {
            registeredStyles.push(className);
          } else {
            rawClassName += className + " ";
          }
        });
        return rawClassName;
      }
      function merge(className, sourceMap) {
        var registeredStyles = [];
        var rawClassName = getRegisteredStyles(registeredStyles, className);
        if (registeredStyles.length < 2) {
          return className;
        }
        return rawClassName + css(registeredStyles, sourceMap);
      }
      function cx() {
        for (var _len2 = arguments.length, classNames = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          classNames[_key2] = arguments[_key2];
        }
        return merge(classnames(classNames));
      }
      function hydrateSingleId(id) {
        caches.inserted[id] = true;
      }
      function hydrate(ids) {
        ids.forEach(hydrateSingleId);
      }
      function flush() {
        if (isBrowser) {
          sheet.flush();
          sheet.inject();
        }
        caches.inserted = {};
        caches.registered = {};
      }
      if (isBrowser) {
        var chunks = document.querySelectorAll("[data-emotion-" + key + "]");
        Array.prototype.forEach.call(chunks, function (node) {
          // $FlowFixMe
          sheet.tags[0].parentNode.insertBefore(node, sheet.tags[0]); // $FlowFixMe

          node.getAttribute("data-emotion-" + key).split(' ').forEach(hydrateSingleId);
        });
      }
      var emotion = {
        flush: flush,
        hydrate: hydrate,
        cx: cx,
        merge: merge,
        getRegisteredStyles: getRegisteredStyles,
        injectGlobal: injectGlobal,
        keyframes: keyframes,
        css: css,
        sheet: sheet,
        caches: caches
      };
      context.__SECRET_EMOTION__ = emotion;
      return emotion;
    }

    /* harmony default export */
    __webpack_exports__["default"] = createEmotion;

    /* WEBPACK VAR INJECTION */
  }).call(__webpack_exports__, __webpack_require__(3));

  /***/
}), ( /* 87 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  var unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
  };

  /* harmony default export */
  __webpack_exports__["a"] = unitlessKeys;

  /***/
}), ( /* 88 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  /* eslint-disable */
  // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
  function murmurhash2_32_gc(str) {
    var l = str.length,
      h = l ^ l,
      i = 0,
      k;
    while (l >= 4) {
      k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
      k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
      k ^= k >>> 24;
      k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
      l -= 4;
      ++i;
    }
    switch (l) {
      case 3:
        h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
      case 2:
        h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
      case 1:
        h ^= str.charCodeAt(i) & 0xff;
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
  }

  /* harmony default export */
  __webpack_exports__["a"] = murmurhash2_32_gc;

  /***/
}), ( /* 89 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  function stylis_min(W) {
    function M(d, c, e, h, a) {
      for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
        g = e.charCodeAt(l);
        l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
        if (0 === b + n + v + m) {
          if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
            switch (g) {
              case 32:
              case 9:
              case 59:
              case 13:
              case 10:
                break;
              default:
                f += e.charAt(l);
            }
            g = 59;
          }
          switch (g) {
            case 123:
              f = f.trim();
              q = f.charCodeAt(0);
              k = 1;
              for (t = ++l; l < B;) {
                switch (g = e.charCodeAt(l)) {
                  case 123:
                    k++;
                    break;
                  case 125:
                    k--;
                    break;
                  case 47:
                    switch (g = e.charCodeAt(l + 1)) {
                      case 42:
                      case 47:
                        a: {
                          for (u = l + 1; u < J; ++u) {
                            switch (e.charCodeAt(u)) {
                              case 47:
                                if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                  l = u + 1;
                                  break a;
                                }
                                break;
                              case 10:
                                if (47 === g) {
                                  l = u + 1;
                                  break a;
                                }
                            }
                          }
                          l = u;
                        }
                    }
                    break;
                  case 91:
                    g++;
                  case 40:
                    g++;
                  case 34:
                  case 39:
                    for (; l++ < J && e.charCodeAt(l) !== g;) {}
                }
                if (0 === k) break;
                l++;
              }
              k = e.substring(t, l);
              0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
              switch (q) {
                case 64:
                  0 < r && (f = f.replace(N, ''));
                  g = f.charCodeAt(1);
                  switch (g) {
                    case 100:
                    case 109:
                    case 115:
                    case 45:
                      r = c;
                      break;
                    default:
                      r = O;
                  }
                  k = M(c, r, k, g, a + 1);
                  t = k.length;
                  0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                  if (0 < t) switch (g) {
                    case 115:
                      f = f.replace(da, ea);
                    case 100:
                    case 109:
                    case 45:
                      k = f + '{' + k + '}';
                      break;
                    case 107:
                      f = f.replace(fa, '$1 $2');
                      k = f + '{' + k + '}';
                      k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                      break;
                    default:
                      k = f + k, 112 === h && (k = (p += k, ''));
                  } else k = '';
                  break;
                default:
                  k = M(c, X(c, f, I), k, h, a + 1);
              }
              F += k;
              k = I = r = u = q = 0;
              f = '';
              g = e.charCodeAt(++l);
              break;
            case 125:
            case 59:
              f = (0 < r ? f.replace(N, '') : f).trim();
              if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
                case 0:
                  break;
                case 64:
                  if (105 === g || 99 === g) {
                    G += f + e.charAt(l);
                    break;
                  }
                default:
                  58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
              }
              I = r = u = q = 0;
              f = '';
              g = e.charCodeAt(++l);
          }
        }
        switch (g) {
          case 13:
          case 10:
            47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
            0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
            z = 1;
            D++;
            break;
          case 59:
          case 125:
            if (0 === b + n + v + m) {
              z++;
              break;
            }
          default:
            z++;
            y = e.charAt(l);
            switch (g) {
              case 9:
              case 32:
                if (0 === n + m + b) switch (x) {
                  case 44:
                  case 58:
                  case 9:
                  case 32:
                    y = '';
                    break;
                  default:
                    32 !== g && (y = ' ');
                }
                break;
              case 0:
                y = '\\0';
                break;
              case 12:
                y = '\\f';
                break;
              case 11:
                y = '\\v';
                break;
              case 38:
                0 === n + b + m && (r = I = 1, y = '\f' + y);
                break;
              case 108:
                if (0 === n + b + m + E && 0 < u) switch (l - u) {
                  case 2:
                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                  case 8:
                    111 === K && (E = K);
                }
                break;
              case 58:
                0 === n + b + m && (u = l);
                break;
              case 44:
                0 === b + v + n + m && (r = 1, y += '\r');
                break;
              case 34:
              case 39:
                0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                break;
              case 91:
                0 === n + b + v && m++;
                break;
              case 93:
                0 === n + b + v && m--;
                break;
              case 41:
                0 === n + b + m && v--;
                break;
              case 40:
                if (0 === n + b + m) {
                  if (0 === q) switch (2 * x + 3 * K) {
                    case 533:
                      break;
                    default:
                      q = 1;
                  }
                  v++;
                }
                break;
              case 64:
                0 === b + v + n + m + u + k && (k = 1);
                break;
              case 42:
              case 47:
                if (!(0 < n + m + v)) switch (b) {
                  case 0:
                    switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                      case 235:
                        b = 47;
                        break;
                      case 220:
                        t = l, b = 42;
                    }
                    break;
                  case 42:
                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
                }
            }
            0 === b && (f += y);
        }
        K = x;
        x = g;
        l++;
      }
      t = p.length;
      if (0 < t) {
        r = c;
        if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
        p = r.join(',') + '{' + p + '}';
        if (0 !== w * E) {
          2 !== w || L(p, 2) || (E = 0);
          switch (E) {
            case 111:
              p = p.replace(ha, ':-moz-$1') + p;
              break;
            case 112:
              p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
          }
          E = 0;
        }
      }
      return G + p + F;
    }
    function X(d, c, e) {
      var h = c.trim().split(ia);
      c = h;
      var a = h.length,
        m = d.length;
      switch (m) {
        case 0:
        case 1:
          var b = 0;
          for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
            c[b] = Z(d, c[b], e, m).trim();
          }
          break;
        default:
          var v = b = 0;
          for (c = []; b < a; ++b) {
            for (var n = 0; n < m; ++n) {
              c[v++] = Z(d[n] + ' ', h[b], e, m).trim();
            }
          }
      }
      return c;
    }
    function Z(d, c, e) {
      var h = c.charCodeAt(0);
      33 > h && (h = (c = c.trim()).charCodeAt(0));
      switch (h) {
        case 38:
          return c.replace(F, '$1' + d.trim());
        case 58:
          return d.trim() + c.replace(F, '$1' + d.trim());
        default:
          if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
      }
      return d + c;
    }
    function P(d, c, e, h) {
      var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;
      if (944 === m) {
        d = a.indexOf(':', 9) + 1;
        var b = a.substring(d, a.length - 1).trim();
        b = a.substring(0, d).trim() + b + ';';
        return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
      }
      if (0 === w || 2 === w && !L(a, 1)) return a;
      switch (m) {
        case 1015:
          return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
        case 951:
          return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
        case 963:
          return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
        case 1009:
          if (100 !== a.charCodeAt(4)) break;
        case 969:
        case 942:
          return '-webkit-' + a + a;
        case 978:
          return '-webkit-' + a + '-moz-' + a + a;
        case 1019:
        case 983:
          return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
        case 883:
          if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
          if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
          break;
        case 932:
          if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
            case 103:
              return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
            case 115:
              return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
            case 98:
              return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
          }
          return '-webkit-' + a + '-ms-' + a + a;
        case 964:
          return '-webkit-' + a + '-ms-flex-' + a + a;
        case 1023:
          if (99 !== a.charCodeAt(8)) break;
          b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
          return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
        case 1005:
          return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
        case 1e3:
          b = a.substring(13).trim();
          c = b.indexOf('-') + 1;
          switch (b.charCodeAt(0) + b.charCodeAt(c)) {
            case 226:
              b = a.replace(G, 'tb');
              break;
            case 232:
              b = a.replace(G, 'tb-rl');
              break;
            case 220:
              b = a.replace(G, 'lr');
              break;
            default:
              return a;
          }
          return '-webkit-' + a + '-ms-' + b + a;
        case 1017:
          if (-1 === a.indexOf('sticky', 9)) break;
        case 975:
          c = (a = d).length - 10;
          b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
          switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
            case 203:
              if (111 > b.charCodeAt(8)) break;
            case 115:
              a = a.replace(b, '-webkit-' + b) + ';' + a;
              break;
            case 207:
            case 102:
              a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
          }
          return a + ';';
        case 938:
          if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
            case 105:
              return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
            case 115:
              return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
            default:
              return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
          }
          break;
        case 973:
        case 989:
          if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
        case 931:
        case 953:
          if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
          break;
        case 962:
          if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
      }
      return a;
    }
    function L(d, c) {
      var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
      e = d.substring(e + 1, d.length - 1);
      return R(2 !== c ? h : h.replace(na, '$1'), e, c);
    }
    function ea(d, c) {
      var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
      return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
      for (var g = 0, x = c, w; g < A; ++g) {
        switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
          case void 0:
          case !1:
          case !0:
          case null:
            break;
          default:
            x = w;
        }
      }
      if (x !== c) return x;
    }
    function T(d) {
      switch (d) {
        case void 0:
        case null:
          A = S.length = 0;
          break;
        default:
          switch (d.constructor) {
            case Array:
              for (var c = 0, e = d.length; c < e; ++c) {
                T(d[c]);
              }
              break;
            case Function:
              S[A++] = d;
              break;
            case Boolean:
              Y = !!d | 0;
          }
      }
      return T;
    }
    function U(d) {
      d = d.prefix;
      void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
      return U;
    }
    function B(d, c) {
      var e = d;
      33 > e.charCodeAt(0) && (e = e.trim());
      V = e;
      e = [V];
      if (0 < A) {
        var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
        void 0 !== h && 'string' === typeof h && (c = h);
      }
      var a = M(O, e, c, 0, 0);
      0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
      V = '';
      E = 0;
      z = D = 1;
      return a;
    }
    var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
  }

  /* harmony default export */
  __webpack_exports__["a"] = stylis_min;

  /***/
}), ( /* 90 */
/***/function (module, exports, __webpack_require__) {
  (function (factory) {
    true ? module['exports'] = factory() : typeof define === 'function' && define['amd'] ? define(factory()) : window['stylisRuleSheet'] = factory();
  })(function () {
    'use strict';

    return function (insertRule) {
      var delimiter = '/*|*/';
      var needle = delimiter + '}';
      function toSheet(block) {
        if (block) try {
          insertRule(block + '}');
        } catch (e) {}
      }
      return function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
        switch (context) {
          // property
          case 1:
            // @import
            if (depth === 0 && content.charCodeAt(0) === 64) return insertRule(content + ';'), '';
            break;
          // selector
          case 2:
            if (ns === 0) return content + delimiter;
            break;
          // at-rule
          case 3:
            switch (ns) {
              // @font-face, @page
              case 102:
              case 112:
                return insertRule(selectors[0] + content), '';
              default:
                return content + (at === 0 ? delimiter : '');
            }
          case -2:
            content.split(needle).forEach(toSheet);
        }
      };
    };
  });

  /***/
}), ( /* 91 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  Object.defineProperty(__webpack_exports__, "__esModule", {
    value: true
  });
  /* WEBPACK VAR INJECTION */
  (function (process) {
    /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(4);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_1__emotion_is_prop_valid__ = __webpack_require__(92);
    function _inheritsLoose(subClass, superClass) {
      subClass.prototype = Object.create(superClass.prototype);
      subClass.prototype.constructor = subClass;
      subClass.__proto__ = superClass;
    }
    var channel = '__EMOTION_THEMING__';

    // https://github.com/styled-components/styled-components/blob/e05b3fe247e9d956bcde786cec376e32afb85bca/src/utils/create-broadcast.js

    var _contextTypes;
    var contextTypes = (_contextTypes = {}, _contextTypes[channel] = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object, _contextTypes);
    function setTheme(theme) {
      this.setState({
        theme: theme
      });
    }
    var testPickPropsOnStringTag = __WEBPACK_IMPORTED_MODULE_1__emotion_is_prop_valid__["a" /* default */];
    var testPickPropsOnComponent = function testPickPropsOnComponent(key) {
      return key !== 'theme' && key !== 'innerRef';
    };
    var testAlwaysTrue = function testAlwaysTrue() {
      return true;
    };
    var pickAssign = function pickAssign(testFn, target) {
      var i = 2;
      var length = arguments.length;
      for (; i < length; i++) {
        var source = arguments[i];
        var _key = void 0;
        for (_key in source) {
          if (testFn(_key)) {
            target[_key] = source[_key];
          }
        }
      }
      return target;
    };
    var warnedAboutExtractStatic = false;
    function createEmotionStyled(emotion, view) {
      var _createStyled = function createStyled(tag, options) {
        if (process.env.NODE_ENV !== 'production') {
          if (tag === undefined) {
            throw new Error('You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.');
          }
        }
        var staticClassName;
        var identifierName;
        var stableClassName;
        var shouldForwardProp;
        if (options !== undefined) {
          staticClassName = options.e;
          identifierName = options.label;
          stableClassName = options.target;
          shouldForwardProp = tag.__emotion_forwardProp && options.shouldForwardProp ? function (propName) {
            return tag.__emotion_forwardProp(propName) &&
            // $FlowFixMe
            options.shouldForwardProp(propName);
          } : options.shouldForwardProp;
        }
        var isReal = tag.__emotion_real === tag;
        var baseTag = staticClassName === undefined ? isReal && tag.__emotion_base || tag : tag;
        if (typeof shouldForwardProp !== 'function') {
          shouldForwardProp = typeof baseTag === 'string' && baseTag.charAt(0) === baseTag.charAt(0).toLowerCase() ? testPickPropsOnStringTag : testPickPropsOnComponent;
        }
        return function () {
          var args = arguments;
          var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
          if (identifierName !== undefined) {
            styles.push("label:" + identifierName + ";");
          }
          if (staticClassName === undefined) {
            if (args[0] == null || args[0].raw === undefined) {
              styles.push.apply(styles, args);
            } else {
              styles.push(args[0][0]);
              var len = args.length;
              var i = 1;
              for (; i < len; i++) {
                styles.push(args[i], args[0][i]);
              }
            }
          } else if (process.env.NODE_ENV !== 'production' && !warnedAboutExtractStatic) {
            console.warn('extractStatic is deprecated and will be removed in emotion@10. We recommend disabling extractStatic or using other libraries like linaria or css-literal-loader');
            warnedAboutExtractStatic = true;
          }
          var Styled = /*#__PURE__*/
          function (_view$Component) {
            _inheritsLoose(Styled, _view$Component);
            function Styled() {
              return _view$Component.apply(this, arguments) || this;
            }
            var _proto = Styled.prototype;
            _proto.componentWillMount = function componentWillMount() {
              if (this.context[channel] !== undefined) {
                this.unsubscribe = this.context[channel].subscribe(setTheme.bind(this));
              }
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
              if (this.unsubscribe !== undefined) {
                this.context[channel].unsubscribe(this.unsubscribe);
              }
            };
            _proto.render = function render() {
              var props = this.props,
                state = this.state;
              this.mergedProps = pickAssign(testAlwaysTrue, {}, props, {
                theme: state !== null && state.theme || props.theme || {}
              });
              var className = '';
              var classInterpolations = [];
              if (props.className) {
                if (staticClassName === undefined) {
                  className += emotion.getRegisteredStyles(classInterpolations, props.className);
                } else {
                  className += props.className + " ";
                }
              }
              if (staticClassName === undefined) {
                className += emotion.css.apply(this, styles.concat(classInterpolations));
              } else {
                className += staticClassName;
              }
              if (stableClassName !== undefined) {
                className += " " + stableClassName;
              }
              return view.createElement(baseTag,
              // $FlowFixMe
              pickAssign(shouldForwardProp, {}, props, {
                className: className,
                ref: props.innerRef
              }));
            };
            return Styled;
          }(view.Component);
          Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
          if (tag.defaultProps !== undefined) {
            // $FlowFixMe
            Styled.defaultProps = tag.defaultProps;
          }
          Styled.contextTypes = contextTypes;
          Styled.__emotion_styles = styles;
          Styled.__emotion_base = baseTag;
          Styled.__emotion_real = Styled;
          Styled.__emotion_forwardProp = shouldForwardProp;
          Object.defineProperty(Styled, 'toString', {
            value: function value() {
              if (process.env.NODE_ENV !== 'production' && stableClassName === undefined) {
                return 'NO_COMPONENT_SELECTOR';
              } // $FlowFixMe

              return "." + stableClassName;
            }
          });
          Styled.withComponent = function (nextTag, nextOptions) {
            return _createStyled(nextTag, nextOptions !== undefined ?
            // $FlowFixMe
            pickAssign(testAlwaysTrue, {}, options, nextOptions) : options).apply(void 0, styles);
          };
          return Styled;
        };
      };
      if (process.env.NODE_ENV !== 'production' && typeof Proxy !== 'undefined') {
        _createStyled = new Proxy(_createStyled, {
          get: function get(target, property) {
            switch (property) {
              // react-hot-loader tries to access this stuff
              case '__proto__':
              case 'name':
              case 'prototype':
              case 'displayName':
                {
                  return target[property];
                }
              default:
                {
                  throw new Error("You're trying to use the styled shorthand without babel-plugin-emotion." + ("\nPlease install and setup babel-plugin-emotion or use the function call syntax(`styled('" + property + "')` instead of `styled." + property + "`)"));
                }
            }
          }
        });
      }
      return _createStyled;
    }

    /* harmony default export */
    __webpack_exports__["default"] = createEmotionStyled;

    /* WEBPACK VAR INJECTION */
  }).call(__webpack_exports__, __webpack_require__(3));

  /***/
}), ( /* 92 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  /* harmony import */
  var __WEBPACK_IMPORTED_MODULE_0__emotion_memoize__ = __webpack_require__(45);
  var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|default|defer|dir|disabled|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|itemProp|itemScope|itemType|itemID|itemRef|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class)|(on[A-Z].*)|((data|aria|x)-.*))$/i;
  var index = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_memoize__["a" /* default */])(reactPropsRegex.test.bind(reactPropsRegex));

  /* harmony default export */
  __webpack_exports__["a"] = index;

  /***/
}), ( /* 93 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _react = __webpack_require__(2);
  var _react2 = _interopRequireDefault(_react);
  var _propTypes = __webpack_require__(4);
  var _propTypes2 = _interopRequireDefault(_propTypes);
  var _spin = __webpack_require__(94);
  var _spin2 = _interopRequireDefault(_spin);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var defaultConfig = {
    lines: 16,
    length: 3,
    width: 3,
    radius: 14,
    color: '#FFFFFF',
    speed: 2.1,
    trail: 60,
    shadow: false,
    hwaccel: false,
    top: '50%',
    left: '50%',
    position: 'absolute',
    zIndex: 999
  };
  var Spinner = function (_Component) {
    _inherits(Spinner, _Component);
    function Spinner() {
      _classCallCheck(this, Spinner);
      return _possibleConstructorReturn(this, (Spinner.__proto__ || Object.getPrototypeOf(Spinner)).apply(this, arguments));
    }
    _createClass(Spinner, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.instantiateSpinner(this.props);
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(newProps) {
        if (newProps.config.color !== this.props.config.color) {
          this.spinner.stop();
          // the Spinner API doesn't provide a method to change its options after instantiation,
          // so the only way to do so is to reinstantiate the spinner ¯\_(ツ)_/¯
          this.instantiateSpinner(newProps);
        } else {
          if (newProps.stopped === true && !this.props.stopped) {
            this.spinner.stop();
          } else if (!newProps.stopped && this.props.stopped === true) {
            this.spinner.spin(this.container);
          }
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.spinner.stop();
      }
    }, {
      key: 'instantiateSpinner',
      value: function instantiateSpinner(props) {
        this.spinner = new _spin2.default(_extends({}, defaultConfig, props.config));
        if (!props.stopped) {
          this.spinner.spin(this.container);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;
        return _react2.default.createElement('div', {
          ref: function ref(node) {
            _this2.container = node;
          }
        });
      }
    }]);
    return Spinner;
  }(_react.Component);
  Spinner.propTypes = {
    config: _propTypes2.default.object,
    stopped: _propTypes2.default.bool,
    className: _propTypes2.default.string,
    style: _propTypes2.default.object
  };
  Spinner.defaultProps = {
    config: defaultConfig,
    className: '',
    style: {}
  };
  exports.default = Spinner;

  /***/
}), ( /* 94 */
/***/function (module, exports, __webpack_require__) {
  var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__; /**
                                                                     * Copyright (c) 2011-2014 Felix Gnass
                                                                     * Licensed under the MIT license
                                                                     * http://spin.js.org/
                                                                     *
                                                                     * Example:
                                                                     var opts = {
                                                                     lines: 12             // The number of lines to draw
                                                                     , length: 7             // The length of each line
                                                                     , width: 5              // The line thickness
                                                                     , radius: 10            // The radius of the inner circle
                                                                     , scale: 1.0            // Scales overall size of the spinner
                                                                     , corners: 1            // Roundness (0..1)
                                                                     , color: '#000'         // #rgb or #rrggbb
                                                                     , opacity: 1/4          // Opacity of the lines
                                                                     , rotate: 0             // Rotation offset
                                                                     , direction: 1          // 1: clockwise, -1: counterclockwise
                                                                     , speed: 1              // Rounds per second
                                                                     , trail: 100            // Afterglow percentage
                                                                     , fps: 20               // Frames per second when using setTimeout()
                                                                     , zIndex: 2e9           // Use a high z-index by default
                                                                     , className: 'spinner'  // CSS class to assign to the element
                                                                     , top: '50%'            // center vertically
                                                                     , left: '50%'           // center horizontally
                                                                     , shadow: false         // Whether to render a shadow
                                                                     , hwaccel: false        // Whether to use hardware acceleration (might be buggy)
                                                                     , position: 'absolute'  // Element positioning
                                                                     }
                                                                     var target = document.getElementById('foo')
                                                                     var spinner = new Spinner(opts).spin(target)
                                                                     */
  ;
  (function (root, factory) {
    /* CommonJS */
    if (typeof module == 'object' && module.exports) module.exports = factory();

    /* AMD module */else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = factory, __WEBPACK_AMD_DEFINE_RESULT__ = typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? __WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module) : __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    /* Browser global */else root.Spinner = factory();
  })(this, function () {
    "use strict";

    var prefixes = ['webkit', 'Moz', 'ms', 'O'] /* Vendor prefixes */,
      animations = {} /* Animation rules keyed by their name */,
      useCssAnimations /* Whether to use CSS animations or setTimeout */,
      sheet; /* A stylesheet to hold the @keyframe or VML rules. */

    /**
     * Utility function to create elements. If no tag name is given,
     * a DIV is created. Optionally properties can be passed.
     */
    function createEl(tag, prop) {
      var el = document.createElement(tag || 'div'),
        n;
      for (n in prop) el[n] = prop[n];
      return el;
    }

    /**
     * Appends children and returns the parent.
     */
    function ins(parent /* child1, child2, ...*/) {
      for (var i = 1, n = arguments.length; i < n; i++) {
        parent.appendChild(arguments[i]);
      }
      return parent;
    }

    /**
     * Creates an opacity keyframe animation rule and returns its name.
     * Since most mobile Webkits have timing issues with animation-delay,
     * we create separate rules for each line/segment.
     */
    function addAnimation(alpha, trail, i, lines) {
      var name = ['opacity', trail, ~~(alpha * 100), i, lines].join('-'),
        start = 0.01 + i / lines * 100,
        z = Math.max(1 - (1 - alpha) / trail * (100 - start), alpha),
        prefix = useCssAnimations.substring(0, useCssAnimations.indexOf('Animation')).toLowerCase(),
        pre = prefix && '-' + prefix + '-' || '';
      if (!animations[name]) {
        sheet.insertRule('@' + pre + 'keyframes ' + name + '{' + '0%{opacity:' + z + '}' + start + '%{opacity:' + alpha + '}' + (start + 0.01) + '%{opacity:1}' + (start + trail) % 100 + '%{opacity:' + alpha + '}' + '100%{opacity:' + z + '}' + '}', sheet.cssRules.length);
        animations[name] = 1;
      }
      return name;
    }

    /**
     * Tries various vendor prefixes and returns the first supported property.
     */
    function vendor(el, prop) {
      var s = el.style,
        pp,
        i;
      prop = prop.charAt(0).toUpperCase() + prop.slice(1);
      if (s[prop] !== undefined) return prop;
      for (i = 0; i < prefixes.length; i++) {
        pp = prefixes[i] + prop;
        if (s[pp] !== undefined) return pp;
      }
    }

    /**
     * Sets multiple style properties at once.
     */
    function css(el, prop) {
      for (var n in prop) {
        el.style[vendor(el, n) || n] = prop[n];
      }
      return el;
    }

    /**
     * Fills in default values.
     */
    function merge(obj) {
      for (var i = 1; i < arguments.length; i++) {
        var def = arguments[i];
        for (var n in def) {
          if (obj[n] === undefined) obj[n] = def[n];
        }
      }
      return obj;
    }

    /**
     * Returns the line color from the given string or array.
     */
    function getColor(color, idx) {
      return typeof color == 'string' ? color : color[idx % color.length];
    }

    // Built-in defaults

    var defaults = {
      lines: 12 // The number of lines to draw
      ,
      length: 7 // The length of each line
      ,
      width: 5 // The line thickness
      ,
      radius: 10 // The radius of the inner circle
      ,
      scale: 1.0 // Scales overall size of the spinner
      ,
      corners: 1 // Roundness (0..1)
      ,
      color: '#000' // #rgb or #rrggbb
      ,
      opacity: 1 / 4 // Opacity of the lines
      ,
      rotate: 0 // Rotation offset
      ,
      direction: 1 // 1: clockwise, -1: counterclockwise
      ,
      speed: 1 // Rounds per second
      ,
      trail: 100 // Afterglow percentage
      ,
      fps: 20 // Frames per second when using setTimeout()
      ,
      zIndex: 2e9 // Use a high z-index by default
      ,
      className: 'spinner' // CSS class to assign to the element
      ,
      top: '50%' // center vertically
      ,
      left: '50%' // center horizontally
      ,
      shadow: false // Whether to render a shadow
      ,
      hwaccel: false // Whether to use hardware acceleration (might be buggy)
      ,
      position: 'absolute' // Element positioning
    };

    /** The constructor */
    function Spinner(o) {
      this.opts = merge(o || {}, Spinner.defaults, defaults);
    }

    // Global defaults that override the built-ins:
    Spinner.defaults = {};
    merge(Spinner.prototype, {
      /**
       * Adds the spinner to the given target element. If this instance is already
       * spinning, it is automatically removed from its previous target b calling
       * stop() internally.
       */
      spin: function (target) {
        this.stop();
        var self = this,
          o = self.opts,
          el = self.el = createEl(null, {
            className: o.className
          });
        css(el, {
          position: o.position,
          width: 0,
          zIndex: o.zIndex,
          left: o.left,
          top: o.top
        });
        if (target) {
          target.insertBefore(el, target.firstChild || null);
        }
        el.setAttribute('role', 'progressbar');
        self.lines(el, self.opts);
        if (!useCssAnimations) {
          // No CSS animation support, use setTimeout() instead
          var i = 0,
            start = (o.lines - 1) * (1 - o.direction) / 2,
            alpha,
            fps = o.fps,
            f = fps / o.speed,
            ostep = (1 - o.opacity) / (f * o.trail / 100),
            astep = f / o.lines;
          (function anim() {
            i++;
            for (var j = 0; j < o.lines; j++) {
              alpha = Math.max(1 - (i + (o.lines - j) * astep) % f * ostep, o.opacity);
              self.opacity(el, j * o.direction + start, alpha, o);
            }
            self.timeout = self.el && setTimeout(anim, ~~(1000 / fps));
          })();
        }
        return self;
      }

      /**
       * Stops and removes the Spinner.
       */,
      stop: function () {
        var el = this.el;
        if (el) {
          clearTimeout(this.timeout);
          if (el.parentNode) el.parentNode.removeChild(el);
          this.el = undefined;
        }
        return this;
      }

      /**
       * Internal method that draws the individual lines. Will be overwritten
       * in VML fallback mode below.
       */,
      lines: function (el, o) {
        var i = 0,
          start = (o.lines - 1) * (1 - o.direction) / 2,
          seg;
        function fill(color, shadow) {
          return css(createEl(), {
            position: 'absolute',
            width: o.scale * (o.length + o.width) + 'px',
            height: o.scale * o.width + 'px',
            background: color,
            boxShadow: shadow,
            transformOrigin: 'left',
            transform: 'rotate(' + ~~(360 / o.lines * i + o.rotate) + 'deg) translate(' + o.scale * o.radius + 'px' + ',0)',
            borderRadius: (o.corners * o.scale * o.width >> 1) + 'px'
          });
        }
        for (; i < o.lines; i++) {
          seg = css(createEl(), {
            position: 'absolute',
            top: 1 + ~(o.scale * o.width / 2) + 'px',
            transform: o.hwaccel ? 'translate3d(0,0,0)' : '',
            opacity: o.opacity,
            animation: useCssAnimations && addAnimation(o.opacity, o.trail, start + i * o.direction, o.lines) + ' ' + 1 / o.speed + 's linear infinite'
          });
          if (o.shadow) ins(seg, css(fill('#000', '0 0 4px #000'), {
            top: '2px'
          }));
          ins(el, ins(seg, fill(getColor(o.color, i), '0 0 1px rgba(0,0,0,.1)')));
        }
        return el;
      }

      /**
       * Internal method that adjusts the opacity of a single line.
       * Will be overwritten in VML fallback mode below.
       */,
      opacity: function (el, i, val) {
        if (i < el.childNodes.length) el.childNodes[i].style.opacity = val;
      }
    });
    function initVML() {
      /* Utility function to create a VML tag */
      function vml(tag, attr) {
        return createEl('<' + tag + ' xmlns="urn:schemas-microsoft.com:vml" class="spin-vml">', attr);
      }

      // No CSS transforms but VML support, add a CSS rule for VML elements:
      sheet.addRule('.spin-vml', 'behavior:url(#default#VML)');
      Spinner.prototype.lines = function (el, o) {
        var r = o.scale * (o.length + o.width),
          s = o.scale * 2 * r;
        function grp() {
          return css(vml('group', {
            coordsize: s + ' ' + s,
            coordorigin: -r + ' ' + -r
          }), {
            width: s,
            height: s
          });
        }
        var margin = -(o.width + o.length) * o.scale * 2 + 'px',
          g = css(grp(), {
            position: 'absolute',
            top: margin,
            left: margin
          }),
          i;
        function seg(i, dx, filter) {
          ins(g, ins(css(grp(), {
            rotation: 360 / o.lines * i + 'deg',
            left: ~~dx
          }), ins(css(vml('roundrect', {
            arcsize: o.corners
          }), {
            width: r,
            height: o.scale * o.width,
            left: o.scale * o.radius,
            top: -o.scale * o.width >> 1,
            filter: filter
          }), vml('fill', {
            color: getColor(o.color, i),
            opacity: o.opacity
          }), vml('stroke', {
            opacity: 0
          }) // transparent stroke to fix color bleeding upon opacity change
          )));
        }
        if (o.shadow) for (i = 1; i <= o.lines; i++) {
          seg(i, -2, 'progid:DXImageTransform.Microsoft.Blur(pixelradius=2,makeshadow=1,shadowopacity=.3)');
        }
        for (i = 1; i <= o.lines; i++) seg(i);
        return ins(el, g);
      };
      Spinner.prototype.opacity = function (el, i, val, o) {
        var c = el.firstChild;
        o = o.shadow && o.lines || 0;
        if (c && i + o < c.childNodes.length) {
          c = c.childNodes[i + o];
          c = c && c.firstChild;
          c = c && c.firstChild;
          if (c) c.opacity = val;
        }
      };
    }
    if (typeof document !== 'undefined') {
      sheet = function () {
        var el = createEl('style', {
          type: 'text/css'
        });
        ins(document.getElementsByTagName('head')[0], el);
        return el.sheet || el.styleSheet;
      }();
      var probe = css(createEl('group'), {
        behavior: 'url(#default#VML)'
      });
      if (!vendor(probe, 'transform') && probe.adj) initVML();else useCssAnimations = vendor(probe, 'animation');
    }
    return Spinner;
  });

  /***/
}), ( /* 95 */
/***/function (module, exports) {
  module.exports = "data:image/gif;base64,R0lGODlhEQARAIAAAODn7P///yH5BAEHAAEALAAAAAARABEAAAIqBIKpab3v3EMyVHWtWZluf0za0XFNKDJfCq5i5JpomdUxqKLQVmInqyoAADs=";

  /***/
}), ( /* 96 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _react = __webpack_require__(2);
  var _react2 = _interopRequireDefault(_react);
  var _propTypes = __webpack_require__(4);
  var _propTypes2 = _interopRequireDefault(_propTypes);
  var _styles = __webpack_require__(17);
  var _styles2 = _interopRequireDefault(_styles);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  var Root = /*#__PURE__*/(0, _styles2.default)('div', {
    target: 'e1m9xwad0'
  })('position:absolute;z-index:1001;top:0;right:0;font-size:20px;font-family:sans-serif;width:50px;height:50px;');
  var closeArrow = /*#__PURE__*/(0, _styles.css)('border-radius:0;display:block;height:2px;width:25px;position:absolute;right:6px;top:6px;');
  var ArrowLeft = /*#__PURE__*/(0, _styles2.default)('span', {
    target: 'e1m9xwad1'
  })(closeArrow, ' background-color:', function (p) {
    return p.backgroundColor;
  }, ';transform:translate(0,13px) rotate3d(0,0,1,-135deg);');
  var ArrowRight = /*#__PURE__*/(0, _styles2.default)('span', {
    target: 'e1m9xwad2'
  })(closeArrow, ' background-color:', function (p) {
    return p.backgroundColor;
  }, ';transform:translate(0,13px) rotate3d(0,0,1,-45deg);');
  var CloseIcon = function CloseIcon(_ref) {
    var color = _ref.color,
      onClick = _ref.onClick,
      dataQa = _ref.dataQa;
    return _react2.default.createElement(Root, {
      'data-qa': dataQa,
      onClick: onClick
    }, _react2.default.createElement(ArrowLeft, {
      backgroundColor: color
    }), _react2.default.createElement(ArrowRight, {
      backgroundColor: color
    }));
  };
  CloseIcon.propTypes = {
    color: _propTypes2.default.string,
    dataQa: _propTypes2.default.string,
    onClick: _propTypes2.default.func
  };
  exports.default = CloseIcon;

  /***/
}), ( /* 97 */
/***/function (module, exports, __webpack_require__) {
  var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
  (function (global, factory) {
    if (true) {
      !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, module], __WEBPACK_AMD_DEFINE_FACTORY__ = factory, __WEBPACK_AMD_DEFINE_RESULT__ = typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__) : __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== 'undefined' && typeof module !== 'undefined') {
      factory(exports, module);
    } else {
      var mod = {
        exports: {}
      };
      factory(mod.exports, mod);
      global.fetchJsonp = mod.exports;
    }
  })(this, function (exports, module) {
    'use strict';

    var defaultOptions = {
      timeout: 5000,
      jsonpCallback: 'callback',
      jsonpCallbackFunction: null
    };
    function generateCallbackFunction() {
      return 'jsonp_' + Date.now() + '_' + Math.ceil(Math.random() * 100000);
    }
    function clearFunction(functionName) {
      // IE8 throws an exception when you try to delete a property on window
      // http://stackoverflow.com/a/1824228/751089
      try {
        delete window[functionName];
      } catch (e) {
        window[functionName] = undefined;
      }
    }
    function removeScript(scriptId) {
      var script = document.getElementById(scriptId);
      if (script) {
        document.getElementsByTagName('head')[0].removeChild(script);
      }
    }
    function fetchJsonp(_url) {
      var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

      // to avoid param reassign
      var url = _url;
      var timeout = options.timeout || defaultOptions.timeout;
      var jsonpCallback = options.jsonpCallback || defaultOptions.jsonpCallback;
      var timeoutId = undefined;
      return new Promise(function (resolve, reject) {
        var callbackFunction = options.jsonpCallbackFunction || generateCallbackFunction();
        var scriptId = jsonpCallback + '_' + callbackFunction;
        window[callbackFunction] = function (response) {
          resolve({
            ok: true,
            // keep consistent with fetch API
            json: function json() {
              return Promise.resolve(response);
            }
          });
          if (timeoutId) clearTimeout(timeoutId);
          removeScript(scriptId);
          clearFunction(callbackFunction);
        };

        // Check if the user set their own params, and if not add a ? to start a list of params
        url += url.indexOf('?') === -1 ? '?' : '&';
        var jsonpScript = document.createElement('script');
        jsonpScript.setAttribute('src', '' + url + jsonpCallback + '=' + callbackFunction);
        if (options.charset) {
          jsonpScript.setAttribute('charset', options.charset);
        }
        jsonpScript.id = scriptId;
        document.getElementsByTagName('head')[0].appendChild(jsonpScript);
        timeoutId = setTimeout(function () {
          reject(new Error('JSONP request to ' + _url + ' timed out'));
          clearFunction(callbackFunction);
          removeScript(scriptId);
          window[callbackFunction] = function () {
            clearFunction(callbackFunction);
          };
        }, timeout);

        // Caught if got 404/500
        jsonpScript.onerror = function () {
          reject(new Error('JSONP request to ' + _url + ' failed'));
          clearFunction(callbackFunction);
          removeScript(scriptId);
          if (timeoutId) clearTimeout(timeoutId);
        };
      });
    }

    // export as global function
    /*
    let local;
    if (typeof global !== 'undefined') {
      local = global;
    } else if (typeof self !== 'undefined') {
      local = self;
    } else {
      try {
        local = Function('return this')();
      } catch (e) {
        throw new Error('polyfill failed because global object is unavailable in this environment');
      }
    }
    local.fetchJsonp = fetchJsonp;
    */

    module.exports = fetchJsonp;
  });

  /***/
}), ( /* 98 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  exports.default = makeWidget;
  var _react = __webpack_require__(2);
  var _react2 = _interopRequireDefault(_react);
  var _reactDom = __webpack_require__(2);
  var _utils = __webpack_require__(9);
  var _mobileDetection = __webpack_require__(16);
  var _widget = __webpack_require__(99);
  var _widget2 = _interopRequireDefault(_widget);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  var defaultOptions = {
    mode: 'embed-widget',
    hideFooter: false,
    hideHeaders: false,
    hideScrollbars: false,
    disableTracking: false,
    onSubmit: _utils.noop
  };
  var queryStringKeys = {
    mode: 'typeform-embed',
    hideFooter: 'embed-hide-footer',
    hideHeaders: 'embed-hide-headers',
    opacity: 'embed-opacity',
    disableTracking: 'disable-tracking'
  };
  function makeWidget(element, url, options) {
    options = _extends({}, defaultOptions, options);
    var enabledFullscreen = (0, _mobileDetection.isMobile)(navigator.userAgent);
    var queryStrings = (0, _utils.replaceExistingKeys)(options, queryStringKeys);
    if (enabledFullscreen) {
      queryStrings = _extends({}, (0, _utils.omit)('embed-opacity', queryStrings), {
        'add-placeholder-ws': true
      });
    }
    var urlWithQueryString = (0, _utils.appendParamsToUrl)(url, queryStrings);
    var embedId = (0, _utils.randomString)();
    (0, _reactDom.render)(_react2.default.createElement(_widget2.default, {
      embedId: embedId,
      enabledFullscreen: enabledFullscreen,
      options: options,
      url: urlWithQueryString
    }), element);
  }

  /***/
}), ( /* 99 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _react = __webpack_require__(2);
  var _react2 = _interopRequireDefault(_react);
  var _propTypes = __webpack_require__(4);
  var _propTypes2 = _interopRequireDefault(_propTypes);
  var _styles = __webpack_require__(17);
  var _styles2 = _interopRequireDefault(_styles);
  var _mobileModal = __webpack_require__(46);
  var _mobileModal2 = _interopRequireDefault(_mobileModal);
  var _utils = __webpack_require__(9);
  var _iframe = __webpack_require__(26);
  var _iframe2 = _interopRequireDefault(_iframe);
  var _dataService = __webpack_require__(47);
  var _dataService2 = _interopRequireDefault(_dataService);
  var _store = __webpack_require__(48);
  var _store2 = _interopRequireDefault(_store);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var DEBOUNCE_WAIT = 200;
  var WidgetWrapper = /*#__PURE__*/(0, _styles2.default)('div', {
    target: 'e12baen60'
  })('height:100%;position:relative;');
  var checkEmbedHash = function checkEmbedHash(embedId, event) {
    return event.detail && event.detail.embedId === embedId;
  };
  var PlaceholderAnimationAppear = /*#__PURE__*/(0, _styles.keyframes)('10%{opacity:1;}25%{top:0;left:0;width:100%;height:100%;opacity:1;}70%{top:0;left:0;width:100%;height:100%;opacity:1;}100%{top:0;left:0;width:100%;height:100%;opacity:0;}');
  var PlaceholderAnimationDisappear = /*#__PURE__*/(0, _styles.keyframes)('100%{opacity:0;}75%{opacity:1;}25%{opacity:1;}0%{opacity:0;}');
  var Placeholder = /*#__PURE__*/(0, _styles2.default)('div', {
    target: 'e12baen61'
  })('position:fixed;top:', function (props) {
    return props.top;
  }, 'px;left:', function (props) {
    return props.left;
  }, 'px;height:', function (props) {
    return props.height ? props.height + 'px' : '100%';
  }, ';width:', function (props) {
    return props.width ? props.width + 'px' : '100%';
  }, ';animation:', function (props) {
    return props.open ? PlaceholderAnimationAppear : PlaceholderAnimationDisappear;
  }, ' 1.5s ease;visibility:', function (props) {
    return props.visible ? 'visible' : 'hidden';
  }, ';background:', function (props) {
    return props.backgroundColor;
  }, ';opacity:0;pointer-events:none;');
  var IframeWrapper = /*#__PURE__*/(0, _styles2.default)('div', {
    target: 'e12baen62'
  })('height:100%;width:100%;overflow:hidden;background:', function (props) {
    return props.backgroundColor;
  }, ';');
  var Widget = function (_Component) {
    _inherits(Widget, _Component);
    function Widget(props) {
      _classCallCheck(this, Widget);
      var _this = _possibleConstructorReturn(this, (Widget.__proto__ || Object.getPrototypeOf(Widget)).call(this, props));
      _this.state = {
        isFormReady: false,
        isIframeFocused: false,
        isFullscreen: false,
        closeIconColor: 'black',
        backgroundColor: 'transparent'
      };
      _this.onFormReady = _this.onFormReady.bind(_this);
      _this.focusIframe = _this.focusIframe.bind(_this);
      _this.onFormSubmit = _this.onFormSubmit.bind(_this);
      _this.goFullScreen = _this.goFullScreen.bind(_this);
      _this.handleClose = _this.handleClose.bind(_this);
      _this.reloadIframe = _this.reloadIframe.bind(_this);
      _this.debouncedScroll = (0, _utils.debounce)(_this.focusIframe, DEBOUNCE_WAIT, _this);
      return _this;
    }
    _createClass(Widget, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;
        window.addEventListener('message', _utils.onMessage);
        window.addEventListener('form-ready', this.onFormReady);
        window.addEventListener('scroll', this.debouncedScroll);
        window.addEventListener('form-submit', this.onFormSubmit);
        window.addEventListener('welcome-screen-hidden', this.goFullScreen);
        window.addEventListener('redirect-after-submit', _utils.redirectAfterSubmit);
        var uid = _dataService2.default.getUidFromURL(this.props.url);
        _dataService2.default.getFormData(uid, _utils.DOMAIN).then(function (resp) {
          return (0, _store2.default)(uid, '', _this2.props.url, '', resp);
        }).then(function (data) {
          _this2.setState({
            closeIconColor: '#' + data.form['button-color'],
            backgroundColor: '#' + data.form['background-color']
          });
        });
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        window.removeEventListener('message', _utils.onMessage);
        window.removeEventListener('form-ready', this.onFormReady);
        window.removeEventListener('scroll', this.debouncedScroll);
        window.removeEventListener('form-submit', this.onFormSubmit);
        window.removeEventListener('welcome-screen-hidden', this.goFullScreen);
        window.addEventListener('redirect-after-submit', _utils.redirectAfterSubmit);
      }
    }, {
      key: 'goFullScreen',
      value: function goFullScreen(event) {
        if (!checkEmbedHash(this.props.embedId, event)) {
          return;
        }
        if (this.props.enabledFullscreen) {
          this.setState({
            isFullscreen: true
          });
          setTimeout(this.reloadIframe, 3000);
        }
      }
    }, {
      key: 'handleClose',
      value: function handleClose() {
        this.setState({
          isFullscreen: false
        });
      }
    }, {
      key: 'onFormReady',
      value: function onFormReady() {
        var _this3 = this;
        this.setState({
          isFormReady: true
        }, function () {
          _this3.focusIframe();
        });
      }
    }, {
      key: 'reloadIframe',
      value: function reloadIframe() {
        // Re-assign the source of the iframe, makes it reload cross-browser
        this.iframe.iframeRef.src = this.iframe.iframeRef.src;
      }
    }, {
      key: 'onFormSubmit',
      value: function onFormSubmit() {
        var options = this.props.options;
        options.onSubmit && options.onSubmit();
      }
    }, {
      key: 'focusIframe',
      value: function focusIframe() {
        if (this.props.enabledFullscreen) return;
        var iframeRef = this.iframe.iframeRef;
        if (!iframeRef || !iframeRef.contentWindow) {
          return;
        }
        var isIframeInViewport = (0, _utils.isElementInViewport)(iframeRef);
        var canPostMessage = this.state.isFormReady && !this.state.isIframeFocused && isIframeInViewport && iframeRef.contentWindow != null;
        if (canPostMessage) {
          iframeRef.contentWindow.postMessage('embed-focus', '*');
          this.setState({
            isIframeFocused: true
          });
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _this4 = this;
        var _state = this.state,
          isFullscreen = _state.isFullscreen,
          closeIconColor = _state.closeIconColor,
          backgroundColor = _state.backgroundColor,
          isFormReady = _state.isFormReady;
        var enabledFullscreen = this.props.enabledFullscreen;
        var iframePosition = this.iframe && this.iframe.iframeRef.getBoundingClientRect();
        var inlineIframeUrl = (0, _utils.updateQueryStringParameter)('typeform-embed-id', this.props.embedId, this.props.url);
        if (enabledFullscreen) {
          inlineIframeUrl = (0, _utils.updateQueryStringParameter)('disable-tracking', 'true', inlineIframeUrl);
        }
        var fullscreenIframeUrl = (0, _utils.updateQueryStringParameter)('typeform-welcome', '0', this.props.url);
        return _react2.default.createElement(WidgetWrapper, null, _react2.default.createElement(IframeWrapper, {
          backgroundColor: enabledFullscreen ? backgroundColor : 'transparent'
        }, _react2.default.createElement(_iframe2.default, {
          frameBorder: '0',
          height: '100%',
          ref: function ref(node) {
            _this4.iframe = node;
          },
          src: inlineIframeUrl,
          width: '100%'
        })), enabledFullscreen && _react2.default.createElement(Placeholder, {
          backgroundColor: backgroundColor,
          bottom: iframePosition && iframePosition.bottom,
          height: iframePosition && iframePosition.height,
          left: iframePosition && iframePosition.left,
          open: isFullscreen,
          right: iframePosition && iframePosition.right,
          top: iframePosition && iframePosition.top,
          visible: isFormReady,
          width: iframePosition && iframePosition.width
        }), enabledFullscreen && _react2.default.createElement(_mobileModal2.default, {
          backgroundColor: backgroundColor,
          buttonColor: closeIconColor,
          onClose: this.handleClose,
          open: isFullscreen,
          openDelay: 0.3,
          url: fullscreenIframeUrl
        }));
      }
    }]);
    return Widget;
  }(_react.Component);
  Widget.propTypes = {
    url: _propTypes2.default.string,
    options: _propTypes2.default.object.isRequired,
    enabledFullscreen: _propTypes2.default.bool,
    embedId: _propTypes2.default.string
  };
  Widget.defaultProps = {
    options: {},
    enabledFullscreen: false
  };
  exports.default = Widget;

  /***/
}), ( /* 100 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  exports.default = makeFullScreen;
  var _utils = __webpack_require__(9);
  var defaultOptions = {
    mode: 'embed-fullpage',
    disableTracking: false,
    onSubmit: _utils.noop
  };
  var queryStringKeys = {
    mode: 'typeform-embed',
    disableTracking: 'disable-tracking'
  };
  function makeFullScreen(iframe, url, options) {
    options = _extends({}, defaultOptions, options);
    iframe.src = (0, _utils.appendParamsToUrl)(url, (0, _utils.replaceExistingKeys)(options, queryStringKeys));
    var onFormSubmit = function onFormSubmit() {
      options.onSubmit();
    };
    (0, _utils.ensureMetaViewport)();

    // Fix scroll inside the iframe (renderer v1)
    iframe.onload = function () {
      setTimeout(function () {
        iframe.style.height = '';
        (0, _utils.applyIOSFooterHack)(iframe);
        (0, _utils.applyIOSIframeResizeHack)(iframe);
      }, 1);
      iframe.contentWindow.focus();
    };
    window.addEventListener('message', _utils.onMessage);
    window.addEventListener('form-submit', onFormSubmit);
  }

  /***/
}), ( /* 101 */
/***/function (module, exports, __webpack_require__) {
  var assign = __webpack_require__(102);

  // `Object.assign` method
  // https://tc39.github.io/ecma262/#sec-object.assign
  __webpack_require__(12)({
    target: 'Object',
    stat: true,
    forced: Object.assign !== assign
  }, {
    assign: assign
  });

  /***/
}), ( /* 102 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  // 19.1.2.1 Object.assign(target, source, ...)
  var objectKeys = __webpack_require__(49);
  var getOwnPropertySymbolsModule = __webpack_require__(51);
  var propertyIsEnumerableModule = __webpack_require__(52);
  var toObject = __webpack_require__(33);
  var IndexedObject = __webpack_require__(27);
  var nativeAssign = Object.assign;

  // should work with symbols and should have deterministic property order (V8 bug)
  module.exports = !nativeAssign || __webpack_require__(10)(function () {
    var A = {};
    var B = {};
    // eslint-disable-next-line no-undef
    var symbol = Symbol();
    var alphabet = 'abcdefghijklmnopqrst';
    A[symbol] = 7;
    alphabet.split('').forEach(function (chr) {
      B[chr] = chr;
    });
    return nativeAssign({}, A)[symbol] != 7 || objectKeys(nativeAssign({}, B)).join('') != alphabet;
  }) ? function assign(target, source) {
    // eslint-disable-line no-unused-vars
    var T = toObject(target);
    var argumentsLength = arguments.length;
    var index = 1;
    var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
    var propertyIsEnumerable = propertyIsEnumerableModule.f;
    while (argumentsLength > index) {
      var S = IndexedObject(arguments[index++]);
      var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
      var length = keys.length;
      var j = 0;
      var key;
      while (length > j) if (propertyIsEnumerable.call(S, key = keys[j++])) T[key] = S[key];
    }
    return T;
  } : nativeAssign;

  /***/
}), ( /* 103 */
/***/function (module, exports, __webpack_require__) {
  var toIndexedObject = __webpack_require__(18);
  var toLength = __webpack_require__(29);
  var toAbsoluteIndex = __webpack_require__(104);

  // `Array.prototype.{ indexOf, includes }` methods implementation
  // false -> Array#indexOf
  // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
  // true  -> Array#includes
  // https://tc39.github.io/ecma262/#sec-array.prototype.includes
  module.exports = function (IS_INCLUDES) {
    return function ($this, el, fromIndex) {
      var O = toIndexedObject($this);
      var length = toLength(O.length);
      var index = toAbsoluteIndex(fromIndex, length);
      var value;
      // Array#includes uses SameValueZero equality algorithm
      // eslint-disable-next-line no-self-compare
      if (IS_INCLUDES && el != el) while (length > index) {
        value = O[index++];
        // eslint-disable-next-line no-self-compare
        if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
      } else for (; length > index; index++) if (IS_INCLUDES || index in O) {
        if (O[index] === el) return IS_INCLUDES || index || 0;
      }
      return !IS_INCLUDES && -1;
    };
  };

  /***/
}), ( /* 104 */
/***/function (module, exports, __webpack_require__) {
  var toInteger = __webpack_require__(30);
  var max = Math.max;
  var min = Math.min;

  // Helper for a popular repeating case of the spec:
  // Let integer be ? ToInteger(index).
  // If integer < 0, let result be max((length + integer), 0); else let result be min(length, length).
  module.exports = function (index, length) {
    var integer = toInteger(index);
    return integer < 0 ? max(integer + length, 0) : min(integer, length);
  };

  /***/
}), ( /* 105 */
/***/function (module, exports, __webpack_require__) {
  var nativeFunctionToString = __webpack_require__(55);
  var WeakMap = __webpack_require__(0).WeakMap;
  module.exports = typeof WeakMap === 'function' && /native code/.test(nativeFunctionToString.call(WeakMap));

  /***/
}), ( /* 106 */
/***/function (module, exports, __webpack_require__) {
  var has = __webpack_require__(7);
  var ownKeys = __webpack_require__(107);
  var getOwnPropertyDescriptorModule = __webpack_require__(34);
  var definePropertyModule = __webpack_require__(14);
  module.exports = function (target, source) {
    var keys = ownKeys(source);
    var defineProperty = definePropertyModule.f;
    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  };

  /***/
}), ( /* 107 */
/***/function (module, exports, __webpack_require__) {
  var getOwnPropertyNamesModule = __webpack_require__(108);
  var getOwnPropertySymbolsModule = __webpack_require__(51);
  var anObject = __webpack_require__(6);
  var Reflect = __webpack_require__(0).Reflect;

  // all object keys, includes non-enumerable and symbols
  module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
    var keys = getOwnPropertyNamesModule.f(anObject(it));
    var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
    return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
  };

  /***/
}), ( /* 108 */
/***/function (module, exports, __webpack_require__) {
  // 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
  var internalObjectKeys = __webpack_require__(50);
  var hiddenKeys = __webpack_require__(32).concat('length', 'prototype');
  exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return internalObjectKeys(O, hiddenKeys);
  };

  /***/
}), ( /* 109 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var internalFind = __webpack_require__(110)(5);
  var FIND = 'find';
  var SKIPS_HOLES = true;

  // Shouldn't skip holes
  if (FIND in []) Array(1)[FIND](function () {
    SKIPS_HOLES = false;
  });

  // `Array.prototype.find` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.find
  __webpack_require__(12)({
    target: 'Array',
    proto: true,
    forced: SKIPS_HOLES
  }, {
    find: function find(callbackfn /* , that = undefined */) {
      return internalFind(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
  });

  // https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
  __webpack_require__(58)(FIND);

  /***/
}), ( /* 110 */
/***/function (module, exports, __webpack_require__) {
  var bind = __webpack_require__(39);
  var IndexedObject = __webpack_require__(27);
  var toObject = __webpack_require__(33);
  var toLength = __webpack_require__(29);
  var arraySpeciesCreate = __webpack_require__(111);

  // `Array.prototype.{ forEach, map, filter, some, every, find, findIndex }` methods implementation
  // 0 -> Array#forEach
  // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
  // 1 -> Array#map
  // https://tc39.github.io/ecma262/#sec-array.prototype.map
  // 2 -> Array#filter
  // https://tc39.github.io/ecma262/#sec-array.prototype.filter
  // 3 -> Array#some
  // https://tc39.github.io/ecma262/#sec-array.prototype.some
  // 4 -> Array#every
  // https://tc39.github.io/ecma262/#sec-array.prototype.every
  // 5 -> Array#find
  // https://tc39.github.io/ecma262/#sec-array.prototype.find
  // 6 -> Array#findIndex
  // https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
  module.exports = function (TYPE, specificCreate) {
    var IS_MAP = TYPE == 1;
    var IS_FILTER = TYPE == 2;
    var IS_SOME = TYPE == 3;
    var IS_EVERY = TYPE == 4;
    var IS_FIND_INDEX = TYPE == 6;
    var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
    var create = specificCreate || arraySpeciesCreate;
    return function ($this, callbackfn, that) {
      var O = toObject($this);
      var self = IndexedObject(O);
      var boundFunction = bind(callbackfn, that, 3);
      var length = toLength(self.length);
      var index = 0;
      var target = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
      var value, result;
      for (; length > index; index++) if (NO_HOLES || index in self) {
        value = self[index];
        result = boundFunction(value, index, O);
        if (TYPE) {
          if (IS_MAP) target[index] = result; // map
          else if (result) switch (TYPE) {
            case 3:
              return true;
            // some
            case 5:
              return value;
            // find
            case 6:
              return index;
            // findIndex
            case 2:
              target.push(value);
            // filter
          } else if (IS_EVERY) return false; // every
        }
      }
      return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
    };
  };

  /***/
}), ( /* 111 */
/***/function (module, exports, __webpack_require__) {
  var isObject = __webpack_require__(5);
  var isArray = __webpack_require__(112);
  var SPECIES = __webpack_require__(1)('species');

  // `ArraySpeciesCreate` abstract operation
  // https://tc39.github.io/ecma262/#sec-arrayspeciescreate
  module.exports = function (originalArray, length) {
    var C;
    if (isArray(originalArray)) {
      C = originalArray.constructor;
      // cross-realm fallback
      if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;else if (isObject(C)) {
        C = C[SPECIES];
        if (C === null) C = undefined;
      }
    }
    return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
  };

  /***/
}), ( /* 112 */
/***/function (module, exports, __webpack_require__) {
  var classof = __webpack_require__(11);

  // `IsArray` abstract operation
  // https://tc39.github.io/ecma262/#sec-isarray
  module.exports = Array.isArray || function isArray(arg) {
    return classof(arg) == 'Array';
  };

  /***/
}), ( /* 113 */
/***/function (module, exports, __webpack_require__) {
  // Chrome 38 Symbol has incorrect toString conversion
  module.exports = !__webpack_require__(10)(function () {
    // eslint-disable-next-line no-undef
    return !String(Symbol());
  });

  /***/
}), ( /* 114 */
/***/function (module, exports, __webpack_require__) {
  var DESCRIPTORS = __webpack_require__(13);
  var definePropertyModule = __webpack_require__(14);
  var anObject = __webpack_require__(6);
  var objectKeys = __webpack_require__(49);
  module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
    anObject(O);
    var keys = objectKeys(Properties);
    var length = keys.length;
    var i = 0;
    var key;
    while (length > i) definePropertyModule.f(O, key = keys[i++], Properties[key]);
    return O;
  };

  /***/
}), ( /* 115 */
/***/function (module, exports, __webpack_require__) {
  var isInteger = __webpack_require__(116);
  var abs = Math.abs;

  // `Number.isSafeInteger` method
  // https://tc39.github.io/ecma262/#sec-number.issafeinteger
  __webpack_require__(12)({
    target: 'Number',
    stat: true
  }, {
    isSafeInteger: function isSafeInteger(number) {
      return isInteger(number) && abs(number) <= 0x1FFFFFFFFFFFFF;
    }
  });

  /***/
}), ( /* 116 */
/***/function (module, exports, __webpack_require__) {
  var isObject = __webpack_require__(5);
  var floor = Math.floor;

  // `Number.isInteger` method implementation
  // https://tc39.github.io/ecma262/#sec-number.isinteger
  module.exports = function isInteger(it) {
    return !isObject(it) && isFinite(it) && floor(it) === it;
  };

  /***/
}), ( /* 117 */
/***/function (module, exports, __webpack_require__) {
  __webpack_require__(118);
  __webpack_require__(120);
  __webpack_require__(126);
  __webpack_require__(129);
  __webpack_require__(141);
  module.exports = __webpack_require__(41).Promise;

  /***/
}), ( /* 118 */
/***/function (module, exports, __webpack_require__) {
  var toString = __webpack_require__(119);
  var ObjectPrototype = Object.prototype;

  // `Object.prototype.toString` method
  // https://tc39.github.io/ecma262/#sec-object.prototype.tostring
  if (toString !== ObjectPrototype.toString) {
    __webpack_require__(19)(ObjectPrototype, 'toString', toString, {
      unsafe: true
    });
  }

  /***/
}), ( /* 119 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var classof = __webpack_require__(61);
  var TO_STRING_TAG = __webpack_require__(1)('toStringTag');
  var test = {};
  test[TO_STRING_TAG] = 'z';

  // `Object.prototype.toString` method implementation
  // https://tc39.github.io/ecma262/#sec-object.prototype.tostring
  module.exports = String(test) !== '[object z]' ? function toString() {
    return '[object ' + classof(this) + ']';
  } : test.toString;

  /***/
}), ( /* 120 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var codePointAt = __webpack_require__(121);
  var InternalStateModule = __webpack_require__(22);
  var defineIterator = __webpack_require__(62);
  var STRING_ITERATOR = 'String Iterator';
  var setInternalState = InternalStateModule.set;
  var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

  // `String.prototype[@@iterator]` method
  // https://tc39.github.io/ecma262/#sec-string.prototype-@@iterator
  defineIterator(String, 'String', function (iterated) {
    setInternalState(this, {
      type: STRING_ITERATOR,
      string: String(iterated),
      index: 0
    });
    // `%StringIteratorPrototype%.next` method
    // https://tc39.github.io/ecma262/#sec-%stringiteratorprototype%.next
  }, function next() {
    var state = getInternalState(this);
    var string = state.string;
    var index = state.index;
    var point;
    if (index >= string.length) return {
      value: undefined,
      done: true
    };
    point = codePointAt(string, index, true);
    state.index += point.length;
    return {
      value: point,
      done: false
    };
  });

  /***/
}), ( /* 121 */
/***/function (module, exports, __webpack_require__) {
  var toInteger = __webpack_require__(30);
  var requireObjectCoercible = __webpack_require__(28);
  // CONVERT_TO_STRING: true  -> String#at
  // CONVERT_TO_STRING: false -> String#codePointAt
  module.exports = function (that, pos, CONVERT_TO_STRING) {
    var S = String(requireObjectCoercible(that));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? S.charAt(position) : first : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };

  /***/
}), ( /* 122 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var IteratorPrototype = __webpack_require__(63).IteratorPrototype;
  var create = __webpack_require__(59);
  var createPropertyDescriptor = __webpack_require__(35);
  var setToStringTag = __webpack_require__(40);
  var Iterators = __webpack_require__(15);
  var returnThis = function () {
    return this;
  };
  module.exports = function (IteratorConstructor, NAME, next) {
    var TO_STRING_TAG = NAME + ' Iterator';
    IteratorConstructor.prototype = create(IteratorPrototype, {
      next: createPropertyDescriptor(1, next)
    });
    setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
    Iterators[TO_STRING_TAG] = returnThis;
    return IteratorConstructor;
  };

  /***/
}), ( /* 123 */
/***/function (module, exports, __webpack_require__) {
  module.exports = !__webpack_require__(10)(function () {
    function F() {/* empty */}
    F.prototype.constructor = null;
    return Object.getPrototypeOf(new F()) !== F.prototype;
  });

  /***/
}), ( /* 124 */
/***/function (module, exports, __webpack_require__) {
  // Works with __proto__ only. Old v8 can't work with null proto objects.
  /* eslint-disable no-proto */
  var validateSetPrototypeOfArguments = __webpack_require__(125);
  module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
    var correctSetter = false;
    var test = {};
    var setter;
    try {
      setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
      setter.call(test, []);
      correctSetter = test instanceof Array;
    } catch (error) {/* empty */}
    return function setPrototypeOf(O, proto) {
      validateSetPrototypeOfArguments(O, proto);
      if (correctSetter) setter.call(O, proto);else O.__proto__ = proto;
      return O;
    };
  }() : undefined);

  /***/
}), ( /* 125 */
/***/function (module, exports, __webpack_require__) {
  var isObject = __webpack_require__(5);
  var anObject = __webpack_require__(6);
  module.exports = function (O, proto) {
    anObject(O);
    if (!isObject(proto) && proto !== null) {
      throw TypeError("Can't set " + String(proto) + ' as a prototype');
    }
  };

  /***/
}), ( /* 126 */
/***/function (module, exports, __webpack_require__) {
  var DOMIterables = __webpack_require__(127);
  var ArrayIteratorMethods = __webpack_require__(128);
  var global = __webpack_require__(0);
  var hide = __webpack_require__(8);
  var wellKnownSymbol = __webpack_require__(1);
  var ITERATOR = wellKnownSymbol('iterator');
  var TO_STRING_TAG = wellKnownSymbol('toStringTag');
  var ArrayValues = ArrayIteratorMethods.values;
  for (var COLLECTION_NAME in DOMIterables) {
    var Collection = global[COLLECTION_NAME];
    var CollectionPrototype = Collection && Collection.prototype;
    if (CollectionPrototype) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
        hide(CollectionPrototype, ITERATOR, ArrayValues);
      } catch (error) {
        CollectionPrototype[ITERATOR] = ArrayValues;
      }
      if (!CollectionPrototype[TO_STRING_TAG]) hide(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
      if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
        // some Chrome versions have non-configurable methods on DOMTokenList
        if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
          hide(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
        } catch (error) {
          CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
        }
      }
    }
  }

  /***/
}), ( /* 127 */
/***/function (module, exports) {
  // iterable DOM collections
  // flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
  module.exports = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
  };

  /***/
}), ( /* 128 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var toIndexedObject = __webpack_require__(18);
  var addToUnscopables = __webpack_require__(58);
  var Iterators = __webpack_require__(15);
  var InternalStateModule = __webpack_require__(22);
  var defineIterator = __webpack_require__(62);
  var ARRAY_ITERATOR = 'Array Iterator';
  var setInternalState = InternalStateModule.set;
  var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

  // `Array.prototype.entries` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.entries
  // `Array.prototype.keys` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.keys
  // `Array.prototype.values` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.values
  // `Array.prototype[@@iterator]` method
  // https://tc39.github.io/ecma262/#sec-array.prototype-@@iterator
  // `CreateArrayIterator` internal method
  // https://tc39.github.io/ecma262/#sec-createarrayiterator
  module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
    setInternalState(this, {
      type: ARRAY_ITERATOR,
      target: toIndexedObject(iterated),
      // target
      index: 0,
      // next index
      kind: kind // kind
    });
    // `%ArrayIteratorPrototype%.next` method
    // https://tc39.github.io/ecma262/#sec-%arrayiteratorprototype%.next
  }, function () {
    var state = getInternalState(this);
    var target = state.target;
    var kind = state.kind;
    var index = state.index++;
    if (!target || index >= target.length) {
      state.target = undefined;
      return {
        value: undefined,
        done: true
      };
    }
    if (kind == 'keys') return {
      value: index,
      done: false
    };
    if (kind == 'values') return {
      value: target[index],
      done: false
    };
    return {
      value: [index, target[index]],
      done: false
    };
  }, 'values');

  // argumentsList[@@iterator] is %ArrayProto_values%
  // https://tc39.github.io/ecma262/#sec-createunmappedargumentsobject
  // https://tc39.github.io/ecma262/#sec-createmappedargumentsobject
  Iterators.Arguments = Iterators.Array;

  // https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
  addToUnscopables('keys');
  addToUnscopables('values');
  addToUnscopables('entries');

  /***/
}), ( /* 129 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var PROMISE = 'Promise';
  var IS_PURE = __webpack_require__(21);
  var global = __webpack_require__(0);
  var $export = __webpack_require__(12);
  var isObject = __webpack_require__(5);
  var aFunction = __webpack_require__(23);
  var anInstance = __webpack_require__(130);
  var classof = __webpack_require__(11);
  var iterate = __webpack_require__(131);
  var checkCorrectnessOfIteration = __webpack_require__(135);
  var speciesConstructor = __webpack_require__(65);
  var task = __webpack_require__(66).set;
  var microtask = __webpack_require__(136);
  var promiseResolve = __webpack_require__(68);
  var hostReportErrors = __webpack_require__(137);
  var newPromiseCapabilityModule = __webpack_require__(69);
  var perform = __webpack_require__(138);
  var userAgent = __webpack_require__(67);
  var SPECIES = __webpack_require__(1)('species');
  var InternalStateModule = __webpack_require__(22);
  var isForced = __webpack_require__(57);
  var getInternalState = InternalStateModule.get;
  var setInternalState = InternalStateModule.set;
  var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
  var PromiseConstructor = global[PROMISE];
  var TypeError = global.TypeError;
  var document = global.document;
  var process = global.process;
  var $fetch = global.fetch;
  var versions = process && process.versions;
  var v8 = versions && versions.v8 || '';
  var newPromiseCapability = newPromiseCapabilityModule.f;
  var newGenericPromiseCapability = newPromiseCapability;
  var IS_NODE = classof(process) == 'process';
  var DISPATCH_EVENT = !!(document && document.createEvent && global.dispatchEvent);
  var UNHANDLED_REJECTION = 'unhandledrejection';
  var REJECTION_HANDLED = 'rejectionhandled';
  var PENDING = 0;
  var FULFILLED = 1;
  var REJECTED = 2;
  var HANDLED = 1;
  var UNHANDLED = 2;
  var Internal, OwnPromiseCapability, PromiseWrapper;
  var FORCED = isForced(PROMISE, function () {
    // correct subclassing with @@species support
    var promise = PromiseConstructor.resolve(1);
    var empty = function () {/* empty */};
    var FakePromise = (promise.constructor = {})[SPECIES] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return !((IS_NODE || typeof PromiseRejectionEvent == 'function') && (!IS_PURE || promise['finally']) && promise.then(empty) instanceof FakePromise
    // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // we can't detect it synchronously, so just check versions
    && v8.indexOf('6.6') !== 0 && userAgent.indexOf('Chrome/66') === -1);
  });
  var INCORRECT_ITERATION = FORCED || !checkCorrectnessOfIteration(function (iterable) {
    PromiseConstructor.all(iterable)['catch'](function () {/* empty */});
  });

  // helpers
  var isThenable = function (it) {
    var then;
    return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
  };
  var notify = function (promise, state, isReject) {
    if (state.notified) return;
    state.notified = true;
    var chain = state.reactions;
    microtask(function () {
      var value = state.value;
      var ok = state.state == FULFILLED;
      var i = 0;
      var run = function (reaction) {
        var handler = ok ? reaction.ok : reaction.fail;
        var resolve = reaction.resolve;
        var reject = reaction.reject;
        var domain = reaction.domain;
        var result, then, exited;
        try {
          if (handler) {
            if (!ok) {
              if (state.rejection === UNHANDLED) onHandleUnhandled(promise, state);
              state.rejection = HANDLED;
            }
            if (handler === true) result = value;else {
              if (domain) domain.enter();
              result = handler(value); // may throw
              if (domain) {
                domain.exit();
                exited = true;
              }
            }
            if (result === reaction.promise) {
              reject(TypeError('Promise-chain cycle'));
            } else if (then = isThenable(result)) {
              then.call(result, resolve, reject);
            } else resolve(result);
          } else reject(value);
        } catch (error) {
          if (domain && !exited) domain.exit();
          reject(error);
        }
      };
      while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
      state.reactions = [];
      state.notified = false;
      if (isReject && !state.rejection) onUnhandled(promise, state);
    });
  };
  var dispatchEvent = function (name, promise, reason) {
    var event, handler;
    if (DISPATCH_EVENT) {
      event = document.createEvent('Event');
      event.promise = promise;
      event.reason = reason;
      event.initEvent(name, false, true);
      global.dispatchEvent(event);
    } else event = {
      promise: promise,
      reason: reason
    };
    if (handler = global['on' + name]) handler(event);else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
  };
  var onUnhandled = function (promise, state) {
    task.call(global, function () {
      var value = state.value;
      var IS_UNHANDLED = isUnhandled(state);
      var result;
      if (IS_UNHANDLED) {
        result = perform(function () {
          if (IS_NODE) {
            process.emit('unhandledRejection', value, promise);
          } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
        });
        // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
        state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
        if (result.error) throw result.value;
      }
    });
  };
  var isUnhandled = function (state) {
    return state.rejection !== HANDLED && !state.parent;
  };
  var onHandleUnhandled = function (promise, state) {
    task.call(global, function () {
      if (IS_NODE) {
        process.emit('rejectionHandled', promise);
      } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
    });
  };
  var bind = function (fn, promise, state, unwrap) {
    return function (value) {
      fn(promise, state, value, unwrap);
    };
  };
  var internalReject = function (promise, state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    state.value = value;
    state.state = REJECTED;
    notify(promise, state, true);
  };
  var internalResolve = function (promise, state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    try {
      if (promise === value) throw TypeError("Promise can't be resolved itself");
      var then = isThenable(value);
      if (then) {
        microtask(function () {
          var wrapper = {
            done: false
          };
          try {
            then.call(value, bind(internalResolve, promise, wrapper, state), bind(internalReject, promise, wrapper, state));
          } catch (error) {
            internalReject(promise, wrapper, error, state);
          }
        });
      } else {
        state.value = value;
        state.state = FULFILLED;
        notify(promise, state, false);
      }
    } catch (error) {
      internalReject(promise, {
        done: false
      }, error, state);
    }
  };

  // constructor polyfill
  if (FORCED) {
    // 25.4.3.1 Promise(executor)
    PromiseConstructor = function Promise(executor) {
      anInstance(this, PromiseConstructor, PROMISE);
      aFunction(executor);
      Internal.call(this);
      var state = getInternalState(this);
      try {
        executor(bind(internalResolve, this, state), bind(internalReject, this, state));
      } catch (error) {
        internalReject(this, state, error);
      }
    };
    // eslint-disable-next-line no-unused-vars
    Internal = function Promise(executor) {
      setInternalState(this, {
        type: PROMISE,
        done: false,
        notified: false,
        parent: false,
        reactions: [],
        rejection: false,
        state: PENDING,
        value: undefined
      });
    };
    Internal.prototype = __webpack_require__(139)(PromiseConstructor.prototype, {
      // `Promise.prototype.then` method
      // https://tc39.github.io/ecma262/#sec-promise.prototype.then
      then: function then(onFulfilled, onRejected) {
        var state = getInternalPromiseState(this);
        var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
        reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
        reaction.fail = typeof onRejected == 'function' && onRejected;
        reaction.domain = IS_NODE ? process.domain : undefined;
        state.parent = true;
        state.reactions.push(reaction);
        if (state.state != PENDING) notify(this, state, false);
        return reaction.promise;
      },
      // `Promise.prototype.catch` method
      // https://tc39.github.io/ecma262/#sec-promise.prototype.catch
      'catch': function (onRejected) {
        return this.then(undefined, onRejected);
      }
    });
    OwnPromiseCapability = function () {
      var promise = new Internal();
      var state = getInternalState(promise);
      this.promise = promise;
      this.resolve = bind(internalResolve, promise, state);
      this.reject = bind(internalReject, promise, state);
    };
    newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
      return C === PromiseConstructor || C === PromiseWrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
    };

    // wrap fetch result
    if (!IS_PURE && typeof $fetch == 'function') $export({
      global: true,
      enumerable: true,
      forced: true
    }, {
      // eslint-disable-next-line no-unused-vars
      fetch: function fetch(input) {
        return promiseResolve(PromiseConstructor, $fetch.apply(global, arguments));
      }
    });
  }
  $export({
    global: true,
    wrap: true,
    forced: FORCED
  }, {
    Promise: PromiseConstructor
  });
  __webpack_require__(40)(PromiseConstructor, PROMISE, false, true);
  __webpack_require__(140)(PROMISE);
  PromiseWrapper = __webpack_require__(41)[PROMISE];

  // statics
  $export({
    target: PROMISE,
    stat: true,
    forced: FORCED
  }, {
    // `Promise.reject` method
    // https://tc39.github.io/ecma262/#sec-promise.reject
    reject: function reject(r) {
      var capability = newPromiseCapability(this);
      capability.reject.call(undefined, r);
      return capability.promise;
    }
  });
  $export({
    target: PROMISE,
    stat: true,
    forced: IS_PURE || FORCED
  }, {
    // `Promise.resolve` method
    // https://tc39.github.io/ecma262/#sec-promise.resolve
    resolve: function resolve(x) {
      return promiseResolve(IS_PURE && this === PromiseWrapper ? PromiseConstructor : this, x);
    }
  });
  $export({
    target: PROMISE,
    stat: true,
    forced: INCORRECT_ITERATION
  }, {
    // `Promise.all` method
    // https://tc39.github.io/ecma262/#sec-promise.all
    all: function all(iterable) {
      var C = this;
      var capability = newPromiseCapability(C);
      var resolve = capability.resolve;
      var reject = capability.reject;
      var result = perform(function () {
        var values = [];
        var counter = 0;
        var remaining = 1;
        iterate(iterable, function (promise) {
          var index = counter++;
          var alreadyCalled = false;
          values.push(undefined);
          remaining++;
          C.resolve(promise).then(function (value) {
            if (alreadyCalled) return;
            alreadyCalled = true;
            values[index] = value;
            --remaining || resolve(values);
          }, reject);
        });
        --remaining || resolve(values);
      });
      if (result.error) reject(result.value);
      return capability.promise;
    },
    // `Promise.race` method
    // https://tc39.github.io/ecma262/#sec-promise.race
    race: function race(iterable) {
      var C = this;
      var capability = newPromiseCapability(C);
      var reject = capability.reject;
      var result = perform(function () {
        iterate(iterable, function (promise) {
          C.resolve(promise).then(capability.resolve, reject);
        });
      });
      if (result.error) reject(result.value);
      return capability.promise;
    }
  });

  /***/
}), ( /* 130 */
/***/function (module, exports) {
  module.exports = function (it, Constructor, name) {
    if (!(it instanceof Constructor)) {
      throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
    }
    return it;
  };

  /***/
}), ( /* 131 */
/***/function (module, exports, __webpack_require__) {
  var anObject = __webpack_require__(6);
  var isArrayIteratorMethod = __webpack_require__(132);
  var toLength = __webpack_require__(29);
  var bind = __webpack_require__(39);
  var getIteratorMethod = __webpack_require__(133);
  var callWithSafeIterationClosing = __webpack_require__(134);
  var BREAK = {};
  var exports = module.exports = function (iterable, fn, that, ENTRIES, ITERATOR) {
    var boundFunction = bind(fn, that, ENTRIES ? 2 : 1);
    var iterator, iterFn, index, length, result, step;
    if (ITERATOR) {
      iterator = iterable;
    } else {
      iterFn = getIteratorMethod(iterable);
      if (typeof iterFn != 'function') throw TypeError('Target is not iterable');
      // optimisation for array iterators
      if (isArrayIteratorMethod(iterFn)) {
        for (index = 0, length = toLength(iterable.length); length > index; index++) {
          result = ENTRIES ? boundFunction(anObject(step = iterable[index])[0], step[1]) : boundFunction(iterable[index]);
          if (result === BREAK) return BREAK;
        }
        return;
      }
      iterator = iterFn.call(iterable);
    }
    while (!(step = iterator.next()).done) {
      if (callWithSafeIterationClosing(iterator, boundFunction, step.value, ENTRIES) === BREAK) return BREAK;
    }
  };
  exports.BREAK = BREAK;

  /***/
}), ( /* 132 */
/***/function (module, exports, __webpack_require__) {
  // check on default Array iterator
  var Iterators = __webpack_require__(15);
  var ITERATOR = __webpack_require__(1)('iterator');
  var ArrayPrototype = Array.prototype;
  module.exports = function (it) {
    return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
  };

  /***/
}), ( /* 133 */
/***/function (module, exports, __webpack_require__) {
  var classof = __webpack_require__(61);
  var ITERATOR = __webpack_require__(1)('iterator');
  var Iterators = __webpack_require__(15);
  module.exports = function (it) {
    if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
  };

  /***/
}), ( /* 134 */
/***/function (module, exports, __webpack_require__) {
  var anObject = __webpack_require__(6);

  // call something on iterator step with safe closing on error
  module.exports = function (iterator, fn, value, ENTRIES) {
    try {
      return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
      // 7.4.6 IteratorClose(iterator, completion)
    } catch (error) {
      var returnMethod = iterator['return'];
      if (returnMethod !== undefined) anObject(returnMethod.call(iterator));
      throw error;
    }
  };

  /***/
}), ( /* 135 */
/***/function (module, exports, __webpack_require__) {
  var ITERATOR = __webpack_require__(1)('iterator');
  var SAFE_CLOSING = false;
  try {
    var called = 0;
    var iteratorWithReturn = {
      next: function () {
        return {
          done: !!called++
        };
      },
      'return': function () {
        SAFE_CLOSING = true;
      }
    };
    iteratorWithReturn[ITERATOR] = function () {
      return this;
    };
    // eslint-disable-next-line no-throw-literal
    Array.from(iteratorWithReturn, function () {
      throw 2;
    });
  } catch (error) {/* empty */}
  module.exports = function (exec, SKIP_CLOSING) {
    if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
    var ITERATION_SUPPORT = false;
    try {
      var object = {};
      object[ITERATOR] = function () {
        return {
          next: function () {
            return {
              done: ITERATION_SUPPORT = true
            };
          }
        };
      };
      exec(object);
    } catch (error) {/* empty */}
    return ITERATION_SUPPORT;
  };

  /***/
}), ( /* 136 */
/***/function (module, exports, __webpack_require__) {
  var global = __webpack_require__(0);
  var getOwnPropertyDescriptor = __webpack_require__(34).f;
  var classof = __webpack_require__(11);
  var macrotask = __webpack_require__(66).set;
  var userAgent = __webpack_require__(67);
  var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
  var process = global.process;
  var Promise = global.Promise;
  var IS_NODE = classof(process) == 'process';
  // Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
  var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global, 'queueMicrotask');
  var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;
  var flush, head, last, notify, toggle, node, promise;

  // modern engines have queueMicrotask method
  if (!queueMicrotask) {
    flush = function () {
      var parent, fn;
      if (IS_NODE && (parent = process.domain)) parent.exit();
      while (head) {
        fn = head.fn;
        head = head.next;
        try {
          fn();
        } catch (error) {
          if (head) notify();else last = undefined;
          throw error;
        }
      }
      last = undefined;
      if (parent) parent.enter();
    };

    // Node.js
    if (IS_NODE) {
      notify = function () {
        process.nextTick(flush);
      };
      // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
    } else if (MutationObserver && !/(iPhone|iPod|iPad).*AppleWebKit/i.test(userAgent)) {
      toggle = true;
      node = document.createTextNode('');
      new MutationObserver(flush).observe(node, {
        characterData: true
      }); // eslint-disable-line no-new
      notify = function () {
        node.data = toggle = !toggle;
      };
      // environments with maybe non-completely correct, but existent Promise
    } else if (Promise && Promise.resolve) {
      // Promise.resolve without an argument throws an error in LG WebOS 2
      promise = Promise.resolve(undefined);
      notify = function () {
        promise.then(flush);
      };
      // for other environments - macrotask based on:
      // - setImmediate
      // - MessageChannel
      // - window.postMessag
      // - onreadystatechange
      // - setTimeout
    } else {
      notify = function () {
        // strange IE + webpack dev server bug - use .call(global)
        macrotask.call(global, flush);
      };
    }
  }
  module.exports = queueMicrotask || function (fn) {
    var task = {
      fn: fn,
      next: undefined
    };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    }
    last = task;
  };

  /***/
}), ( /* 137 */
/***/function (module, exports, __webpack_require__) {
  var global = __webpack_require__(0);
  module.exports = function (a, b) {
    var console = global.console;
    if (console && console.error) {
      arguments.length === 1 ? console.error(a) : console.error(a, b);
    }
  };

  /***/
}), ( /* 138 */
/***/function (module, exports) {
  module.exports = function (exec) {
    try {
      return {
        error: false,
        value: exec()
      };
    } catch (error) {
      return {
        error: true,
        value: error
      };
    }
  };

  /***/
}), ( /* 139 */
/***/function (module, exports, __webpack_require__) {
  var redefine = __webpack_require__(19);
  module.exports = function (target, src, options) {
    for (var key in src) redefine(target, key, src[key], options);
    return target;
  };

  /***/
}), ( /* 140 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var getBuiltIn = __webpack_require__(70);
  var definePropertyModule = __webpack_require__(14);
  var DESCRIPTORS = __webpack_require__(13);
  var SPECIES = __webpack_require__(1)('species');
  module.exports = function (CONSTRUCTOR_NAME) {
    var C = getBuiltIn(CONSTRUCTOR_NAME);
    var defineProperty = definePropertyModule.f;
    if (DESCRIPTORS && C && !C[SPECIES]) defineProperty(C, SPECIES, {
      configurable: true,
      get: function () {
        return this;
      }
    });
  };

  /***/
}), ( /* 141 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var getBuiltIn = __webpack_require__(70);
  var speciesConstructor = __webpack_require__(65);
  var promiseResolve = __webpack_require__(68);

  // `Promise.prototype.finally` method
  // https://tc39.github.io/ecma262/#sec-promise.prototype.finally
  __webpack_require__(12)({
    target: 'Promise',
    proto: true,
    real: true
  }, {
    'finally': function (onFinally) {
      var C = speciesConstructor(this, getBuiltIn('Promise'));
      var isFunction = typeof onFinally == 'function';
      return this.then(isFunction ? function (x) {
        return promiseResolve(C, onFinally()).then(function () {
          return x;
        });
      } : onFinally, isFunction ? function (e) {
        return promiseResolve(C, onFinally()).then(function () {
          throw e;
        });
      } : onFinally);
    }
  });

  /***/
}
/******/)]);